export default {
  "brandSeo": {
    "pageTitle": "{title} con Miral AI",
    "toolDescription": "En Miral AI, {description}",
    "sectionTitle": "{title} con Miral AI",
    "faqTitle": "{title} en Miral AI",
    "toolFreeTrialCta": "Probar esta herramienta gratis en Miral AI",
    "toolProcessCta": "{action} gratis",
    "imageFaqs": [
      { "q": "¿Puedo probar gratis la generación de imágenes en Miral?", "a": "Sí. Regístrate en Miral AI para recibir créditos gratis y probar la generación. Cada resultado seguirá usando los créditos requeridos por el modelo elegido." },
      { "q": "¿Por qué crear imágenes con Miral AI?", "a": "Miral AI reúne modelos de imagen líderes en un solo lugar para comparar funciones y seguir creando sin cambiar entre varias plataformas." }
    ],
    "toolFaqs": [
      { "q": "¿Puedo probar gratis esta herramienta de Miral AI?", "a": "Sí. Inicia sesión en Miral AI para comenzar una prueba gratis. El acceso depende de los límites de la cuenta y no implica uso gratuito ilimitado." },
      { "q": "¿Por qué usar las herramientas creativas de Miral AI?", "a": "Miral AI combina generación de imágenes y herramientas prácticas de edición para crear, procesar y descargar resultados en un mismo flujo." }
    ]
  },
  "common": {
    "loading": "Cargando...",
    "error": "Ocurrió un error",
    "success": "Éxito",
    "confirm": "OK",
    "prev": "Anterior",
    "next": "Siguiente",
    "optional": "Opcional",
    "remove": "Eliminar",
    "generate": "Generar",
    "generating": "Generando...",
    "required": "Obligatorio",
    "generateFailedContactSupport": "La generación falló. ¡Inténtalo de nuevo o contacta con soporte!",
    "localMediaTransferFailed": "Inestabilidad de red: se interrumpió la transferencia o la interacción con el servicio. El proceso de generación se detuvo. Vuelve a generar o contacta con soporte.",
    "errorDetails": "Detalles del error",
    "tryAgainOrContactSupportTail": " Por favor, inténtalo de nuevo o contacta con soporte!",
    "errorCategoryImageSizeInvalid": "El tamaño de la imagen no cumple los requisitos. Por favor, utiliza una imagen válida",
    "errorCategoryOutputEmptyOrSensitive": "La salida fue bloqueada por reglas de seguridad o no se generó ningún resultado. Por favor, ajusta tu mensaje/imagen de referencia",
    "errorCategoryUpstreamBusy": "El servicio está ocupado ahora mismo",
    "errorCategoryAiNetworkError": "Conexión de red inestable. Revisa tu red e inténtalo de nuevo",
    "errorCategoryAiTimeout": "La solicitud de AI ha superado el tiempo de espera. La red puede estar inestable, inténtalo de nuevo en breve",
    "close": "Cerrar",
    "leaveConfirmTitle": "Recordatorio Amistoso",
    "leaveConfirmMessage": "Tu trabajo de AI todavía está siendo generado. Cambiar de página no afectará el progreso. Puedes verificar el procesamiento o trabajos completados en [Mi - Mis Trabajos].\n¿Estás seguro de que quieres salir?",
    "leaveConfirmConfirm": "Salir de la Página",
    "leaveConfirmCancel": "Quedarse Aquí"
  },
  "api": {
    "errors": {
      "requestFailed": "Solicitud fallida",
      "badRequest": "Solicitud incorrecta",
      "unauthorized": "No autorizado, inicie sesión nuevamente",
      "forbidden": "Prohibido",
      "notFound": "Recurso no encontrado",
      "serverError": "Error interno del servidor",
      "timeout": "Tiempo de espera de la solicitud, inténtelo de nuevo",
      "networkError": "Error de red, verifique su conexión",
      "sessionExpired": "Sesión expirada, inicie sesión nuevamente",
      "operationFailed": "¡Operación fallida!"
    }
  },
  "nav": {
    "home": "Inicio",
    "models": "Modelos de IA",
    "pricing": "Precios",
    "faq": "Preguntas Frecuentes",
    "login": "Iniciar Sesión",
    "signup": "Actualizar",
    "register": "Registrarse",
    "email": "Correo Electrónico",
    "logout": "Cerrar Sesión",
    "help": "Ayuda",
    "profile": "Perfil",
    "myWorks": "Mis Trabajos",
    "username": "Nombre de Usuario",
    "password": "Contraseña",
    "confirmPassword": "Confirmar Contraseña",
    "processing": "Procesando...",
    "haveAccount": "¿Ya tienes una cuenta?",
    "noAccount": "¿No tienes una cuenta?",
    "orContinueWith": "O continuar con",
    "loginFailed": "Error en el inicio de sesión, inténtelo de nuevo",
    "registerFailed": "Error en el registro, inténtelo de nuevo",
    "fillRequired": "Complete todos los campos obligatorios",
    "passwordMismatch": "Las contraseñas no coinciden",
    "passwordTooShort": "La contraseña debe tener al menos 6 caracteres",
    "googleNotLoaded": "Servicio de inicio de sesión de Google no cargado, actualice la página",
    "googleInitFailed": "Error en la inicialización del inicio de sesión de Google",
    "googleUserInfoFailed": "No se puede obtener la información del usuario",
    "googleCancelled": "Inicio de sesión de Google cancelado",
    "codeLoginHint": "Ingrese su correo electrónico, le enviaremos un código de verificación",
    "verificationCode": "Código de Verificación",
    "sendCode": "Enviar Código",
    "resendCode": "Reenviar",
    "verifyAndLogin": "Verificar e Iniciar Sesión",
    "enterEmail": "Ingrese su dirección de correo electrónico",
    "invalidEmail": "Ingrese una dirección de correo electrónico válida",
    "sendCodeFailed": "Error al enviar el código de verificación, inténtelo de nuevo",
    "checkSpamFolder": "¿No encuentras el correo? Revisa tu carpeta de spam/correo no deseado",
    "enterValidCode": "Ingrese el código de verificación de 6 dígitos",
    "verifyCodeFailed": "Código de verificación inválido o expirado",
    "googleLoginFailed": "Error en el inicio de sesión de Google, inténtelo de nuevo",
    "registerHint": "Al registrarse, acepta nuestros",
    "and": "y",
    "freeCreditsLabel": "Créditos gratuitos:",
    "freeCreditsDesc": "¡Obtén créditos gratis solo iniciando sesión — sin pago requerido!",
    "sidebar": {
      "navigation": "Navegación",
      "home": "Inicio",
      "inspiration": "Inspiración",
      "allModels": "Todos los Modelos de IA",
      "videoAI": "Video de IA",
      "videoGenerator": "Generador de Video",
      "newModels": "Nuevos Modelos",
      "otherModels": "Otros Modelos",
      "videoEnhance": "Mejora de Video",
      "musicAI": "Música de IA",
      "musicGenerator": "Música de IA",
      "imageAI": "Imagen de IA",
      "imageGenerator": "Generador de Imágenes",
      "hotModels": "Modelos Populares",
      "hotTools": "Herramientas Populares",
      "history": "Historial",
      "upgrade": "Actualizar"
    }
  },
  "about": {
    "tag": "About Miral",
    "title": "About Us",
    "subtitle": "Create images, videos, and music with leading AI models in one place.",
    "paragraphs": [
      "Miral is an AI creation platform for creators, designers, and businesses. Generate images and videos, compose AI music, and use practical tools such as watermark removal and document cleanup.",
      "We continuously integrate leading models and reliable channels so you can go from idea to finished content in the browser.",
      "Learn more about our data practices on Trust & Safety, or contact support when you need help."
    ]
  },
  "contact": {
    "tag": "Support",
    "title": "Contact Us",
    "subtitle": "We will get back to your questions and feedback as soon as we can.",
    "emailLabel": "Support email",
    "hint": "Email us about billing, credits, or generation issues. We usually reply on business days.",
    "cta": "Send Email"
  },
  "models": {
    "image": {
      "nano-banana": {
        "name": "Nano Banana Pro",
        "desc": "Realismo cinematográfico con detalles naturales de piel, textura e iluminación"
      },
      "nano-banana-31": {
        "name": "Nano Banana 3.1",
        "desc": "Generación de imágenes multiresolución, modos v2.5 y v3.1"
      },
      "seedream-4": {
        "name": "Seedream 4",
        "desc": "Artistic Style"
      },
      "seedream-5": {
        "name": "Seedream 5",
        "desc": "Artistic Style"
      },
      "midjourney": {
        "name": "Midjourney",
        "desc": "Artistic Style"
      },
      "gpt-image-1": {
        "name": "GPT-Image-1",
        "desc": "Multi-purpose"
      },
      "gpt-image-1-5": {
        "name": "GPT-Image-1-5",
        "desc": "Multi-purpose"
      },
      "flux-pro-1-1-ultra": {
        "name": "Flux Pro 1.1 Ultra",
        "desc": "High-quality text-to-image"
      },
      "flux-schnell": {
        "name": "Flux Schnell",
        "desc": "Fast text-to-image"
      },
      "flux-2": {
        "name": "FLUX.2",
        "desc": "Texto a imagen de nueva generación"
      },
      "flux-kontext": {
        "name": "Flux Kontext",
        "desc": "High-quality text-to-image & editing"
      },
      "qwen-image-2-0-pro": {
        "name": "Qwen Image 2.0 Pro",
        "desc": "Generación de alta resolución con detalles finos"
      },
      "z-image-turbo": {
        "name": "Z Image Turbo",
        "desc": "Generación de alta resolución de texto a imagen"
      },
      "sd-3-5": {
        "name": "Stable Diffusion 3.5",
        "desc": "Generación de texto a imagen con Stable Diffusion 3.5"
      }
    },
    "video": {
      "pollodance": {
        "name": "Pollo Dance",
        "desc": "Control de movimiento, referencias y estilo cinematográfico"
      },
      "seegen": {
        "name": "SeeGen",
        "desc": "Texto e imagen a vídeo, multiresolución"
      },
      "seedance": {
        "name": "Seedance AI",
        "desc": "Native Audio-Visual Sync"
      },
      "wan-2-5": {
        "name": "Wan 2.5",
        "desc": "Animation Style"
      },
      "wan-2-6": {
        "name": "Wan 2.6",
        "desc": "Enhanced Quality"
      },
      "veo-3-1": {
        "name": "Veo 3.1",
        "desc": "Multi-image Reference"
      },
      "veo-3-1-fast": {
        "name": "Veo 3.1 Fast",
        "desc": "Fast, supports tail frame"
      },
      "kling-2-6": {
        "name": "Kling 2.6",
        "desc": "Lip Sync"
      },
      "kling-3": {
        "name": "Kling 3",
        "desc": "Lip Sync"
      },
      "sora-2": {
        "name": "Sora 2",
        "desc": "4 s / 8 s / 12 s"
      },
      "kling-2-5": {
        "name": "Kling 2.5",
        "desc": "Standard"
      },
      "wan-2-2": {
        "name": "Wan 2.2",
        "desc": "Classic"
      },
      "vidu-q3-pro": {
        "name": "Vidu Q3 Pro",
        "desc": "Texto/imagen a video, multi-resolución"
      },
      "veo-3-0": {
        "name": "Veo 3.0",
        "desc": "Text/Image to Video"
      },
      "hailuo-2-3": {
        "name": "Hailuo 2.3",
        "desc": "Creative Video"
      },
      "runway": {
        "name": "Runway",
        "desc": "Workbench"
      },
      "wan-animate": {
        "name": "Wan Animate",
        "desc": "Imagen y vídeo de referencia para animar personajes. Calidad estándar/pro, marca de agua opcional."
      }
    }
  },
  "footer": {
    "brand": "Miral",
    "siteTitle": "Miral - Plataforma de creación de imágenes, videos y música con IA",
    "desc": "Una plataforma integral de IA para creación de imágenes, videos y música.",
    "fluxModels": "Modelos FLUX",
    "aiImages": "Imágenes de IA",
    "aiVideos": "Videos de IA",
    "aiMusic": "Música de IA",
    "product": "Producto",
    "videoModels": "Modelos de video IA",
    "imageModels": "Modelos de imagen IA",
    "musicModels": "Modelos de música IA",
    "apps": "Apps",
    "company": "Empresa",
    "about": "Sobre nosotros",
    "contact": "Contáctanos",
    "blog": "Blog",
    "tools": "Herramientas",
    "resources": "Recursos",
    "allModels": "Todos los Modelos de IA",
    "pricing": "Precios",
    "trustSafety": "Confianza y Seguridad",
    "terms": "Términos de Servicio",
    "privacy": "Política de Privacidad",
    "faq": "Preguntas Frecuentes",
    "musicGenerator": "Generador de Música IA",
    "copyright": "© 2025 Miral. Todos los derechos reservados.",
    "langZh": "简体中文",
    "langEn": "English"
  },
  "home": {
    "generate": "Generar",
    "chatDisabledGenerateHint": "Introduce un prompt",
    "compactChatPlaceholder": "Introduce tu prompt para generar increíbles imágenes y vídeos con IA y música original",
    "hero": {
      "title": "Miral – Creador todo en uno de imágenes, vídeos y música con IA",
      "subtitle": "Impulsado por modelos de IA versátiles, Miral reúne edición de imágenes, generación de vídeo y creación de música con IA. Edita fotos, crea vídeos de retratos cinematográficos y música de fondo personalizada para proyectos personales y comerciales.",
      "createVideo": "Crear Video",
      "createImage": "Crear Imagen"
    },
    "stats": {
      "models": "Modelos de IA Principales",
      "works": "Trabajos Generados",
      "tools": "Herramientas Profesionales",
      "platforms": "Plataformas Asociadas"
    },
    "generatorNew": {
      "promptPlaceholder": "Describe el video que quieres generar...",
      "promptPlaceholderImage": "Describe la imagen que quieres generar...",
      "generating": "Generando...",
      "noHistory": "Los resultados aparecerán aquí",
      "generationFailed": "Generación fallida",
      "historyTitle": "Historial",
      "myAssets": "Mis activos"
    },
    "quickTools": {
      "title": "Herramientas rápidas de IA"
    },
    "exploreMore": {
      "title": "Explorar más funciones de IA"
    },
    "platform": {
      "tag": "Plataforma",
      "title": "Caja de Herramientas IA que Hace Simple la Creación",
      "subtitle": "Generación de imágenes todo-en-uno, creación de video, producción musical y herramientas profesionales potenciadas por modelos de IA líderes en la industria.",
      "tabs": {
        "image": "Imágenes IA",
        "video": "Videos IA",
        "music": "Música IA",
        "tools": "Caja de Herramientas IA"
      },
      "image": {
        "title": "Genera y Edita Imágenes Impresionantes con los Mejores Modelos Globales de IA",
        "desc": "Texto a imagen, edición de precisión, transferencia de estilo y escalado HD. Potenciado por FLUX, Midjourney, Seedream, GPT-Image-1 y Nano Banana.",
        "explore": "Explorar Modelos de Imagen →"
      },
      "video": {
        "title": "Crea Videos Cinematográficos con IA",
        "desc": "De texto a video hasta animación de imagen, potenciado por modelos Veo, Sora, Kling, Seedance y Wan. Genera videos con audio sincronizado y trabajo de cámara profesional.",
        "explore": "Explorar Modelos de Video →"
      },
      "music": {
        "title": "Creación de Música Original Potenciada por IA",
        "desc": "Genera música original a partir de descripciones, soportando varios estilos y duraciones. Perfecto para bandas sonoras de video, música de fondo de podcasts y más.",
        "explore": "Explorar Música IA →"
      },
      "tools": {
        "title": "Caja de Herramientas IA Profesional",
        "desc": "Eliminación de marcas de agua, restauración de fotos, escalado HD, mejora de video y más herramientas profesionales para todas tus necesidades de postproducción",
        "explore": "Ver Todas las Herramientas →"
      }
    },
    "models": {
      "tag": "Modelos",
      "title": "Integración en Un Solo Lugar de los Mejores Modelos de IA Globales",
      "subtitle": "Una plataforma integrando todos los modelos principales de IA. No más cambios entre múltiples cuentas y suscripciones.",
      "imageModels": "Modelos de Imagen",
      "videoModels": "Modelos de Video",
      "musicModels": "Música IA",
      "musicDesc": "Genera música original a partir de descripciones",
      "filterAll": "Todos",
      "credits": "Créditos",
      "viewAll": "Ver Todos →"
    },
    "features": {
      "tag": "Características Principales",
      "title": "Crea Imágenes, Videos y Música Impresionantes",
      "subtitle": "De texto a imagen, texto a video hasta creación de música IA, más edición de precisión y escalado HD — creación todo-en-uno.",
      "items": {
        "textToImage": {
          "tag": "Texto a Imagen",
          "title": "Texto a Imagen",
          "desc": "Ingresa una descripción, presencia la magia. Ya sean retratos hiperrealistas o paisajes de fantasía, usa Midjourney, Seedream, Nano Banana y otros modelos para generar obras maestras visuales con simples comandos.",
          "cta": "Generación de Imagen",
          "imageAlt": "Genera obras maestras visuales con prompts simples usando Midjourney, Seedream, Nano Banana y otros modelos"
        },
        "imageEdit": {
          "tag": "Edición de Imagen y Transferencia de Estilo",
          "title": "Edición de Imagen y Transferencia de Estilo",
          "desc": "Usa IA para remodelar imágenes con precisión. Ya sea cambiando estilos, modificando objetos, reemplazando fondos o editando texto, todo con alta consistencia.",
          "cta": "Edición de Imagen",
          "beforeAlt": "Antes de la edición de imagen y transferencia de estilo",
          "afterAlt": "Después de la edición de imagen y transferencia de estilo"
        },
        "textToVideo": {
          "tag": "Texto a Video",
          "title": "Texto a Video",
          "desc": "Solo ingresa comandos para generar videos cinematográficos con audio sincronizado, trabajo de cámara profesional y movimiento realista. Elige entre modelos Veo, Sora, Kling, Seedance y Wan.",
          "cta": "Generación de Video"
        },
        "imageToVideo": {
          "tag": "Imagen a Video",
          "title": "Imagen a Video",
          "desc": "Convierte imágenes estáticas en videos cinematográficos. Ya sean fotos de producto, ilustraciones o imágenes generadas por IA, dales vida con movimiento natural y doblaje.",
          "cta": "Animación de Imagen"
        },
        "upscale": {
          "tag": "Escalado HD",
          "title": "Escalado HD",
          "desc": "Usa IA para mejorar la calidad de imagen y video. Soporta escalado HD sin pérdida y mejora la resolución de video a nivel profesional 4K.",
          "cta": "Escalar Ahora",
          "imageAlt": "Mejora la calidad de imagen y video con IA"
        },
        "templates": {
          "tag": "40+ Plantillas de Imagen",
          "title": "40+ Plantillas de Imagen",
          "desc": "Plantillas masivas para inspirar creatividad: modelos 3D, estilo Ghibli, juguetes de diseñador, generador de memes, portadas de revistas y más — sube una foto, resultados instantáneos.",
          "cta": "Explorar Plantillas",
          "imageAlt": "Ejemplo de plantilla de imagen"
        }
      }
    },
    "gallery": {
      "tag": "Galería",
      "title": "Explora Posibilidades Infinitas",
      "subtitle": "Mira lo que los creadores están construyendo con Miral — desde imágenes hiperrealistas hasta videos cinematográficos, inspiración a tu alcance.",
      "images": {
        "alt1": "Ejemplo de imagen generada por Midjourney",
        "alt2": "Ejemplo de imagen generada por Seedream",
        "alt3": "Ejemplo de imagen generada por GPT-Image-1",
        "alt4": "Ejemplo de imagen generada por Flux",
        "alt5": "Ejemplo de imagen generada por Flux Pro",
        "alt6": "Ejemplo de imagen generada por Midjourney",
        "alt7": "Ejemplo de imagen generada por Seedream",
        "alt8": "Ejemplo de imagen generada por GPT-Image-1"
      }
    },
    "whyChoose": {
      "tag": "Por Qué Elegir Miral",
      "title": "Creación Todo-en-Uno, Todo Lo Que Necesitas",
      "subtitle": "Plataforma integral que reúne los mejores modelos del mundo de IA para imagen, video y creación musical.",
      "items": {
        "allModels": {
          "title": "Todos los Modelos Integrados, Uno es Suficiente",
          "desc": "Acceso de un solo clic a 29+ modelos de IA principales de OpenAI, Google, Alibaba, ByteDance y más. No necesitas cambiar entre herramientas ni gestionar múltiples suscripciones."
        },
        "fast": {
          "title": "Ultrarrápido",
          "desc": "La mayor parte de la generación de imágenes se completa en 30 segundos, la generación de video toma aproximadamente 1-6 minutos. Infraestructura optimizada asegura esperas mínimas."
        },
        "credits": {
          "title": "Sistema de Créditos Simple",
          "desc": "Paga por uso, precios transparentes. Comienza con créditos gratuitos — no se necesita suscripción para comenzar a crear."
        },
        "api": {
          "title": "API para Desarrolladores",
          "desc": "Integra generación de imagen, video y música IA directamente en tus aplicaciones a través de nuestra API completa. Construye tu producto sobre modelos de IA principales."
        }
      }
    },
    "testimonials": {
      "tag": "Historias de Usuarios",
      "title": "Confiado por Creadores en Todo el Mundo",
      "subtitle": "Únete a miles de profesionales y creadores que usan Miral para generar imágenes, crear videos y potenciar sus flujos de trabajo creativos."
    },
    "faq": {
      "tag": "Soporte",
      "title": "Preguntas Frecuentes",
      "subtitle": "Una guía completa de la plataforma, modelos compatibles, planes de precios y características."
    },
    "cta": {
      "title": "Comienza Tu Viaje de Creación IA Ahora",
      "subtitle": "Únete a miles de creadores, diseñadores y empresas que usan Miral para realizar su creatividad con los mejores modelos de IA del mundo.",
      "createImage": "Crear Imagen →",
      "createVideo": "Crear Video →",
      "note": "Los nuevos usuarios obtienen créditos gratuitos al registrarse. No se requiere tarjeta de crédito."
    },
    "apps": {
      "title": "Aplicaciones",
      "quickTitle": "Aplicaciones rápidas de IA",
      "more": "Más",
      "keywords": {
        "viralVideo": "Vídeo viral",
        "tiktokAds": "Anuncios TikTok",
        "productShowcase": "Showcase de producto",
        "aiAvatar": "Avatar IA",
        "homeModernKitchen": "Cocina moderna"
      },
      "social": "Redes Sociales",
      "posters": "Pósters",
      "interior": "Hogar",
      "entertainment": "Entretenimiento",
      "lifestyle": "Estilo de Vida",
      "comic": "Cómic",
      "items": {
        "viralVideo": "Videos Virales",
        "celebrityVideo": "Video de Celebridad",
        "productShowcase": "Escaparate de Producto",
        "tiktokAds": "Anuncio TikTok",
        "aiMeme": "Meme IA",
        "aiAvatar": "Avatar IA",
        "logoAnimation": "Animación de Logo",
        "socialShorts": "Shorts Sociales",
        "brandStory": "Historia de Marca",
        "tutorialClip": "Tutorial",
        "musicVideo": "Video Musical IA",
        "animeScene": "Escena Anime",
        "movieTrailer": "Tráiler de Película",
        "gameCinematic": "Cinemática de Juego",
        "visualPoetry": "Poesía Visual",
        "natureDoc": "Documental de Naturaleza",
        "cyberpunkCity": "Ciudad Cyberpunk",
        "underwaterWorld": "Mundo Submarino",
        "timelapseArt": "Arte Timelapse",
        "dailyVlog": "Vlogs Diarios",
        "cookingShow": "Programa de Cocina",
        "fitnessCoach": "Coach de Fitness",
        "travelDiary": "Diario de Viaje",
        "fashionShow": "Desfile de Moda",
        "petParadise": "Paraíso Pet",
        "weddingMoment": "Momento de Boda",
        "yogaFlow": "Flujo Yoga",
        "homeDecor": "Decoración del Hogar",
        "sunsetRun": "Carrera al Atardecer",
        "instagramReels": "Instagram Reels",
        "youtubeIntro": "Intro YouTube",
        "linkedinPromo": "Promo LinkedIn",
        "aiThumbnail": "Miniatura IA",
        "podcastClip": "Clip Podcast",
        "horrorShort": "Corto de Terror",
        "danceVideo": "Video de Baile",
        "aiComic": "Cómic IA",
        "magicShow": "Espectáculo de Magia",
        "fantasyWorld": "Mundo Fantástico",
        "diyCraft": "Manualidades DIY",
        "morningRoutine": "Rutina Matutina",
        "babyGrowth": "Crecimiento del Bebé",
        "streetFood": "Comida Callejera",
        "bookTrailer": "Tráiler de Libro",
        "socialLuxuryBag": "Drop de Bolso de Lujo",
        "socialFashionVote": "Voto de Moda",
        "socialSneakerDrop": "Zapatillas Urbanas Premium",
        "socialTropicalCocktail": "Cóctel de Fin de Semana",
        "socialCityBillboard": "Anuncio en Valla Urbana",
        "socialStreetwearDrop": "Drop Streetwear",
        "socialBoxingGloves": "Anuncio de Guantes de Boxeo",
        "homeEclecticLiving": "Salón Ecléctico",
        "homeFarmhouseKitchen": "Cocina de Granja",
        "homeModernKitchen": "Cocina Moderna Minimalista",
        "homeVictorianStairs": "Escalera Victoriana",
        "homeScandiLiving": "Salón Escandinavo",
        "homeMediterraneanPatio": "Patio Mediterráneo",
        "homeBohoSunroom": "Invernadero Bohemio",
        "homeEclecticBedroom": "Dormitorio Ecléctico",
        "comicPortrait": "Cómic de Superhéroe",
        "animeCharacter": "Anime Méca",
        "mangaScene": "Manga Noche Lluviosa",
        "comicOilPainting": "Cómic Cotidiano",
        "comicCover": "Cómic Héroe de Energía",
        "animePortrait": "Cómic Salto entre Tejados",
        "comicCouple": "Cómic Joven Héroe",
        "mangaWarrior": "Cómic Hechicero"
      }
    }
  },
  "pricing": {
    "title": "Inspiración Ilimitada, Elige el Plan que Mejor se Adapte a Ti",
    "subtitle": "Desbloquea todos los modelos de IA, genera imágenes, videos y música por lotes.",
    "promo": "Oferta por Tiempo Limitado — Ahorra 30% en Planes Anuales",
    "monthly": "Mensual",
    "yearly": "Anual",
    "yearlyNote": "Plan anual — créditos entregados de una vez, pago único más económico",
    "popular": "Más Popular",
    "currentPlan": "Plan Actual",
    "currentPlanBtn": "Plan Actual",
    "upgrade": "Actualizar",
    "unavailable": "No Disponible",
    "upgradeSuccess": "¡Actualización exitosa!",
    "upgradeFailed": "Actualización fallida",
    "upgradeModal": {
      "title": "Confirmar actualización",
      "item1": "Cargaremos la diferencia de precio a tu tarjeta.",
      "item2": "Después de que el pago tenga éxito, el saldo extra se agregará automáticamente.",
      "item3": "El nuevo plan entra en vigor después de que el pago tenga éxito.",
      "tip": "Consejo: Asegúrate de que tu método de pago sea válido. El saldo se actualiza en segundos después del pago.",
      "cancel": "Cancelar",
      "confirm": "Confirmar actualización"
    },
    "subscribe": "Suscribirse Ahora",
    "processing": "Procesando...",
    "creditsPer": "créditos /",
    "extraCredits": "créditos extra",
    "creditsRate": "100 créditos = $",
    "perMonth": "mes",
    "perYear": "año",
    "yearlyBilling": "Facturado anualmente",
    "saveVsMonthly": "Ahorro vs mensual:",
    "planDesc": {
      "basic": "Perfecto para comenzar",
      "pro": "Mejor para creadores y profesionales",
      "ultimate": "Para equipos y usuarios avanzados"
    },
    "creditsPack": {
      "title": "Comprar Paquete de Créditos",
      "subtitle": "Compra única, sin suscripción",
      "buy": "Comprar Créditos",
      "oneTime": "Compra única",
      "permanent": "Los créditos nunca expiran",
      "tip": "Consejo: Las suscripciones son mejor valor",
      "tipItems": [
        "Tasas de crédito más bajas (ahorra 40-60%)",
        "15% de descuento en todos los paquetes de crédito"
      ]
    },
    "security": {
      "noTraining": "No usado para entrenamiento IA",
      "encrypted": "Almacenamiento encriptado",
      "gdpr": "Cumple GDPR",
      "delete": "Eliminación de cuenta autogestionada"
    },
    "dataSafety": "Conoce sobre nuestro compromiso de seguridad de datos →",
    "allPlansInclude": "Todos los Planes Incluyen",
    "includes": {
      "models": "Modelos de IA Premium",
      "fast": "Generación Rápida",
      "privacy": "100% Privacidad",
      "commercial": "Uso Comercial"
    },
    "creditsInfo": {
      "title": "Guía de Créditos",
      "subtitle": "Vista el consumo de créditos de todos los modelos",
      "model": "Modelo",
      "type": "Tipo",
      "cost": "Costo de Crédito",
      "speed": "Velocidad",
      "image": "Imagen",
      "video": "Video"
    },
    "questions": "¿Preguntas?",
    "contact": "¿Necesitas ayuda?",
    "contactUs": "Contáctanos",
    "faq": {
      "items": [
        {
          "q": "¿Qué puedo crear con créditos?",
          "a": "Los créditos pueden usarse para generar imágenes, videos y música IA. La generación de imágenes comienza desde 2 créditos, la generación de video desde 10 créditos y la música desde 10 créditos por pista. Los modelos premium pueden consumir más créditos."
        },
        {
          "q": "¿Puedo cancelar en cualquier momento?",
          "a": "Sí, puedes cancelar tu suscripción en cualquier momento. Puedes continuar usando el servicio hasta el final de tu período de facturación actual."
        },
        {
          "q": "¿Qué pasa si me quedo sin créditos?",
          "a": "Puedes comprar paquetes de crédito de un solo uso en cualquier momento (no se necesita suscripción). Los suscriptores obtienen 15% de descuento en paquetes de crédito. También puedes actualizar tu plan para obtener mejores tasas en cuotas mensuales."
        },
        {
          "q": "¿Hay una política de reembolso?",
          "a": "Sí. Para primeras compras de paquetes únicos o primeras suscripciones, puedes solicitar un reembolso dentro de 7 días calendario si el uso de créditos es inferior al 3%."
        }
      ]
    },
    "basic": {
      "name": "Básico",
      "features": [
        "Todos los créditos entregados de una vez",
        "Genera hasta 2,600 imágenes AI",
        "Genera 520 videos AI",
        "Genera hasta 480 pistas de música AI",
        "Sin marcas de agua",
        "Licencia comercial"
      ]
    },
    "pro": {
      "name": "Pro",
      "features": [
        "Todos los créditos entregados de una vez",
        "Genera hasta 10,600 imágenes AI",
        "Genera hasta 2,120 videos AI",
        "Genera hasta 1,920 pistas de música AI",
        "Todos los modelos premium",
        "Cola prioritaria",
        "Soporte prioritario",
        "Modo de privacidad y cumplimiento DPA"
      ]
    },
    "ultimate": {
      "name": "Último",
      "features": [
        "Todos los créditos entregados de una vez",
        "Genera hasta 36,600 imágenes AI",
        "Genera hasta 7,320 videos AI",
        "Genera hasta 6,720 pistas de música AI",
        "Todos los modelos premium",
        "Soporte dedicado",
        "Modo de privacidad y cumplimiento DPA"
      ]
    }
  },
  "generate": {
    "title": "Generar",
    "prompt": "Prompt",
    "promptPlaceholder": "Describe lo que quieres crear...",
    "negativePrompt": "Prompt Negativo",
    "negativePromptPlaceholder": "Describe lo que no quieres...",
    "settings": "Configuración",
    "aspectRatio": "Relación de Aspecto",
    "style": "Estilo",
    "quality": "Calidad",
    "generate": "Generar",
    "generating": "Generando...",
    "download": "Descargar",
    "share": "Compartir",
    "history": "Historial",
    "clearHistory": "Limpiar Historial",
    "noHistory": "No hay historial aún",
    "startCreating": "Comienza a Crear",
    "advanced": "Avanzado",
    "basic": "Básico",
    "seed": "Semilla",
    "randomSeed": "Semilla Aleatoria",
    "steps": "Pasos",
    "guidance": "Guía",
    "batchSize": "Tamaño de Lote",
    "variations": "Variaciones"
  },
  "image": {
    "title": "Generación de Imagen",
    "width": "Ancho",
    "height": "Alto",
    "commonRatios": "Relaciones Comunes",
    "custom": "Personalizado",
    "styles": {
      "realistic": "Realista",
      "artistic": "Artístico",
      "anime": "Anime",
      "cartoon": "Dibujos Animados",
      "sketch": "Boceto",
      "oilPainting": "Pintura al Óleo",
      "watercolor": "Acuarela",
      "digital": "Digital"
    },
    "quality": {
      "standard": "Estándar",
      "high": "Alta",
      "ultra": "Ultra"
    }
  },
  "video": {
    "title": "Generación de Video",
    "duration": "Duración",
    "fps": "FPS",
    "motion": "Movimiento",
    "styles": {
      "cinematic": "Cinemático",
      "animation": "Animación",
      "documentary": "Documental",
      "commercial": "Comercial",
      "musicVideo": "Video Musical"
    }
  },
  "music": {
    "breadcrumb": {
      "home": "Inicio",
      "aiMusic": "Música IA"
    },
    "model": {
      "label": "Modelo",
      "aiMusicName": "Música IA",
      "desc": "Genera música original a partir de descripciones, soportando varios estilos y duraciones.",
      "tagMusic": "Generación de Música",
      "tagLyrics": "Creación de Letras"
    },
    "mode": {
      "describe": "Describir",
      "lyrics": "Escribir Letras"
    },
    "form": {
      "musicDesc": "Descripción de Música",
      "musicDescPlaceholder": "Describe el estilo musical, emoción y escena que deseas...\n\nEjemplo: Una música electrónica animada con melodías de sintetizador futuristas, adecuada para videos promocionales de productos tecnológicos",
      "optimize": "Optimizar",
      "songTitle": "Título de la Canción",
      "songTitlePlaceholder": "Ingresa el título de la canción...",
      "lyricsDescLabel": "Descripción de Letras",
      "lyricsDescPlaceholder": "Escribe tu descripción de letras aquí...\n\nEjemplo:\n[Intro]\n...\n[Verso]\n...\n[Coro]\n...",
      "styleTags": "Etiquetas de Estilo",
      "styleTagsPlaceholder": "Haz clic en las etiquetas de abajo para agregar (selección múltiple)"
    },
    "tags": {
      "sections": [
        {
          "label": "Verso",
          "value": "[Verse]\n"
        },
        {
          "label": "Coro",
          "value": "[Chorus]\n"
        },
        {
          "label": "Puente",
          "value": "[Bridge]\n"
        },
        {
          "label": "Intro",
          "value": "[Intro]\n"
        },
        {
          "label": "Outro",
          "value": "[Outro]\n"
        }
      ],
      "styles": [
        {
          "label": "Pop",
          "value": "Pop"
        },
        {
          "label": "Rock",
          "value": "Rock"
        },
        {
          "label": "Jazz",
          "value": "Jazz"
        },
        {
          "label": "Clásica",
          "value": "Classical"
        },
        {
          "label": "Electrónica",
          "value": "Electronic"
        },
        {
          "label": "R&B",
          "value": "R&B"
        },
        {
          "label": "Hip-Hop",
          "value": "Hip-Hop"
        },
        {
          "label": "Country",
          "value": "Country"
        },
        {
          "label": "Folk",
          "value": "Folk"
        },
        {
          "label": "Ambient",
          "value": "Ambient"
        },
        {
          "label": "Cinematográfica",
          "value": "Cinematic"
        },
        {
          "label": "Lo-fi",
          "value": "Lo-fi"
        },
        {
          "label": "Metal",
          "value": "Metal"
        },
        {
          "label": "Reggae",
          "value": "Reggae"
        },
        {
          "label": "Blues",
          "value": "Blues"
        },
        {
          "label": "Soul",
          "value": "Soul"
        },
        {
          "label": "Funk",
          "value": "Funk"
        },
        {
          "label": "Indie",
          "value": "Indie"
        }
      ]
    },
    "options": {
      "duration": "Duración",
      "instrumental": "Instrumental",
      "instrumentalDescOn": "Generar solo acompañamiento, sin voces",
      "instrumentalDescOff": "Incluir actuación vocal"
    },
    "errors": {
      "titleRequired": "El título de la canción es obligatorio",
      "lyricsDescRequired": "La descripción de letras es obligatoria"
    },
    "footer": {
      "creditsRequired": "Créditos Requeridos:",
      "creditsLeft": "Restantes:",
      "generate": "Generar Música"
    },
    "preview": {
      "generating": "Generando música...",
      "generatedTitle": "Música Generada",
      "emptyTitle": "Generador de Música IA",
      "emptySubtitle": "Crea música original con IA. Describe el estilo o ingresa letras, y genera tu propia canción en segundos.",
      "emptyTags": [
        "Pop",
        "Jazz",
        "Cinematográfica",
        "Lo-fi",
        "Rock"
      ],
      "track": "Pista",
      "play": "Reproducir",
      "pause": "Pausar",
      "mute": "Silenciar",
      "unmute": "Activar sonido",
      "download": "Descargar",
      "showLyrics": "Mostrar letras",
      "hideLyrics": "Ocultar letras",
      "generateFailed": "Generación fallida",
      "requestFailed": "Solicitud fallida, inténtalo de nuevo",
      "downloadMp3": "Descargar MP3",
      "downloadWav": "Descargar WAV",
      "regenerate": "Regenerar",
      "noHistory": "Aún sin historial"
    },
    "intro": {
      "title": "Generador de Música IA",
      "desc": "Usando tecnología IA avanzada, simplemente ingresa una descripción o letras para generar música original de alta calidad. Soporta múltiples estilos musicales, adecuado para bandas sonoras de video, anuncios, podcasts y más.",
      "tagMusic": "Generación de Música",
      "tagLyrics": "Creación de Letras",
      "tagStyles": "Múltiples Estilos",
      "tagCommercial": "Licencia Comercial"
    },
    "features": {
      "badge": "Características Principales",
      "title": "¿Qué puede hacer el Generador de Música IA por ti?",
      "items": {
        "styles": {
          "icon": "🎵",
          "title": "Múltiples Estilos",
          "desc": "Soporta Pop, Rock, Electrónica, Jazz, Clásica, Hip-Hop y docenas de estilos musicales para satisfacer varias necesidades creativas."
        },
        "lyrics": {
          "icon": "📝",
          "title": "Creación de Letras",
          "desc": "Ingresa letras para generar canciones completas con marcadores de sección (Verso, Coro, etc.), IA organiza y produce música automáticamente."
        },
        "vocals": {
          "icon": "🎤",
          "title": "Síntesis Vocal",
          "desc": "Soporta voces masculinas y femeninas con varios timbres, IA canta tus letras con resultados naturales y suaves."
        },
        "instrumental": {
          "icon": "🎹",
          "title": "Modo Instrumental",
          "desc": "Genera acompañamiento instrumental de alta calidad, adecuado para bandas sonoras de video, música de fondo de podcasts y más."
        },
        "fast": {
          "icon": "⚡",
          "title": "Generación Rápida",
          "desc": "Modelos IA avanzados aseguran producción musical rápida, la mayor parte de la música puede generarse dentro de 30 segundos."
        },
        "commercial": {
          "icon": "💼",
          "title": "Licencia Comercial",
          "desc": "Toda la música generada puede usarse para propósitos comerciales, incluyendo videos, anuncios, podcasts y más."
        }
      }
    },
    "faq": {
      "title": "Preguntas Frecuentes",
      "items": {
        "howItWorks": {
          "q": "¿Cómo funciona el Generador de Música IA?",
          "a": "Nuestro Generador de Música IA usa modelos de aprendizaje profundo avanzados para crear música original basada en tus descripciones de texto o letras. Simplemente ingresa el estilo musical, emoción y descripción de escena, e IA compondrá automáticamente una pieza musical completa."
        },
        "commercial": {
          "q": "¿Se puede usar la música generada para propósitos comerciales?",
          "a": "Sí, toda la música generada usando nuestra plataforma puede usarse para propósitos comerciales, incluyendo videos de YouTube, anuncios, podcasts, juegos y más."
        },
        "styles": {
          "q": "¿Qué estilos musicales son compatibles?",
          "a": "Soportamos Pop, Rock, Electrónica, Jazz, Clásica, Hip-Hop, R&B, Country, Metal, Folk y docenas de otros estilos musicales. También puedes mezclar múltiples estilos para crear música única."
        },
        "credits": {
          "q": "¿Cuántos créditos cuesta cada generación?",
          "a": "Dependiendo del modelo seleccionado, cada generación cuesta 8-10 créditos. Puedes obtener mejores tasas de crédito a través de planes de suscripción."
        },
        "download": {
          "q": "¿Puedo descargar la música generada?",
          "a": "Sí, la música generada admite descarga en formatos MP3 y WAV. Puedes elegir el formato apropiado según tus necesidades."
        }
      }
    },
    "demoTracks": {
      "summerBreeze": {
        "title": "Brisa de Verano",
        "style": "Pop / Animado",
        "duration": "2:00"
      },
      "spaceJourney": {
        "title": "Viaje Espacial",
        "style": "Electrónica / Futurista",
        "duration": "1:30"
      },
      "rainWalk": {
        "title": "Caminando en la Lluvia",
        "style": "Jazz / Relajado",
        "duration": "2:30"
      },
      "mountainDawn": {
        "title": "Amanecer en la Montaña",
        "style": "Clásica / Serena",
        "duration": "3:00"
      }
    }
  },
  "profile": {
    "joinTime": "Se unió",
    "tabs": {
      "account": "Cuenta",
      "billing": "Facturación",
      "privacy": "Datos y Privacidad"
    },
    "balance": {
      "title": "Resumen de Saldo",
      "available": "Créditos Disponibles"
    },
    "subscription": {
      "currentPlan": "Plan Actual",
      "status": "Estado",
      "activated": "Activado",
      "cancelled": "Cancela al final del período actual",
      "pending": "Procesando",
      "failed": "Pago Fallido",
      "expiryDate": "Válido Hasta",
      "permanent": "Permanente",
      "upgradePlan": "Actualizar o Cambiar Plan",
      "cancelPlan": "Cancelar Suscripción",
      "cancelNote": "Tu suscripción permanece activa hasta el final de tu período de facturación actual",
      "cancelWarning": "Tu suscripción será cancelada. Puedes continuar usando todas las características hasta",
      "restorePlan": "Reanudar Suscripción"
    },
    "upgrade": {
      "title": "Actualizar",
      "desc": "Obtén acceso ilimitado y beneficios exclusivos",
      "btn": "Ver Planes"
    },
    "billing": {
      "title": "Historial de Pagos",
      "subtitle": "Vea sus registros de pago y descargue facturas",
      "empty": "Aún sin registros de facturación",
      "creditsPack": "Paquete de Créditos",
      "oneTime": "Único",
      "monthly": "Mensual",
      "yearly": "Anual",
      "refresh": "Actualizar",
      "plan": "Plan",
      "date": "Fecha",
      "amount": "Monto",
      "invoice": "Factura",
      "download": "Descargar",
      "invoiceModal": {
        "title": "Detalles de Factura",
        "orderInfo": "Información del Pedido",
        "invoiceInfo": "Información de Factura",
        "plan": "Plan",
        "date": "Fecha de Pago",
        "amount": "Monto",
        "paymentId": "ID de Pedido",
        "close": "Cerrar",
        "download": "Descargar Factura",
        "fullName": "Nombre Completo",
        "fullNamePlaceholder": "Ingresa tu nombre completo",
        "email": "Correo Electrónico",
        "emailPlaceholder": "Ingresa tu correo electrónico",
        "company": "Empresa",
        "companyPlaceholder": "Nombre legal de la empresa",
        "taxId": "ID Fiscal",
        "taxIdPlaceholder": "Ingresa ID fiscal",
        "addressLine1": "Línea de Dirección 1",
        "addressLine1Placeholder": "Dirección de la calle",
        "addressLine2": "Línea de Dirección 2",
        "addressLine2Placeholder": "Apto, suite, etc. (opcional)",
        "city": "Ciudad",
        "cityPlaceholder": "Ciudad",
        "province": "Provincia",
        "provincePlaceholder": "Provincia",
        "postalCode": "Código Postal",
        "postalCodePlaceholder": "Código postal",
        "country": "País",
        "countryPlaceholder": "País",
        "invoiceRemarks": "Observaciones",
        "invoiceRemarksPlaceholder": "Observaciones de factura",
        "optional": "opcional",
        "required": "Este campo es obligatorio"
      }
    },
    "privacy": {
      "title": "Configuración de Privacidad",
      "cardTitle": "Tus Datos Están Protegidos",
      "cardSubtitle": "Nuestro compromiso con tu privacidad y seguridad de datos",
      "item1": "Tus datos nunca se usan para entrenamiento de modelos de IA",
      "item2": "La transmisión y almacenamiento de datos están completamente encriptados",
      "item3": "Los trabajos generados se eliminan automáticamente después del período de almacenamiento",
      "item4": "Sin bucles de retroalimentación, sin uso secundario de datos derivados",
      "item5": "Cumplimiento estricto de regulaciones de protección de datos"
    },
    "support": {
      "title": "¿Necesitas Ayuda?",
      "desc": "Nuestro equipo de soporte está aquí para ayudar",
      "btn": "Contactar Soporte",
      "note": "miral_support@miralvis.com · Respuesta dentro de 24 horas"
    }
  },
  "errors": {
    "generic": "Ocurrió un error. Inténtelo de nuevo.",
    "network": "Error de red. Verifique su conexión.",
    "unauthorized": "No autorizado. Inicie sesión nuevamente.",
    "notFound": "Página no encontrada.",
    "serverError": "Error del servidor. Inténtelo más tarde.",
    "maintenance": "Estamos en mantenimiento. Vuelva más tarde.",
    "quotaExceeded": "Cuota excedida. Actualice su plan.",
    "invalidInput": "Entrada inválida. Verifique e inténtelo de nuevo.",
    "rateLimit": "Demasiadas solicitudes. Inténtelo más tarde."
  },
  "success": {
    "imageGenerated": "Imagen generada con éxito",
    "videoGenerated": "Video generado con éxito",
    "musicGenerated": "Música generada con éxito",
    "profileUpdated": "Perfil actualizado con éxito",
    "settingsSaved": "Configuración guardada con éxito",
    "emailSent": "Correo electrónico enviado con éxito"
  },
  "validation": {
    "required": "Este campo es obligatorio",
    "email": "Ingrese un correo electrónico válido",
    "minLength": "Debe tener al menos {min} caracteres",
    "maxLength": "No puede exceder {max} caracteres",
    "passwordMatch": "Las contraseñas deben coincidir",
    "url": "Ingrese una URL válida",
    "number": "Ingrese un número válido",
    "positive": "Debe ser un número positivo"
  },
  "time": {
    "seconds": "segundos",
    "minutes": "minutos",
    "hours": "horas",
    "days": "días",
    "weeks": "semanas",
    "months": "meses",
    "years": "años",
    "ago": "hace",
    "in": "en"
  },
  "units": {
    "pixel": "píxel",
    "pixels": "píxeles",
    "mb": "MB",
    "gb": "GB",
    "kb": "KB"
  },
  "tools": {
    "demoTitle": "Demo",
    "page": {
      "tag": "Caja de Herramientas AI",
      "title": "Caja de Herramientas AI Profesional",
      "subtitle": "Eliminación de marcas de agua, restauración de fotos, escalado HD, mejora de video y más herramientas profesionales para todas sus necesidades de postproducción.",
      "allTools": "Todas las Herramientas"
    },
    "detail": {
      "useNow": "Usar Ahora",
      "clickUpload": "Haz clic o arrastra para subir",
      "support": "Soporta",
      "reupload": "Volver a subir",
      "scale": "Escala",
      "process": "Procesar",
      "processing": "Procesando...",
      "before": "Antes",
      "after": "Después",
      "download": "Descargar Resultado",
      "processNew": "Procesar Nuevo Archivo",
      "howToUse": "Cómo Usar",
      "moreTools": "Más Herramientas",
      "notFound": "Herramienta No Encontrada",
      "backToList": "Volver a Herramientas",
      "loginRequired": "Inicio de Sesión Requerido",
      "loginRequiredDesc": "Inicia sesión para usar esta herramienta",
      "loginNow": "Iniciar Sesión Ahora",
      "demo": "Demo",
      "uploadOriginalFailed": "Error al subir la imagen original, por favor intente de nuevo"
    },
    "steps": {
      "upload": {
        "title": "Subir Archivo",
        "desc": "Selecciona o arrastra y suelta el archivo de imagen o video que deseas procesar."
      },
      "adjust": {
        "title": "Ajustar Configuración",
        "desc": "Configura parámetros de procesamiento como factor de escala y formato de salida."
      },
      "process": {
        "title": "Procesar con un Clic",
        "desc": "La IA procesa automáticamente, usualmente completado en segundos a minutos."
      },
      "download": {
        "title": "Descargar Resultado",
        "desc": "Vista previa el resultado y descarga la salida de alta calidad."
      }
    },
    "fileTypes": {
      "image": "Imagen",
      "video": "Video"
    },
    "imageEnhancer": {
      "name": "Mejorador de Imágenes",
      "desc": "Escala imágenes a resolución 4K con detalles mejorados.",
      "fullDesc": "Escala imágenes a resolución 4K con detalles mejorados. Utiliza algoritmos IA avanzados para mejorar detalles, haciendo que imágenes borrosas se vean nítidas y claras."
    },
    "watermark-remover": {
      "name": "Eliminador de Marcas de Agua",
      "desc": "Elimina marcas de agua de imagen con IA en un clic.",
      "fullDesc": "Eliminación de marcas de agua potenciada por IA preservando la calidad de imagen. Soporta procesamiento por lotes, detección automática de marcas de agua y eliminación precisa sin dañar la imagen original.",
      "fileTooLarge": "La imagen es demasiado grande. Usa un archivo menor de 15MB (JPG, PNG o WebP).",
      "notImageFile": "Por favor sube un archivo de imagen.",
      "noImageInResponse": "No se devolvió ninguna imagen resultado. Por favor inténtelo más tarde.",
      "downloadName": "marca-agua-eliminada.png",
      "aiRepair": "Eliminación de marcas de agua",
      "uploadLabel": "Subir imagen",
      "uploadHint": "Admite imágenes JPG, PNG o WebP de hasta 15 MB.",
      "featuresKicker": "Rápido y preciso",
      "featuresTitle": "Eliminar diferentes marcas de agua de fotos en línea",
      "featuresIntro": "Cargue una imagen JPG, PNG o WebP y deje que la IA detecte áreas de marcas de agua y reconstruya el fondo sin cepillado manual.",
      "features": [
        {
          "title": "Borrar marcas de agua de imagen completa",
          "desc": "Elimine el texto translúcido repetido o las marcas de agua de patrones que cubren toda la imagen para obtener un resultado más limpio.",
          "cta": "Pruebe el eliminador de marcas de agua AI gratis"
        },
        {
          "title": "Eliminar marcas de tiempo y fechas",
          "desc": "Limpia fechas, marcas de tiempo y marcas de cámara de las esquinas de las fotografías mientras reconstruyes el fondo detrás de ellas.",
          "cta": "Borrar marcas de agua de imágenes en línea"
        },
        {
          "title": "Borrar logotipos de marcas",
          "desc": "Elimine logotipos de marcas, insignias en las esquinas y marcas promocionales de las imágenes que tenga permiso para editar.",
          "cta": "Eliminar marcas de agua de fotos ahora"
        },
        {
          "title": "Texto limpio y marcas de borrador",
          "desc": "Elimine las superposiciones de texto de las vistas previas, borradores de diseño y fotografías para crear contenido visual más limpio.",
          "cta": "Pruebe el eliminador de marcas de agua ahora"
        }
      ],
      "useCasesKicker": "Casos de uso",
      "useCasesTitle": "¿Qué puede limpiar el eliminador de marcas de agua de imágenes AI?",
      "audienceLabels": [
        "Vendedores de comercio electrónico",
        "Equipos de marketing",
        "Diseñadores y creadores",
        "Tiendas de moda y ropa"
      ],
      "audienceCases": [
        {
          "title": "Prepare imágenes de productos 3 veces más rápido",
          "desc": "Antes de crear imágenes pulidas de listados de productos, primero limpie las fotografías autorizadas de productos, imágenes de proveedores o borradores de activos. Elimine las marcas que distraigan para que los compradores puedan concentrarse en el producto."
        },
        {
          "title": "Reduzca la limpieza manual en un 60 % y cree recursos de campaña más rápido",
          "desc": "Antes de convertir imágenes propias o con licencia en anuncios, pancartas y gráficos de marca, elimine las marcas de agua no deseadas. Los activos limpios pueden pasar más rápido a las promociones de campañas, lanzamientos de productos y carteles de productos."
        },
        {
          "title": "Convierta imágenes limpias en nuevos conceptos creativos más rápido",
          "desc": "Comience con imágenes de origen más limpias para explorar nuevas direcciones de diseño sin reconstruir desde cero. Utilice borradores limpios como referencia para bocetos de IA, arte conceptual o imágenes estilo póster."
        },
        {
          "title": "Actualizar imágenes del catálogo de productos sin volver a disparar",
          "desc": "Antes de preparar actualizaciones del catálogo, lanzamientos de temporada o imágenes de pruebas virtuales con IA, limpie las fotografías de prendas autorizadas para que los compradores puedan centrarse en el ajuste, la tela y los detalles del producto."
        }
      ],
      "useCases": [
        {
          "title": "Eliminación de marcas de agua en fotos de productos",
          "desc": "Limpie el texto, los logotipos y las marcas promocionales de las fotografías de los productos antes de transmitir sus propios activos."
        },
        {
          "title": "Eliminación de marcas de agua para fotos sociales",
          "desc": "Elimine las marcas de plataforma o las marcas de tiempo de sus propias fotos para obtener una versión de publicación más limpia."
        },
        {
          "title": "Limpiar múltiples marcas de agua",
          "desc": "Cuando una imagen contiene varias marcas de agua, la IA puede detectar y limpiar múltiples áreas cubiertas."
        }
      ],
      "howToKicker": "Tres sencillos pasos",
      "howToTitle": "Cómo eliminar marcas de agua de imágenes en línea de forma gratuita",
      "howToIntro": "No se necesita instalación de software. Cargue una imagen, ejecute el eliminador de marcas de agua con IA y descargue el resultado limpio.",
      "howToCta": "Eliminar marcas de agua en línea ahora",
      "steps": {
        "upload": {
          "title": "Cargar una imagen con marca de agua",
          "desc": "Elija una imagen JPG, PNG o WebP de menos de 15 MB. Asegúrese de tener derecho a editarlo y usarlo."
        },
        "remove": {
          "title": "Eliminar la marca de agua con IA",
          "desc": "Inicie el procesamiento y la IA detectará logotipos, texto, marcas de tiempo o marcas de agua de imagen completa y reconstruirá el fondo."
        },
        "download": {
          "title": "Vista previa y descarga",
          "desc": "Compare los resultados del antes y el después, luego descargue la imagen limpia o cargue otra."
        }
      },
      "faqTitle": "Preguntas frecuentes sobre el eliminador de marcas de agua con IA",
      "faqs": [
        {
          "q": "¿Qué es un eliminador de marcas de agua con IA?",
          "a": "Un eliminador de marcas de agua con IA detecta áreas de marcas de agua y reconstruye fondos cubiertos utilizando colores, texturas y contenido de imagen cercanos."
        },
        {
          "q": "¿Cómo eliminar marcas de agua de fotos online gratis?",
          "a": "Regístrese, cargue una imagen en el eliminador de marcas de agua Miral AI y comience a procesar para obtener una vista previa del resultado limpio."
        },
        {
          "q": "¿Qué formatos de imagen son compatibles?",
          "a": "Actualmente, la herramienta admite imágenes JPG, PNG y WebP de menos de 15 MB. Esta página no elimina marcas de agua de los videos."
        },
        {
          "q": "¿Puede eliminar marcas de agua, logotipos y marcas de tiempo de imagen completa?",
          "a": "Sí. La IA puede procesar marcas de agua de imagen completa, logotipos de marcas, sellos de fecha, texto y borradores repetidos. Los resultados dependen de la opacidad, el área cubierta y la complejidad del fondo."
        },
        {
          "q": "¿Qué herramienta puedo utilizar para eliminar varios logotipos o marcas de tiempo de una foto?",
          "a": "El eliminador de marcas de agua Miral AI puede procesar múltiples áreas de marcas de agua, incluidos logotipos y marcas de tiempo. Consulte la vista previa cuando marcas grandes cubran personas o texturas complejas."
        },
        {
          "q": "¿Es legal eliminar una marca de agua de una imagen?",
          "a": "Procese únicamente imágenes de su propiedad, que esté autorizado a editar o que pueda utilizar legalmente. Eliminar marcas de agua con derechos de autor sin permiso puede infringir los derechos del propietario."
        },
        {
          "q": "¿Cómo arreglar áreas borrosas después de eliminar una marca de agua?",
          "a": "Comience con la imagen fuente de mayor calidad disponible y verifique la vista previa antes de descargarla. La IA intenta preservar la composición, la resolución y los detalles originales, pero el contenido oculto por grandes marcas de agua debe reconstruirse, por lo que los resultados locales pueden diferir del original."
        }
      ]
    },
    "full-watermark-remover": {
      "name": "Eliminador de marcas de agua IA",
      "desc": "Elimina marcas de agua de imágenes con IA.",
      "fullDesc": "Usa IA para detectar y eliminar marcas de agua de imágenes, preservando el contenido, los detalles y la calidad visual.",
      "audienceLabels": ["Vendedores de e-commerce", "Equipos de marketing", "Diseñadores y creadores", "Tiendas de moda y ropa"],
      "audienceCases": [
        { "title": "Prepara recursos visuales de producto 3 veces más rápido", "desc": "Antes de crear imágenes de producto profesionales, limpia las fotos, imágenes de proveedores o borradores que tengas autorización para usar. Elimina marcas que distraen para que los compradores se centren en el producto." },
        { "title": "Reduce un 60 % la limpieza manual y crea campañas más rápido", "desc": "Antes de convertir recursos propios o autorizados en anuncios, banners y gráficos de marca, elimina las marcas de agua innecesarias. Los materiales limpios pasan más rápido a campañas, lanzamientos y carteles de producto." },
        { "title": "Convierte imágenes limpias en nuevos conceptos creativos más rápido", "desc": "Explora nuevas direcciones de diseño a partir de imágenes fuente limpias sin reconstruirlas desde cero. Usa los borradores sin marcas de agua como referencia para bocetos con IA, arte conceptual o diseños de carteles." },
        { "title": "Renueva el catálogo sin volver a hacer las fotos", "desc": "Antes de preparar catálogos, lanzamientos de temporada o imágenes para pruebas virtuales con IA, limpia las fotos de ropa autorizadas para destacar el corte, el tejido y los detalles del producto." }
      ],
      "notImageFile": "Por favor sube un archivo de imagen válido.",
      "fileTooLarge": "La imagen es demasiado grande. Selecciona una imagen menor de 15MB.",
      "downloadName": "marca-agua-completa-eliminada.png"
    },
    "ai-text-remover": {
      "name": "Eliminador de texto IA",
      "desc": "Elimina texto no deseado de imágenes con IA.",
      "fullDesc": "Elimina texto no deseado de imágenes con IA, preservando el fondo, la textura y los detalles naturales.",
      "notImageFile": "Por favor sube un archivo de imagen válido.",
      "fileTooLarge": "La imagen es demasiado grande. Selecciona una imagen menor de 15MB.",
      "downloadName": "texto-eliminado.png"
    },
    "ai-logo-remover": {
      "name": "Eliminador de logos IA",
      "desc": "Elimina logos no deseados de imágenes con IA.",
      "fullDesc": "Elimina logos no deseados de imágenes con IA, preservando el fondo, la textura y los detalles naturales.",
      "notImageFile": "Por favor sube un archivo de imagen válido.",
      "fileTooLarge": "La imagen es demasiado grande. Selecciona una imagen menor de 15MB.",
      "downloadName": "logo-eliminado.png"
    },
    "ai-passersby-remover": {
      "name": "Eliminador de transeúntes IA",
      "desc": "Elimina transeúntes de imágenes con IA.",
      "fullDesc": "Usa IA para detectar y eliminar transeúntes de imágenes, preservando el sujeto, la textura del fondo y los detalles naturales.",
      "notImageFile": "Por favor sube un archivo de imagen válido.",
      "fileTooLarge": "La imagen es demasiado grande. Selecciona una imagen menor de 15MB.",
      "downloadName": "transeuntes-eliminados.png"
    },
    "background-remover": {
      "name": "Eliminador de Fondos",
      "desc": "Elimina el fondo de imagen con IA en un clic.",
      "heroTitle": "Eliminador de fondos con IA gratis para crear PNG transparentes",
      "fullDesc": "Sube una imagen JPG, PNG o WebP y deja que la IA detecte retratos, productos y bordes. Conserva detalles como el cabello y descarga un PNG transparente sin Photoshop.",
      "uploadLabel": "Sube una imagen para quitar el fondo",
      "uploadHint": "Haz clic o arrastra una imagen aquí",
      "uploadSpec": "Admite JPG, PNG o WebP de hasta 15MB. El resultado se descarga como PNG transparente.",
      "processButton": "Eliminar fondo de imagen",
      "previewAlt": "Vista previa antes de eliminar el fondo con IA",
      "demoBeforeAlt": "Retrato antes de eliminar el fondo",
      "demoAfterAlt": "Retrato después de eliminar el fondo con IA",
      "processingAlt": "La IA está eliminando el fondo de la imagen",
      "processingLabel": "Recorte en proceso",
      "resultLabel": "Fondo transparente listo",
      "resultBeforeAlt": "Imagen original antes de quitar el fondo",
      "resultAfterAlt": "PNG transparente después de quitar el fondo con IA",
      "productBeforeAlt": "Foto de producto antes de quitar el fondo",
      "productAfterAlt": "Producto recortado sobre fondo transparente",
      "featuresKicker": "Detección precisa del sujeto",
      "featuresTitle": "Eliminador de fondos con IA para retratos y fotos de producto",
      "featuresIntro": "Desde bordes complejos en retratos hasta recortes para ecommerce, la IA separa sujeto y fondo sin pinceles, trazados ni máscaras manuales.",
      "features": [
        { "title": "Quita el fondo de retratos conservando el cabello", "desc": "Detecta personas, ropa y cabellos finos para crear fotos de perfil, retratos, carteles y diseños sociales con un recorte más limpio.", "cta": "Quitar fondo de retrato gratis" },
        { "title": "Recorta fotos de producto en un clic", "desc": "Elimina mesas, paredes y decorados para reutilizar el producto transparente en fondos blancos, fichas y anuncios.", "cta": "Quitar fondo de producto" },
        { "title": "Descarga un PNG transparente", "desc": "Conserva la transparencia para colocar el sujeto en otro fondo, banner, presentación, miniatura o diseño gráfico.", "cta": "Hacer el fondo transparente" }
      ],
      "featureAlts": { "portraitBefore": "Retrato antes de quitar el fondo", "portraitAfter": "Retrato recortado conservando el cabello", "productBefore": "Producto antes de quitar el fondo", "productAfter": "Producto sobre fondo transparente", "ecommerceBefore": "Imagen ecommerce antes del recorte", "ecommerceAfter": "PNG transparente para ecommerce" },
      "useCasesKicker": "Casos de uso populares",
      "useCasesTitle": "¿Qué imágenes funcionan con el recorte de IA en un clic?",
      "useCasesIntro": "Úsalo cuando necesites aislar un sujeto o preparar una imagen transparente para proyectos creativos y comerciales.",
      "useCases": [
        { "title": "Fotos de producto ecommerce", "desc": "Prepara productos transparentes para catálogos, tiendas y campañas." },
        { "title": "Retratos y fotos de perfil", "desc": "Elimina el entorno conservando cabello, ropa y contornos." },
        { "title": "Diseños para redes sociales", "desc": "Coloca personas o productos en portadas, publicaciones y miniaturas." },
        { "title": "Fotos profesionales y de identificación", "desc": "Separa a la persona y añade después el color de fondo necesario." },
        { "title": "Logos y recursos gráficos", "desc": "Quita un fondo no deseado antes de reutilizar el diseño." },
        { "title": "Publicidad y diseño gráfico", "desc": "Crea PNG transparentes flexibles sin recortes manuales repetitivos." }
      ],
      "howToKicker": "Tres pasos sencillos",
      "howToTitle": "Cómo eliminar gratis el fondo de una imagen online",
      "howToIntro": "Sube una imagen, ejecuta el recorte automático con IA y descarga el PNG transparente.",
      "steps": [
        { "title": "Sube un JPG, PNG o WebP", "desc": "Elige un retrato, producto o diseño claro de menos de 15MB." },
        { "title": "Elimina el fondo con IA", "desc": "La IA separa el sujeto conservando los bordes importantes." },
        { "title": "Previsualiza y descarga el PNG", "desc": "Compara el resultado y guarda la imagen transparente." }
      ],
      "faqTitle": "Preguntas frecuentes sobre el eliminador de fondos con IA",
      "faqs": [
        { "q": "¿Cómo eliminar gratis el fondo de una imagen online?", "a": "Sube un JPG, PNG o WebP e inicia el proceso. La IA detecta el sujeto y genera un PNG transparente." },
        { "q": "¿La IA conserva el cabello y los bordes finos?", "a": "La herramienta intenta conservar cabello, ropa y detalles pequeños. Un buen contraste entre sujeto y fondo suele mejorar el resultado." },
        { "q": "¿Puedo quitar el fondo de una foto de producto?", "a": "Sí. Los productos claramente visibles son adecuados para crear recursos transparentes de ecommerce y publicidad." },
        { "q": "¿Qué formato obtengo después del proceso?", "a": "El resultado se descarga como PNG con transparencia." },
        { "q": "¿Qué formatos y tamaños se admiten?", "a": "Se admiten JPG, PNG y WebP de hasta 15MB." },
        { "q": "¿Necesito instalar Photoshop?", "a": "No. La IA elimina el fondo directamente en el navegador." }
      ],
      "fileTooLarge": "La imagen es demasiado grande. Usa un archivo menor de 15MB (JPG, PNG o WebP).",
      "notImageFile": "Por favor sube un archivo de imagen.",
      "noImageInResponse": "No se devolvió ninguna imagen resultado. Por favor inténtelo más tarde.",
      "downloadName": "fondo-eliminado.png"
    },
    "image-eraser": {
      "name": "Borrador de Imágenes",
      "desc": "Borra cualquier objeto, persona o marca de agua de imágenes con IA.",
      "fullDesc": "Borrador de imágenes potenciado por IA. Pasa el pincel sobre cualquier objeto, persona, marca de agua o texto no deseado en tu foto y la IA lo eliminará sin costuras rellenando el área con contenido natural. Perfecto para limpiar fotos y eliminar distracciones.",
      "fileTooLarge": "La imagen es demasiado grande. Usa un archivo menor de 15MB (JPG, PNG o WebP).",
      "notImageFile": "Por favor sube un archivo de imagen.",
      "noImageInResponse": "No se devolvió ninguna imagen resultado. Por favor inténtelo más tarde.",
      "downloadName": "image-erased.png"
    },
    "object-remover": {
      "name": "Eliminador de Objetos",
      "desc": "Elimina objetos no deseados de tus fotos con IA.",
      "fullDesc": "Eliminador de objetos potenciado por IA. Pasa el pincel sobre cualquier objeto no deseado en tu foto y la IA lo eliminará sin costuras rellenando el área con contenido natural. Perfecto para limpiar fotos y eliminar distracciones.",
      "fileTooLarge": "La imagen es demasiado grande. Usa un archivo menor de 15MB (JPG, PNG o WebP).",
      "notImageFile": "Por favor sube un archivo de imagen.",
      "noImageInResponse": "No se devolvió ninguna imagen resultado. Por favor inténtelo más tarde.",
      "downloadName": "object-removed.png",
      "uploadLabel": "Subir imagen",
      "uploadHint": "Haga clic o arrastre para cargar una imagen",
      "uploadSpec": "Admite imágenes JPG, PNG o WebP.",
      "maskHint": "Cepille cada parte del objeto que desea que la IA elimine.",
      "processButton": "Quitar objeto",
      "demoBeforeAlt": "Foto antes de la eliminación de objetos no deseados.",
      "demoAfterAlt": "Foto después de la eliminación de objetos no deseados.",
      "processingAlt": "IA procesando la foto marcada",
      "resultBeforeAlt": "Foto original antes de la retirada del objeto.",
      "resultAfterAlt": "Foto limpia después de la eliminación del objeto.",
      "featureImageLabels": {
        "object": "ejemplo de eliminación de objetos no deseados",
        "person": "ejemplo de eliminación de persona",
        "distraction": "ejemplo de eliminación de distracciones de fondo"
      },
      "featuresKicker": "Limpieza precisa de fotografías",
      "featuresTitle": "Eliminar objetos no deseados de fotos en línea",
      "featuresIntro": "Marque el área exacta que desea limpiar y utilice la eliminación de objetos con IA para las distracciones fotográficas cotidianas sin reconstruir manualmente el fondo.",
      "features": [
        {
          "title": "Quite los objetos no deseados",
          "desc": "Utilice un cepillo ajustable para marcar el desorden, los carteles, los accesorios u otros objetos. La IA elimina el área seleccionada y la rellena con detalles de la imagen circundante.",
          "cta": "Eliminar objetos gratis"
        },
        {
          "title": "Eliminar personas de fondos de fotos",
          "desc": "Limpie a los fotobombarderos, turistas o transeúntes de las fotografías de viajes y retratos cuando distraigan la atención del sujeto principal.",
          "cta": "Fondos de fotos limpios gratis"
        },
        {
          "title": "Borrar pequeñas distracciones de fondo",
          "desc": "Elimine cables, contenedores, desorden de la calle, marcas o distracciones visuales aisladas para crear una composición más limpia.",
          "cta": "Borrar distracciones fotográficas gratis"
        }
      ],
      "useCasesKicker": "Casos de uso populares",
      "useCasesTitle": "¿Qué se puede eliminar con AI Object Remover?",
      "useCasesIntro": "Diseñado para ediciones enfocadas donde puedes pasar claramente el área no deseada y mantener el resto de la foto sin cambios.",
      "useCases": [
        {
          "title": "Limpieza de fotografías de viajes",
          "desc": "Elimina a los transeúntes, los carteles, los contenedores o el desorden de las calles de las fotos de las vacaciones."
        },
        {
          "title": "Limpieza de fotografías del producto",
          "desc": "Borre accesorios, etiquetas, cables y elementos que distraigan alrededor de un producto."
        },
        {
          "title": "Limpieza del fondo del retrato",
          "desc": "Elimine las personas del fondo y los objetos pequeños que desvíen la atención del sujeto."
        },
        {
          "title": "Fotos de bienes raíces",
          "desc": "Limpie el desorden temporal y los objetos aislados de las imágenes de habitaciones o propiedades."
        },
        {
          "title": "Imágenes de redes sociales",
          "desc": "Pula las fotografías antes de publicarlas eliminando las distracciones visibles del marco."
        },
        {
          "title": "Edición de fotografías creativas",
          "desc": "Borre las áreas seleccionadas antes de reutilizar una imagen en un diseño o proyecto visual."
        }
      ],
      "howToKicker": "Tres sencillos pasos",
      "howToTitle": "Cómo eliminar un objeto de una foto en línea",
      "howToIntro": "Cargue una foto, pase el pincel sobre el objeto no deseado y descargue el resultado limpio con IA.",
      "steps": [
        {
          "title": "Sube tu foto",
          "desc": "Elige la imagen que contiene la persona, el elemento o la distracción que deseas borrar."
        },
        {
          "title": "Pincel sobre el objeto",
          "desc": "Ajuste el cepillo y cubra toda el área no deseada. Utilice deshacer o el borrador para refinar la máscara."
        },
        {
          "title": "Quitar y descargar",
          "desc": "Inicie el procesamiento de IA, compare las imágenes de antes y después y luego descargue la foto limpia."
        }
      ],
      "faqTitle": "Preguntas frecuentes sobre la eliminación de objetos de IA",
      "faqs": [
        {
          "q": "¿Cómo eliminar objetos no deseados de fotos en línea?",
          "a": "Sube una foto, aplica un pincel sobre todo el objeto no deseado y comienza a procesar. La IA reconstruye el área seleccionada utilizando colores, texturas y detalles de la escena cercanos."
        },
        {
          "q": "¿Qué herramienta puedo utilizar para eliminar a una persona del fondo de una fotografía?",
          "a": "Utiliza el pincel para cubrir a la persona e incluye detalles como sombras o elementos transportados. Los resultados suelen ser mejores cuando el fondo circundante es visible."
        },
        {
          "q": "¿Puede la IA eliminar señales, cables, contenedores y el desorden de las calles?",
          "a": "Sí. Marque claramente el área no deseada y evite cubrir objetos cercanos que desee conservar. Las distracciones pequeñas y aisladas suelen ser más fáciles de reconstruir."
        },
        {
          "q": "¿Cómo puedo obtener un resultado de eliminación de objetos más natural?",
          "a": "Utilice una imagen fuente clara y de alta calidad y aplique un pincel ligeramente más allá de los bordes del objeto. Procese las áreas difíciles por separado cuando varios objetos se superpongan."
        },
        {
          "q": "¿El eliminador de objetos cambia toda la foto?",
          "a": "La solicitud de eliminación se basa en la máscara cepillada. La herramienta se centra en el área seleccionada, aunque la IA debe reconstruir los píxeles alrededor de sus bordes."
        },
        {
          "q": "¿Qué formatos de imagen puedo cargar?",
          "a": "El control de carga acepta formatos de imagen comunes, incluidos JPG, PNG y WebP."
        }
      ]
    },
    "ai-person-remover": {
      "name": "Eliminador de Personas IA",
      "desc": "Elimina personas de tus fotos con IA.",
      "fullDesc": "Eliminador de personas potenciado por IA. Pasa el pincel sobre cualquier persona en tu foto y la IA la eliminará sin costuras rellenando el área con contenido natural. Perfecto para eliminar transeúntes, turistas o desconocidos de tus fotos.",
      "fileTooLarge": "La imagen es demasiado grande. Usa un archivo menor de 15MB (JPG, PNG o WebP).",
      "notImageFile": "Por favor sube un archivo de imagen.",
      "noImageInResponse": "No se devolvió ninguna imagen resultado. Por favor inténtelo más tarde.",
      "downloadName": "person-removed.png"
    },
    "background-blur": {
      "name": "Desenfoque de fondo",
      "desc": "Desenfoca el fondo de la imagen con IA con un clic para resaltar el sujeto",
      "fullDesc": "La IA detecta automáticamente el sujeto en primer plano (persona/objeto), mantiene el sujeto nítido y aplica un desenfoque gaussiano al fondo para un efecto tipo Modo Retrato. Ideal para retratos y primeros planos de producto.",
      "fileTooLarge": "La imagen es demasiado grande. Usa un archivo menor de 15MB (JPG, PNG o WebP).",
      "notImageFile": "Por favor sube un archivo de imagen.",
      "noImageInResponse": "No se devolvió ninguna imagen resultado. Por favor inténtelo más tarde.",
      "downloadName": "desenfoque-fondo.png"
    },
    "white-background": {
      "name": "Fondo Blanco",
      "desc": "Reemplazar fondo de imagen por blanco con IA.",
      "fullDesc": "Reemplazo de fondo por blanco potenciado por IA con un clic. Detecta con precisión el contorno del sujeto, preserva detalles finos como el cabello, salida de imagen con fondo blanco limpio. Ideal para fotos de producto y fotos de identificación.",
      "fileTooLarge": "La imagen es demasiado grande. Usa un archivo menor de 15MB (JPG, PNG o WebP).",
      "notImageFile": "Por favor sube un archivo de imagen.",
      "noImageInResponse": "No se devolvió ninguna imagen resultado. Por favor inténtelo más tarde.",
      "downloadName": "fondo-blanco.png"
    },
    "blue-background": {
      "name": "Fondo Azul",
      "desc": "Reemplazar fondo de imagen por azul con IA.",
      "fullDesc": "Reemplazo de fondo por azul potenciado por IA con un clic. Detecta con precisión el contorno del sujeto, preserva detalles finos como el cabello, salida de imagen con fondo azul limpio. Ideal para fotos de pasaporte y fotos de identificación.",
      "fileTooLarge": "La imagen es demasiado grande. Usa un archivo menor de 15MB (JPG, PNG o WebP).",
      "notImageFile": "Por favor sube un archivo de imagen.",
      "noImageInResponse": "No se devolvió ninguna imagen resultado. Por favor inténtelo más tarde.",
      "downloadName": "fondo-azul.png"
    },
    "face-swap": {
      "name": "Intercambio de rostros en fotos",
      "desc": "Intercambia rostros en fotos con IA en un clic.",
      "fullDesc": "Intercambio de rostros potenciado por IA. Sube una foto objetivo y una foto de rostro fuente para fusionar el rostro en la imagen objetivo de forma transparente. Soporta escenas con múltiples personas con resultados realistas.",
      "fileTooLarge": "La imagen es demasiado grande. Usa un archivo menor de 15MB (JPG, PNG o WebP).",
      "notImageFile": "Por favor sube un archivo de imagen.",
      "targetImage": "Foto objetivo",
      "sourceImage": "Rostro fuente",
      "effectImageLabel": "Resultado",
      "downloadName": "intercambio-rostros-resultado.png",
      "step1Title": "Subir fotos",
      "step1Desc": "Sube la foto objetivo y la foto de rostro fuente",
      "step2Title": "Intercambio de rostros IA",
      "step2Desc": "Haz clic en procesar, la IA intercambia el rostro automáticamente",
      "step3Title": "Descargar",
      "step3Desc": "Previsualiza y descarga el resultado",
      "processButton": "Cambiar cara",
      "targetPreviewAlt": "Vista previa de la foto de destino para el intercambio de caras con IA",
      "sourcePreviewAlt": "Vista previa de la cara fuente para el intercambio de caras de IA",
      "processingAlt": "Vista previa del procesamiento de intercambio de caras de IA",
      "resultBeforeAlt": "Foto de destino antes del cambio de cara",
      "resultAfterAlt": "Foto después del cambio de cara de IA",
      "featuresKicker": "Reemplazo de rostro natural",
      "featuresTitle": "Intercambia caras entre fotos con IA",
      "featuresIntro": "Utilice una foto de destino para la pose y la composición, luego proporcione una cara de origen clara para un intercambio de caras enfocado en la foto.",
      "features": [
        {
          "title": "Crea un intercambio de caras de apariencia natural",
          "desc": "La IA combina la identidad de origen con la foto de destino mientras sigue su pose, encuadre, iluminación y estilo visual general.",
          "cta": "Crea una foto con intercambio de caras gratis"
        },
        {
          "title": "Mantenga la composición de la foto de destino",
          "desc": "Utilice un retrato, una selfie, una imagen de personaje o una escena creativa como objetivo manteniendo su fondo y composición.",
          "cta": "Pruebe Photo Face Swap gratis"
        },
        {
          "title": "Utilice una cara de origen clara",
          "desc": "Cargue una imagen fuente frontal y bien iluminada con detalles faciales visibles para ayudar al modelo a crear un reemplazo más consistente.",
          "cta": "Subir e intercambiar gratis"
        }
      ],
      "useCasesKicker": "Ideas fotográficas creativas",
      "useCasesTitle": "Usos populares para el intercambio de caras de fotos en línea",
      "useCasesIntro": "Cree ediciones fotográficas divertidas y creativas utilizando una imagen de destino y una imagen de rostro de origen.",
      "useCases": [
        {
          "title": "Intercambios de caras de selfies y fotos de perfil",
          "desc": "Reemplace una cara en una selfie o retrato conservando la pose, el fondo y el encuadre del objetivo. Explora conceptos de fotografías de perfil e ideas de retratos personales con un rostro fuente claro.",
          "cta": "Crea un retrato con intercambio de caras gratis",
          "imageAlt": "Ejemplo de intercambio de caras con IA para selfies y fotos de perfil"
        },
        {
          "title": "Memes e imágenes de reacciones sociales",
          "desc": "Convierta fotografías familiares en memes personalizados, imágenes de reacciones divertidas y contenido social para compartir. Una expresión de destino clara ayuda a que la imagen final sea fácil de reconocer.",
          "cta": "Haz un intercambio de caras de memes gratis",
          "imageAlt": "Caso de uso de imagen de reacción social y meme creativo"
        },
        {
          "title": "Cosplay, personajes e historias creativas",
          "desc": "Pruebe con una cara disfrazada, un retrato de fantasía, un personaje ilustrado o una escena temática. Utilice el intercambio de caras para explorar conceptos de personajes y crear historias visuales a partir de imágenes que pueda editar.",
          "cta": "Prueba un intercambio de caras de personajes gratis",
          "imageAlt": "Caso de uso de cosplay e intercambio de caras de personajes"
        }
      ],
      "howToKicker": "Tres sencillos pasos",
      "howToTitle": "Cómo intercambiar caras en fotos en línea con IA",
      "howToIntro": "Elija una foto de destino, agregue una cara de origen clara y deje que la IA genere el resultado del intercambio de caras.",
      "faqTitle": "Preguntas frecuentes sobre el intercambio de caras de fotos",
      "faqs": [
        {
          "q": "¿Cómo intercambiar una cara entre dos fotos en línea?",
          "a": "Sube la foto cuya pose y composición deseas mantener como objetivo, luego sube la identidad que deseas usar como rostro de origen y comienza a procesar."
        },
        {
          "q": "¿Cuál es la diferencia entre la foto de destino y la cara de origen?",
          "a": "La fotografía de destino proporciona la pose, el fondo y la composición. La cara de origen proporciona la identidad facial utilizada para el reemplazo."
        },
        {
          "q": "¿Cómo elijo una buena imagen fuente para intercambiar caras?",
          "a": "Utilice una imagen clara y bien iluminada con una cara sin obstáculos. Un ángulo de origen y una expresión similares al objetivo pueden producir un resultado más consistente."
        },
        {
          "q": "¿Puedo usar el intercambio de caras con IA para selfies, memes o fotos de cosplay?",
          "a": "Sí. Estos son usos creativos comunes cuando eres propietario o tienes permiso para editar las imágenes cargadas."
        },
        {
          "q": "¿Por qué a veces un cambio de cara parece menos realista?",
          "a": "Las grandes diferencias en el ángulo de la cara, la iluminación, la expresión, la resolución o la oclusión intensa pueden dificultar la fusión. Pruebe fotografías de origen más claras y compatibles."
        },
        {
          "q": "¿Qué formatos de imagen y tamaños de archivo son compatibles?",
          "a": "Se admiten imágenes JPG, PNG y WebP, con un tamaño de archivo máximo de 15 MB por imagen."
        },
        {
          "q": "¿Puedo intercambiar una cara en un video en esta página?",
          "a": "No. Esta página procesa imágenes fijas y devuelve un resultado de imagen."
        }
      ]
    },
    "image-enhancer": {
      "name": "Mejorador de Imágenes",
      "desc": "Mejora la nitidez de imagen con IA en un clic.",
      "fullDesc": "Escala imágenes a resolución 4K con detalles mejorados. Utiliza algoritmos IA avanzados para mejorar detalles, haciendo que imágenes borrosas se vean nítidas y claras.",
      "fileTooLarge": "La imagen es demasiado grande. Usa un archivo menor de 15MB (JPG, PNG o WebP).",
      "notImageFile": "Por favor sube un archivo de imagen.",
      "downloadName": "imagen-mejorada.png",
      "targetResolution": "Resolución objetivo",
      "outputFormat": "Formato de salida",
      "resolutions": {
        "2k": "2K",
        "4k": "4K",
        "8k": "8K"
      },
      "formats": {
        "JPEG": "JPEG",
        "PNG": "PNG",
        "WEBP": "WEBP"
      },
      "processFailed": "Procesamiento fallido. Prueba otra imagen o formato de salida."
    },
    "video-enhancer": {
      "name": "Mejorador de vídeo",
      "desc": "Mejora la calidad del vídeo con IA y escalado.",
      "fullDesc": "Mejora la calidad del vídeo a HD/4K con interpolación de fotogramas y nitidez asistida por IA.",
      "notVideoFile": "Sube un archivo de vídeo (p. ej. MP4, MOV, AVI).",
      "fileTooLarge": "El vídeo es demasiado grande. Usa un archivo de menos de 100MB."
    },
    "cartoon-video-style-converter": {
      "name": "Convertidor estilo cartoon",
      "desc": "Convierte vídeos a estilo cartoon",
      "fullDesc": "Sube un vídeo y la IA lo convertirá a estilo cartoon conservando el movimiento principal, el encuadre y el ritmo.",
      "notVideoFile": "Sube un archivo de vídeo válido.",
      "fileTooLarge": "El vídeo es demasiado grande. Selecciona un vídeo menor de 100MB.",
      "downloadName": "cartoon-style-video.mp4"
    },
    "anime-video-style-converter": {
      "name": "Convertidor estilo anime",
      "desc": "Convierte vídeos a estilo anime",
      "fullDesc": "Sube un vídeo y la IA lo convertirá a estilo anime conservando el movimiento del sujeto y el ritmo de la toma.",
      "notVideoFile": "Sube un archivo de vídeo válido.",
      "fileTooLarge": "El vídeo es demasiado grande. Selecciona un vídeo menor de 100MB.",
      "downloadName": "anime-style-video.mp4"
    },
    "oil-painting-video-style-converter": {
      "name": "Convertidor estilo pintura al óleo",
      "desc": "Convierte vídeos a estilo pintura al óleo",
      "fullDesc": "Sube un vídeo y la IA lo convertirá a estilo pintura al óleo con colores ricos y textura pictórica.",
      "notVideoFile": "Sube un archivo de vídeo válido.",
      "fileTooLarge": "El vídeo es demasiado grande. Selecciona un vídeo menor de 100MB.",
      "downloadName": "oil-painting-style-video.mp4"
    },
    "cyberpunk-video-style-converter": {
      "name": "Convertidor estilo cyberpunk",
      "desc": "Convierte vídeos a estilo cyberpunk",
      "fullDesc": "Sube un vídeo y la IA lo convertirá a estilo cyberpunk futurista de alto contraste con luces de neón.",
      "notVideoFile": "Sube un archivo de vídeo válido.",
      "fileTooLarge": "El vídeo es demasiado grande. Selecciona un vídeo menor de 100MB.",
      "downloadName": "cyberpunk-style-video.mp4"
    },
    "photo-restore": {
      "name": "Restauración de Fotos",
      "desc": "Restaura fotos antiguas, borrosas o dañadas con tecnología IA.",
      "fullDesc": "Restaura fotos antiguas, borrosas o dañadas con tecnología IA. Soporta eliminación de ruido, mejora de nitidez y relleno de partes faltantes para revivir recuerdos preciosos.",
      "notImageFile": "Sube un archivo de imagen válido.",
      "fileTooLarge": "La imagen es demasiado grande; elige una de menos de 15MB.",
      "downloadName": "foto-restaurada.png"
    },
    "blurry-photo-repair": {
      "name": "Reparar Imágenes Borrosas",
      "desc": "Repara imágenes borrosas y recupera detalles más claros con IA.",
      "fullDesc": "Repara imágenes borrosas con IA. Mejora la nitidez, recupera detalles de rostros y texturas, y hace que las fotos suaves se vean más claras.",
      "notImageFile": "Sube un archivo de imagen válido.",
      "fileTooLarge": "La imagen es demasiado grande; elige una de menos de 15MB.",
      "downloadName": "imagen-borrosa-reparada.png"
    },
    "cartoon-digital-human": {
      "name": "Generador de personajes de dibujos IA",
      "desc": "Convertir retrato a estilo caricatura",
      "fullDesc": "Genera un humano digital estilo anime a partir de un retrato. Conserva los rasgos reconocibles y crea un avatar pulido con líneas limpias y colores vivos.",
      "notImageFile": "Sube un archivo de imagen válido.",
      "fileTooLarge": "La imagen es demasiado grande; elige una de menos de 15MB.",
      "downloadName": "humano-digital-cartoon.png"
    },
    "manga-digital-human": {
      "name": "Generador de personajes manga IA",
      "desc": "Convertir retrato a estilo manga",
      "fullDesc": "Genera un humano digital estilo manga a partir de un retrato. Conserva los rasgos reconocibles y crea un aspecto de cómic limpio con líneas expresivas y sombreado pulido.",
      "notImageFile": "Sube un archivo de imagen válido.",
      "fileTooLarge": "La imagen es demasiado grande; elige una de menos de 15MB.",
      "downloadName": "humano-digital-manga.png"
    },
    "oil-painting-digital-human": {
      "name": "Generador de retratos al óleo IA",
      "desc": "Convertir retrato a estilo óleo",
      "fullDesc": "Genera un humano digital estilo pintura al óleo desde un retrato. Conserva rasgos reconocibles mientras crea un retrato pictórico con colores ricos y textura de pincel.",
      "notImageFile": "Por favor sube un archivo de imagen válido.",
      "fileTooLarge": "Imagen demasiado grande, por favor selecciona una imagen menor de 15MB.",
      "downloadName": "humano-digital-oleo.png"
    },
    "id-photo-generator": {
      "name": "Generador de Foto ID",
      "desc": "Generar foto de identidad estándar desde un retrato",
      "fullDesc": "Genera una foto de identificación limpia y profesional desde un retrato. La IA ajusta el sujeto a un aspecto ordenado de foto documental.",
      "notImageFile": "Sube un archivo de imagen válido.",
      "fileTooLarge": "La imagen es demasiado grande; elige una de menos de 15MB.",
      "downloadName": "foto-id.png"
    },
    "doc-crop-enhance": {
      "name": "Recorte y Corrección de Imagen",
      "desc": "Recorta bordes y corrige deformación de documentos con IA.",
      "fullDesc": "Recorte, corrección y mejora de imagen. Elimina fondo de bordes, corrige distorsión y mejora con múltiples modos incluyendo iluminación, sharpen, blanco y negro, escala de grises, eliminación de sombras, etc.",
      "enhanceMode": "Modo de mejora",
      "enhanceModes": {
        "disabled": "Deshabilitado",
        "brighten": "Iluminar",
        "sharpen": "Mejorar y Sharpen",
        "blackWhite": "Blanco y Negro",
        "grayscale": "Escala de Grises",
        "deshadow": "Eliminación de Sombras",
        "bitmap": "Mapa de Bits"
      },
      "cropImage": "Recortar Bordes",
      "dewarpImage": "Corregir deformación",
      "notImageFile": "Por favor sube un archivo de imagen válido",
      "fileTooLarge": "Imagen demasiado grande, selecciona una imagen menor de 15MB",
      "noImageInResponse": "Procesamiento fallido, inténtelo de nuevo",
      "downloadName": "doc-recortado-mejorado.png",
      "featuresKicker": "MEJORA DEL ESCANEO DE DOCUMENTOS",
      "featuresTitle": "Convierta fotografías de documentos en escaneos limpios y correctamente alineados",
      "featuresIntro": "Maneje los bordes, la inclinación, la perspectiva, las páginas curvas, las sombras y la claridad del texto de los documentos para las necesidades comunes de captura móvil y mejora del escaneo.",
      "features": [
        {
          "title": "Detectar y recortar los bordes del documento automáticamente",
          "desc": "Encuentre el límite entre el papel y su fondo, luego elimine los escritorios, las sombras de los bordes y las áreas no relacionadas para obtener una página más limpia.",
          "cta": "Recorta un documento gratis"
        },
        {
          "title": "Enderezar documentos torcidos y corregir la perspectiva",
          "desc": "Corrija la distorsión trapezoidal, las páginas inclinadas y las proporciones causadas por fotografías en ángulo de contratos, formularios y exámenes.",
          "cta": "Corregir una foto de documento"
        },
        {
          "title": "Dewarp páginas curvas y documentos escaneados",
          "desc": "Corrija la distorsión cerca de encuadernaciones de libros, papel curvado y páginas dobladas para que los libros de texto y las fotografías de libros sean más fáciles de leer.",
          "cta": "Dewarping un documento curvo"
        },
        {
          "title": "Eliminar sombras de los escaneos de documentos",
          "desc": "Reduzca las sombras causadas por los teléfonos, los dedos, los lomos de los libros y la iluminación desigual para obtener recibos, hojas de trabajo y páginas escaneadas más limpias.",
          "cta": "Eliminar sombras del documento"
        },
        {
          "title": "Ilumine documentos y enfoque texto",
          "desc": "Mejore el brillo y los bordes del texto impreso en documentos de bajo contraste para facilitar la lectura, impresión y organización.",
          "cta": "Mejorar el texto escaneado"
        },
        {
          "title": "Cree escaneos en blanco y negro, en escala de grises o de mapa de bits",
          "desc": "Convierta fotografías de documentos en color en imágenes en blanco y negro, en escala de grises o mejoradas en mapas de bits para imprimirlas y archivarlas.",
          "cta": "Mejorar la imagen de un documento"
        }
      ],
      "useCasesKicker": "CASOS DE USO COMUNES",
      "useCasesTitle": "¿Qué imágenes de documentos se pueden recortar y mejorar?",
      "useCasesIntro": "Diseñado para imágenes de documentos individuales capturadas por teléfono o escáner con encuadres irregulares, sombras, distorsiones o texto poco claro.",
      "useCases": [
        {
          "title": "Foto del teléfono para escanear",
          "desc": "Elimine los fondos del escritorio y corrija los ángulos de la cámara para que las fotos del teléfono parezcan más escaneadas."
        },
        {
          "title": "Contratos y formularios",
          "desc": "Contratos de recorte, aplicaciones y formularios para restaurar bordes limpios y proporciones de página."
        },
        {
          "title": "Recibos y Facturas",
          "desc": "Reduzca las sombras y mejore el texto impreso tenue para verlo y archivarlo con mayor claridad."
        },
        {
          "title": "Páginas de libros curvas",
          "desc": "Corrija la curvatura cerca de las encuadernaciones de libros de texto, libros y cuadernos de trabajo."
        },
        {
          "title": "Documentos de prueba y hojas de trabajo",
          "desc": "Enderece los papeles de prueba, elimine las sombras y mejore el texto impreso para reutilizarlo o imprimirlo."
        },
        {
          "title": "Archivos en blanco y negro",
          "desc": "Convierta fotografías de documentos en estilos de escaneo consistentes en blanco y negro o en escala de grises."
        }
      ],
      "faqTitle": "Preguntas frecuentes sobre corrección y recorte de documentos con IA",
      "faqs": [
        {
          "q": "¿Qué es el recorte y la corrección de documentos con IA?",
          "a": "Detecta el área del documento, elimina el fondo circundante y puede corregir la distorsión de la página inclinada, la perspectiva o la curvatura según su configuración."
        },
        {
          "q": "¿Cómo recorto automáticamente imágenes de documentos escaneados en línea?",
          "a": "Habilite el recorte de bordes y luego cargue la imagen del documento escaneado. La herramienta intenta detectar el límite del papel y eliminar el área fuera del documento."
        },
        {
          "q": "¿Puedo alinear un documento escaneado en línea?",
          "a": "Sí. Utilice el enderezamiento para un escaneo inclinado y la corrección de perspectiva para una foto de teléfono en ángulo. Utilice la corrección de distorsión solo cuando la página en sí esté curvada."
        },
        {
          "q": "¿Cuál es la diferencia entre los modos de sombreado y enfoque?",
          "a": "Deshadow mejora la iluminación desigual de la página, mientras que la nitidez fortalece el texto y los bordes de las líneas. Elija el modo que coincida con el problema fuente."
        },
        {
          "q": "¿Qué herramienta puedo utilizar para mejorar los exámenes, contratos y recibos escaneados?",
          "a": "Utilice esta herramienta de mejora y recorte de documentos con sombreado para iluminación desigual, enfoque para texto tenue y blanco y negro o escala de grises al preparar documentos para imprimir."
        },
        {
          "q": "¿Puede convertir una foto de un teléfono en un documento escaneado?",
          "a": "Recortar, corregir y mejorar puede producir una imagen similar a la de un escaneo, pero la herramienta no genera archivos PDF ni extrae texto OCR."
        },
        {
          "q": "¿Qué formatos de imagen y tamaños de archivo son compatibles?",
          "a": "Se admiten imágenes JPG, PNG y WebP, con un tamaño de archivo máximo de 15 MB."
        },
        {
          "q": "¿El procesamiento cambia el contenido del documento original?",
          "a": "La herramienta ajusta el encuadre, la geometría, el brillo y la claridad. No edita texto ni extrae el contenido del documento."
        }
      ],
      "education": {
        "kicker": "DOCUMENTOS EDUCATIVOS",
        "title": "Convierta exámenes, tareas y fotografías de libros de texto en escaneos claros",
        "intro": "Detecte automáticamente los bordes de los documentos educativos y corrija la inclinación, la perspectiva, las páginas curvas y las sombras para una impresión, un archivo y un uso más limpios en el aula.",
        "items": [
          {
            "title": "Fotos de papel de prueba de cultivos",
            "desc": "Detecte los bordes del papel de prueba y elimine el fondo del escritorio para crear una página limpia y con el marco adecuado."
          },
          {
            "title": "Imágenes correctas de la tarea",
            "desc": "Corrija la inclinación y la perspectiva en las fotografías de las tareas para que sean más fáciles de revisar, enviar e imprimir."
          },
          {
            "title": "Dewarp páginas de libros de texto",
            "desc": "Corrija las páginas curvas cerca de las encuadernaciones de libros y reduzca las sombras que dificultan la lectura del contenido impreso."
          },
          {
            "title": "Mejorar las hojas de trabajo del aula",
            "desc": "Ilumine y mejore las hojas de trabajo o los materiales de estudio con efectos de escaneo limpios en blanco y negro o en escala de grises."
          }
        ],
        "relatedTitle": "¿Necesita eliminar las respuestas escritas a mano de un examen?",
        "relatedDesc": "Esta herramienta se encarga del recorte, la corrección geométrica y la mejora de la imagen. Utilice el borrador de escritura a mano para eliminar las respuestas de los estudiantes, los cálculos o las anotaciones del profesor.",
        "relatedCta": "Borrador de escritura abierta"
      }
    },
    "handwritten-erase": {
      "name": "Borrador de Escritura a Mano",
      "desc": "Borra texto manuscrito de documentos con IA.",
      "fullDesc": "Detecta y borra automáticamente texto escrito a mano de documentos preservando contenido impreso. Perfecto para exámenes, notas, contratos, etc. Soporta recorte, corrección, rotación, etc.",
      "docDirection": "Rotación",
      "docDirections": {
        "none": "Sin Rotación",
        "rotate90": "90° Horario",
        "rotate180": "180° Horario",
        "rotate270": "270° Horario",
        "auto": "Detectar Automáticamente"
      },
      "crop": "Recortar Bordes",
      "dewarp": "Corregir deformación",
      "notImageFile": "Por favor sube un archivo de imagen válido",
      "fileTooLarge": "Imagen demasiado grande, selecciona una imagen menor de 15MB",
      "noImageInResponse": "Procesamiento fallido, inténtelo de nuevo",
      "downloadName": "escritura-borrada.png",
      "featuresKicker": "Eliminación de escritura a mano de documentos",
      "featuresTitle": "Eliminar escritura a mano y restaurar documentos limpios",
      "featuresIntro": "Limpie las respuestas escritas a mano, las revisiones de contratos, las notas de revisión y las marcas de documentos escaneados mientras conserva el texto impreso y el diseño original.",
      "features": [
        {
          "title": "Eliminar las respuestas de los estudiantes de los exámenes",
          "desc": "Detecte automáticamente respuestas escritas a mano, cálculos y anotaciones en exámenes completados.",
          "cta": "Respuestas en papel de prueba limpio gratis"
        },
        {
          "title": "Borrar escritura a mano de los contratos",
          "desc": "Limpie las adiciones escritas a mano, los círculos, las cantidades modificadas, las flechas y revise las notas mientras conserva las cláusulas, las tablas y el diseño impresos.",
          "cta": "Escritura limpia de contratos en línea"
        },
        {
          "title": "Preparar y reimprimir pruebas para la enseñanza",
          "desc": "Limpia las respuestas de los estudiantes y las anotaciones de los profesores para las lecciones, la preparación de exámenes y el archivo de documentos.",
          "cta": "Pruebe el limpiador de papel Teacher Test"
        },
        {
          "title": "Limpiar marcas escritas a mano de documentos escaneados",
          "desc": "Elimine marcas, flechas, círculos, notas al margen y marcas de revisión de formularios escaneados, informes de inspección y documentos de oficina.",
          "cta": "Limpiar marcas de documentos escaneados"
        }
      ],
      "useCasesKicker": "Para estudiantes y profesores",
      "useCasesTitle": "Casos de uso en educación para la eliminación de escritura a mano mediante IA",
      "useCases": [
        {
          "title": "Eliminación de respuesta de prueba",
          "desc": "Borre las respuestas y cálculos de los estudiantes de los exámenes."
        },
        {
          "title": "Revisión de errores",
          "desc": "Restaura los trabajos completados para otra ronda de práctica."
        },
        {
          "title": "Limpieza del libro de trabajo",
          "desc": "Elimine el contenido escrito a mano de las tareas y hojas de trabajo."
        },
        {
          "title": "Enseñanza y preparación de exámenes",
          "desc": "Cree documentos limpios para lecciones, reimpresión y archivo."
        },
        {
          "title": "Corrección del papel escaneado",
          "desc": "Gire, recorte y corrija imágenes de documentos torcidas o curvas."
        },
        {
          "title": "Limpieza de contratos y notas",
          "desc": "Elimine la escritura a mano y las anotaciones de documentos generales."
        }
      ],
      "howToKicker": "Tres sencillos pasos",
      "howToTitle": "Cómo eliminar respuestas escritas a mano de exámenes en línea",
      "howToIntro": "Cargue un documento o papel de prueba, configure las opciones de rotación, recorte y corrección de distorsión y luego descargue el resultado limpio.",
      "steps": {
        "upload": {
          "title": "Cargar un examen o documento",
          "desc": "Cargue un documento de prueba, una hoja de tarea o un documento escaneado en formato JPG, PNG o WebP de menos de 15 MB."
        },
        "process": {
          "title": "Configurar y eliminar escritura a mano",
          "desc": "Elija la dirección del documento y habilite el recorte o la corrección de distorsión según sea necesario, luego comience a procesar."
        },
        "download": {
          "title": "Revisar y descargar",
          "desc": "Compare las imágenes de antes y después, descargue el documento limpio o procese otra imagen."
        }
      },
      "faqTitle": "Preguntas frecuentes sobre el eliminador de respuestas del papel de prueba AI",
      "faqs": [
        {
          "q": "¿Qué herramienta puedo utilizar para eliminar las respuestas escritas a mano de los exámenes?",
          "a": "El eliminador de escritura a mano de Miral AI detecta respuestas, cálculos y anotaciones escritas a mano mientras conserva las preguntas impresas y el diseño original siempre que sea posible."
        },
        {
          "q": "¿Puede la IA eliminar la escritura a mano conservando el texto impreso?",
          "a": "Puede restaurar un papel limpio y al mismo tiempo preservar el texto impreso cuando la escritura a mano no se superpone demasiado al contenido impreso."
        },
        {
          "q": "¿Pueden los profesores limpiar y reimprimir los exámenes?",
          "a": "Sí. Es adecuado para la preparación de lecciones, explicaciones en el aula, creación de exámenes y archivo de documentos."
        },
        {
          "q": "¿Pueden los estudiantes restablecer los trabajos respondidos para su revisión?",
          "a": "Sí. Los exámenes y hojas de trabajo limpios se pueden reutilizar para revisar errores y practicar más."
        },
        {
          "q": "¿Cómo borro notas escritas a mano, marcas de bolígrafo y anotaciones en tinta roja?",
          "a": "Cargue la imagen del documento y ejecute el eliminador de escritura a mano. Puede procesar diferentes colores de escritura a mano y herramientas de escritura, aunque los resultados dependen de la claridad y se superponen con el texto impreso."
        },
        {
          "q": "¿Cómo soluciono un escaneo torcido o curvo antes de eliminar la escritura a mano?",
          "a": "Primero alinee o gire un escaneo inclinado. Utilice el recorte para el exceso de fondo y la corrección de distorsión solo para páginas genuinamente curvas antes de procesar la escritura a mano."
        },
        {
          "q": "¿Qué formatos de imagen son compatibles?",
          "a": "Se admiten imágenes JPG, PNG y WebP de menos de 15 MB. Los archivos PDF no son compatibles con esta página."
        }
      ]
    },
    "ai-change-clothes": {
      "name": "Cambiador de ropa IA",
      "desc": "Sube ropa y persona, cambio de outfit en un clic",
      "fullDesc": "Sube primero la imagen de ropa y luego la imagen de persona. La IA transfiere la prenda seleccionada al retrato, preservando la persona, la pose y los detalles naturales de la imagen.",
      "demoTitle": "Demo",
      "notImageFile": "Por favor sube un archivo de imagen válido.",
      "fileTooLarge": "Imagen demasiado grande, por favor selecciona una imagen menor de 15MB.",
      "firstImageLabel": "Imagen de ropa",
      "uploadFirstImage": "Subir imagen de ropa",
      "changeFirstImage": "Cambiar imagen de ropa",
      "secondImageLabel": "Imagen de persona",
      "uploadSecondImage": "Subir imagen de persona",
      "changeSecondImage": "Cambiar imagen de persona",
      "uploadingSecondImage": "Subiendo imagen de persona...",
      "downloadName": "ropa-cambiada-ia.png"
    },
    "category": {
      "image": "Procesamiento de imagen",
      "video": "Procesamiento de vídeo",
      "document": "Procesamiento de documento"
    },
    "categoryModal": {
      "title": "Seleccionar categoría de herramienta"
    },
    "convert": {
      "success": "¡Conversión completada!",
      "zipHint": "El resultado está empaquetado como un archivo ZIP que contiene múltiples imágenes",
      "fileTooLarge": "Archivo demasiado grande, seleccione un archivo menor a 50MB",
      "demoTitle": "Vista previa de conversión",
      "sourceLabel": "Formato origen",
      "targetLabel": "Formato de salida"
    },
    "pdf-to-word": {
      "name": "PDF a Word",
      "desc": "Convertir archivos PDF a documentos Word editables",
      "fullDesc": "Convertir inteligentemente archivos PDF a documentos Word editables, preservando con precisión el diseño, tablas, imágenes y más."
    },
    "image-to-word": {
      "name": "Imagen a Word",
      "desc": "Convertir texto en imágenes a documentos Word",
      "fullDesc": "Reconocer inteligentemente texto, tablas y otros contenidos en imágenes y convertirlos a documentos Word, preservando el formato original."
    },
    "pdf-to-excel": {
      "name": "PDF a Excel",
      "desc": "Convertir tablas PDF a archivos Excel editables",
      "fullDesc": "Reconocer inteligentemente el contenido de tablas en archivos PDF y convertirlos a archivos Excel editables."
    },
    "pdf-to-ppt": {
      "name": "PDF a PPT",
      "desc": "Convertir archivos PDF a presentaciones PPT editables",
      "fullDesc": "Convertir inteligentemente archivos PDF a presentaciones PPT editables, preservando el diseño, imágenes y texto originales."
    },
    "pdf-to-image": {
      "name": "PDF a Imagen",
      "desc": "Convertir cada página PDF a imágenes de alta calidad",
      "fullDesc": "Convertir cada página de un archivo PDF a imágenes de alta calidad. Soporta conversión por lotes de PDF multipágina."
    },
    "word-to-pdf": {
      "name": "Word a PDF",
      "desc": "Convertir documentos Word a archivos PDF",
      "fullDesc": "Convertir rápidamente documentos Word a archivos PDF, preservando el diseño, fuentes e imágenes originales."
    },
    "excel-to-pdf": {
      "name": "Excel a PDF",
      "desc": "Convertir hojas de cálculo Excel a archivos PDF",
      "fullDesc": "Convertir hojas de cálculo Excel a archivos PDF, preservando la estructura de tablas y el diseño de datos."
    },
    "image-to-pdf": {
      "name": "Imagen a PDF",
      "desc": "Fusionar múltiples imágenes en un solo archivo PDF",
      "fullDesc": "Fusionar múltiples imágenes en un solo archivo PDF. Soporta formatos de imagen comunes como JPG, PNG y BMP."
    },
    "word-to-image": {
      "name": "Word a Imagen",
      "desc": "Convertir cada página de documento Word a imagen",
      "fullDesc": "Convertir cada página de un documento Word a imágenes de alta calidad. Soporta conversión por lotes de documentos multipágina."
    }
  },
  "musicTags": {
    "pop": "Pop",
    "electronic": "Electrónica",
    "classical": "Clásica",
    "jazz": "Jazz"
  },
  "faq": {
    "categories": {
      "all": "Todas",
      "general": "General",
      "pricing": "Precios",
      "models": "Modelos",
      "features": "Características"
    },
    "items": [
      {
        "q": "¿Qué es Miral?",
        "a": "Miral es una plataforma de creación IA todo en uno que integra 29+ modelos IA de primera clase, soportando generación de imágenes, creación de video, producción musical y herramientas de edición profesional. No hay necesidad de cambiar entre plataformas - una cuenta te da acceso a todos los modelos principales incluyendo FLUX, Midjourney, Sora, Veo, Kling y más."
      },
      {
        "q": "¿Qué modelos IA son compatibles?",
        "a": "Soportamos 29+ modelos IA de primera clase, incluyendo modelos de imagen (FLUX 2 Max, Midjourney, Seedream, GPT-Image-1, Nano Banana, etc.), modelos de video (Veo 3.1, Sora 2, Kling 2.6, Seedance, Wan 2.5, etc.) y modelos de generación de música IA. Todos los modelos se actualizan continuamente."
      },
      {
        "q": "¿Cómo funciona el sistema de créditos?",
        "a": "Utilizamos un sistema de créditos unificado. La generación de imágenes comienza desde 2 créditos, la generación de video desde 10 créditos y la música desde 10 créditos por pista. Los modelos premium pueden consumir más créditos. Los suscriptores disfrutan de tasas de crédito más bajas y también pueden comprar paquetes de créditos por separado."
      },
      {
        "q": "¿Puedo generar imágenes, videos y música?",
        "a": "¡Sí! Miral soporta texto-imagen, edición de imagen, transferencia de estilo, texto-video, imagen-video, creación musical IA y más, satisfaciendo todas las necesidades creativas desde proyectos personales hasta trabajo comercial."
      },
      {
        "q": "¿Qué tan rápida es la generación?",
        "a": "La mayor parte de la generación de imágenes se completa dentro de 30 segundos, la generación de video toma aproximadamente 1-6 minutos. Continuamos optimizando nuestra infraestructura para garantizar generación rápida y estable."
      },
      {
        "q": "¿Puedo usar Miral para propósitos comerciales?",
        "a": "Sí. Todos los planes de pago incluyen licencias comerciales, permitiéndote usar contenido generado para proyectos comerciales, materiales de marketing, redes sociales y más."
      },
      {
        "q": "¿Hay acceso API disponible?",
        "a": "Sí, el plan Último incluye acceso API. A través de nuestra API completa, puede integrar generación de imágenes, videos y música IA directamente en sus aplicaciones."
      },
      {
        "q": "¿Puedo generar música con IA?",
        "a": "¡Absolutamente! Nuestro generador de música IA soporta varios estilos musicales. Simplemente describe lo que quieres para generar música original, perfecta para pistas de video, música de fondo de podcasts, etc."
      },
      {
        "q": "¿Cómo manejan la privacidad y seguridad de datos?",
        "a": "Cumplimos estrictamente los estándares de cumplimiento GDPR. Todos los datos están encriptados y no se usan para entrenamiento IA. Los usuarios pueden eliminar su cuenta y todos los datos en cualquier momento."
      },
      {
        "q": "¿Otros pueden ver mis trabajos?",
        "a": "Por defecto, tus trabajos solo son visibles para ti. Los usuarios Pro y Ultimate pueden habilitar modo de privacidad para asegurar privacidad completa."
      },
      {
        "q": "¿Cómo puedo eliminar mi cuenta y datos?",
        "a": "Puedes solicitar la eliminación de la cuenta en tu configuración de cuenta en cualquier momento. Eliminaremos todos tus datos y contenido generado dentro de 30 días."
      },
      {
        "q": "¿Puedo obtener soporte si encuentro problemas?",
        "a": "¡Por supuesto! Puedes contactar nuestro equipo de soporte en miral_support@miralvis.com. Los usuarios Pro obtienen soporte prioritario, los usuarios Ultimate obtienen soporte dedicado."
      }
    ]
  },
  "testimonials": {
    "items": [
      {
        "name": "Alex Chen",
        "role": "Director de Marketing Digital",
        "tag": "Ahorra 90% Tiempo",
        "content": "Miral se ha convertido en nuestro centro de contenido visual. Genera imágenes de producto con Midjourney, crea videos promocionales con Veo, luego edita todo en Miral - todo sin cambiar plataformas."
      },
      {
        "name": "Sarah Rodriguez",
        "role": "Propietario de Comercio Electrónico",
        "tag": "40% Más Conversión",
        "content": "Tener acceso a 29+ modelos en un solo lugar es increíble. Uso Seedream para fotos de producto, Seedance para anuncios de video, y las herramientas de escalado para catálogos. ¡La conversión aumentó un 40%!"
      },
      {
        "name": "David Kim",
        "role": "Creador de Contenido",
        "tag": "Más de 500K Seguidores",
        "content": "Creo imágenes con FLUX y Nano Banana, luego las convierto en videos virales con Kling y Sora. El sistema de créditos es justo - paga por uso. ¡A mis seguidores les encanta este contenido variado!"
      },
      {
        "name": "Emma Thompson",
        "role": "Diseñador Gráfico",
        "tag": "Calidad Profesional",
        "content": "Como diseñador, era escéptico sobre las plataformas IA. Pero la rica biblioteca de modelos y herramientas de edición precisas de Miral es realmente impresionante - desde bocetos conceptuales hasta productos finales, todo es fácil."
      },
      {
        "name": "James Wilson",
        "role": "Productor de Video",
        "tag": "Flujo de Trabajo 10x Más Rápido",
        "content": "Los modelos de video aquí son increíbles - Veo es cinematográfico, Seedance es rápido, y la animación de personajes de Wan es natural. Todos los modelos comparten un sistema de créditos - ahorra tiempo y dinero."
      },
      {
        "name": "Lisa Park",
        "role": "Propietario de Agencia Creativa",
        "tag": "Elección del Equipo",
        "content": "Todo nuestro equipo ha cambiado a Miral. La integración API es suave, y la variedad de modelos significa que siempre encontramos la herramienta adecuada. Esta es la mejor plataforma IA disponible."
      }
    ]
  },
  "langModal": {
    "title": "Seleccionar Idioma"
  },
  "modelDetail": {
    "breadcrumb": {
      "home": "Inicio",
      "models": "Modelos"
    },
    "model": "Modelo",
    "modelVersion": "Versión del Modelo",
    "standard": "Estándar",
    "pro": "Pro",
    "standardDesc": "Calidad estándar, generación rápida",
    "proDesc": "Alta calidad, soporta alta resolución",
    "credits": "créditos",
    "imagePrompt": "Prompt de Imagen",
    "imagePromptPlaceholder": "Describe la imagen que deseas generar...",
    "videoPrompt": "Prompt de Video",
    "videoPromptPlaceholder": "Describe el video que deseas generar...",
    "referenceImage": "Imagen de referencia",
    "aspectRatio": "Relación de aspecto",
    "thinkingLevel": "Nivel de razonamiento",
    "thinkingMinimal": "Baja latencia",
    "thinkingHigh": "Alta fidelidad",
    "characters": "caracteres",
    "imageSize": "Tamaño de Imagen",
    "auto": "Auto",
    "resolution": "Resolución",
    "duration": "Duración",
    "seconds": "segundos",
    "creditsRequired": "Créditos Requeridos:",
    "creditsRemaining": "Restantes:",
    "remaining": "Restantes:",
    "generate": "Generar",
    "getMoreCredits": "Obtener más créditos",
    "generating": "Generando...",
    "demoPrompt": "Prompt de Demostración",
    "modelLabel": "Modelo:",
    "version": "Versión:",
    "size": "Tamaño:",
    "download": "Descargar",
    "regenerate": "Regenerar",
    "noHistory": "Sin historial de generación",
    "features": {
      "badge": "Características Principales",
      "title": "¿Qué puede hacer este modelo?",
      "items": {
        "realistic": {
          "icon": "📷",
          "title": "Estilo Realista",
          "desc": "Genera imágenes fotorrealistas con iluminación natural y detalles."
        },
        "artistic": {
          "icon": "🎨",
          "title": "Estilo Artístico",
          "desc": "Crea imágenes artísticas con varios estilos de pintura."
        },
        "portrait": {
          "icon": "👤",
          "title": "Retrato",
          "desc": "Fotografía de retrato profesional con tonos de piel naturales."
        },
        "landscape": {
          "icon": "🏔️",
          "title": "Paisaje",
          "desc": "Fotografía impresionante de paisajes y naturaleza."
        },
        "product": {
          "icon": "📦",
          "title": "Producto",
          "desc": "Fotografía de producto de alta calidad para comercio electrónico."
        },
        "fast": {
          "icon": "⚡",
          "title": "Generación Rápida",
          "desc": "La mayoría de las imágenes generadas en 10-30 segundos."
        },
        "highRes": {
          "icon": "🖼️",
          "title": "Alta Resolución",
          "desc": "Soporta salida de resolución hasta 4K."
        },
        "cinematic": {
          "icon": "🎬",
          "title": "Cinematográfico",
          "desc": "Crea videos cinematográficos con trabajo de cámara profesional."
        },
        "audioSync": {
          "icon": "🔊",
          "title": "Sincronización de Audio",
          "desc": "Sincronización audiovisual nativa para videos."
        },
        "lipSync": {
          "icon": "👄",
          "title": "Sincronización Labial",
          "desc": "Sincronización labial precisa para videos de personajes."
        },
        "animation": {
          "icon": "🎭",
          "title": "Animación",
          "desc": "Animación de personajes suave y movimiento natural."
        },
        "longVideo": {
          "icon": "⏱️",
          "title": "Video Largo",
          "desc": "Soporte para duraciones de video más largas."
        },
        "privacy": {
          "icon": "🔒",
          "title": "Privacidad y seguridad",
          "desc": "Todos los datos están encriptados en tránsito y no se usan para entrenamiento IA. Tus creaciones te pertenecen."
        }
      }
    },
    "whyChoose": {
      "items": [
        "Creación inteligente potenciada por {name}",
        "Completa tareas creativas complejas rápida y eficientemente",
        "El contenido generado puede usarse comercialmente",
        "Actualizaciones continuas y capacidades mejoradas",
        "Sistema de créditos unificado, paga por uso"
      ]
    },
    "faq": {
      "title": "Preguntas Frecuentes",
      "imageType": "imágenes",
      "videoType": "videos",
      "imageFormats": "Se admiten formatos de salida PNG, JPEG y WebP; elige lo que se ajuste a tu flujo de trabajo.",
      "videoFormats": "Los videos se entregan como MP4 con opciones 480p y 720p y múltiples relaciones de aspecto.",
      "items": [
        {
          "q": "¿Cómo funciona {name}?",
          "a": "Sube una referencia o ingresa un prompt de texto — {name} genera {type} de alta calidad basado en tu entrada. El proceso es simple y no necesita habilidades expertas."
        },
        {
          "q": "¿Puedo usar {type} generados comercialmente?",
          "a": "Sí. El contenido de {name} puede usarse comercialmente, incluyendo marketing, redes sociales y uso de productos."
        },
        {
          "q": "¿Cuántos créditos por generación?",
          "a": "Cada generación con {name} usa {credits} créditos. Los suscriptores obtienen mejores tasas de crédito."
        },
        {
          "q": "¿Qué tan rápida es la generación?",
          "a": "La velocidad típica para {name} es {speed}. Seguimos optimizando para resultados confiables y rápidos."
        },
        {
          "q": "¿Qué formatos de salida son compatibles?",
          "a": ""
        }
      ]
    },
    "qwenImage20Pro": {
      "negativePromptLabel": "Prompt negativo (opcional)",
      "negativePromptPlaceholder": "Describe lo que no quieres que aparezca (por ejemplo: baja nitidez, manos deformes, etc.)",
      "customWidth": "Ancho",
      "customHeight": "Alto",
      "sizeHint": "Rango: 512×512 a 2048×2048",
      "sizeErrorRequired": "Introduce el ancho y la altura",
      "sizeErrorInteger": "El ancho y el alto deben ser enteros",
      "sizeErrorRange": "La resolución debe estar entre 512×512 y 2048×2048",
      "promptEnhanceTitle": "Mejora del prompt",
      "promptEnhanceDesc": "Mejora los detalles del prompt para obtener resultados más ricos",
      "watermarkTitle": "Marca de agua",
      "watermarkDesc": "Añade una marca de agua a las imágenes generadas",
      "demoPromptText": "Entre montañas nevadas, un niño con equipo de esquí y gafas desliza felizmente; la nieve se levanta en su estela, detrás se extienden crestas cubiertas de nieve.",
      "faqSizeSupportQ": "¿Qué tamaños son compatibles?",
      "faqSizeSupportA": "Introduce el ancho y alto dentro del rango 512~2048 (por ej. 2048*2048).",
      "faqMaxCountQ": "¿Cuántas imágenes se pueden generar como máximo en una sola solicitud?",
      "faqMaxCountA": "Hasta 4 imágenes (n=1..4).",
      "faqLinkUsageQ": "¿Cómo usar los enlaces de las imágenes después de la generación?",
      "faqLinkUsageA": "Primero descarga la URL temporal devuelta por DashScope, luego la sube a nuestro servidor y devuelve una URL accesible de larga duración."
    },
    "zImageTurbo": {
      "promptExtendTitle": "Mejora del prompt",
      "promptExtendDesc": "Mejora los detalles del prompt para obtener resultados más ricos",
      "customWidth": "Ancho",
      "customHeight": "Alto",
      "sizeHint": "Rango: 512×512 a 2048×2048",
      "sizeErrorRequired": "Introduce el ancho y la altura",
      "sizeErrorInteger": "El ancho y el alto deben ser enteros",
      "sizeErrorRange": "La resolución debe estar entre 512×512 y 2048×2048",
      "seedLabel": "Semilla",
      "seedErrorRequired": "Introduce una semilla",
      "seedErrorInteger": "La semilla debe ser un entero",
      "seedErrorRange": "El rango de la semilla debe estar entre 0 y 2147483647",
      "tagQuality": "Alta calidad",
      "tagOfficial": "Oficial directo",
      "tagHighRes": "Alta resolución",
      "tagSeed": "Control de semilla",
      "tagPromptExtend": "Mejora del prompt",
      "feature1Title": "Salida de alta calidad",
      "feature1Desc": "Genera imágenes de alta resolución y súbelas para obtener URLs de acceso a largo plazo.",
      "feature2Title": "Resolución personalizada",
      "feature2Desc": "Introduce ancho y alto dentro de 512–2048.",
      "feature3Title": "Generación controlable",
      "feature3Desc": "Soporta semilla y mejora del prompt para reproducibilidad y ajustes.",
      "demoPromptText": "En una arena dorada y fina, una hilera clara de huellas se adentra en el fondo del encuadre; los bordes tienen la textura húmeda de la arena, la superficie brilla bajo el sol y guía la mirada hacia un faro lejano.",
      "faqSizeSupportQ": "¿Qué tamaños son compatibles?",
      "faqSizeSupportA": "Introduce el ancho y alto dentro del rango 512~2048 (por ej. 1024*1536).",
      "faqSeedQ": "¿Para qué sirve la semilla (seed)?",
      "faqSeedA": "Con el mismo prompt y parámetros, la semilla ayuda a reproducir resultados similares.",
      "faqPromptExtendQ": "¿Qué es la mejora del prompt?",
      "faqPromptExtendA": "Cuando está habilitada, mejora los detalles del prompt para obtener resultados más ricos."
    }
  },
  "modelIntro": {
    "common": {
      "videoMode": "Modo de vídeo",
      "textToVideo": "Texto a vídeo",
      "imageToVideo": "Imagen a vídeo",
      "referenceImage": "Imagen de referencia",
      "referenceAudio": "Audio de referencia",
      "negativePrompt": "Prompt negativo",
      "duration": "Duración",
      "resolution": "Resolución",
      "aspectRatio": "Relación de aspecto",
      "seed": "Semilla",
      "generateAudio": "Generar audio",
      "watermark": "Añadir marca de agua",
      "endFrame": "Frame final",
      "promptEnhance": "Mejorar prompt",
      "promptExtend": "Extender prompt",
      "imageSize": "Tamaño de imagen",
      "imageCount": "Cantidad de imágenes",
      "style": "Estilo",
      "sizeMode": "Modo de tamaño",
      "width": "Ancho",
      "height": "Alto",
      "optional": "Opcional",
      "uploading": "Subiendo...",
      "clickToUpload": "Haz clic para subir",
      "quality": "Calidad",
      "qualityAuto": "Auto",
      "qualityLow": "Baja",
      "qualityMedium": "Media",
      "qualityHigh": "Alta",
      "multipleOf64Hint": "El ancho y la altura deben ser múltiplos de 64."
    },
    "seegen": {
      "aspectAdaptive": "Auto",
      "genMode": "Modo de generación",
      "modeStand": "Estándar",
      "modeSpeed": "Rápido"
    },
    "pollodance": {
      "variantLabel": "Variante del modelo",
      "card20": "2.0",
      "card20Fast": "2.0 FAST",
      "card20Ref": "2.0 REF",
      "card20FastRef": "2.0 FAST REF",
      "opt20Desc": "Control de movimiento avanzado, transferencia de estilo cinematográfico y generación industrial.",
      "opt20FastDesc": "Generación rápida y baja latencia.",
      "opt20RefDesc": "Referencias entre vídeos, transferencia de estilo y seguimiento del sujeto.",
      "opt20FastRefDesc": "Velocidad y referencias precisas.",
      "refImages": "Imágenes de referencia (varias)",
      "refVideo": "Vídeo de referencia",
      "refAudio": "Audio de referencia",
      "webSearch": "Búsqueda web"
    },
    "nanoBanana": {
      "version": "Versión del modelo",
      "title": "Generador de Imagen IA Nano Banana Pro",
      "desc": "Nano Banana es un modelo de generación de imagen IA de alto rendimiento que soporta generación de imágenes de estilo realista, destacando en retratos y escenas naturales. Disponible en versiones Estándar y Pro para satisfacer diferentes necesidades.",
      "v25Type": "Baja latencia",
      "v25TypeBadge": "Rápido",
      "v25TypeDesc": "Resolución fija 1024px, velocidad de generación rápida",
      "v31Type": "Alta fidelidad",
      "v31TypeBadge": "Alta calidad",
      "v31TypeDesc": "Soporta múltiples resoluciones 1K/2K/4K",
      "demoPrompt": "Retrato cinematográfico, luz de hora dorada, textura de piel natural, fondo bokeh suave",
      "multiSize": "Múltiples Tamaños",
      "multiSizeDesc": "Soporta auto, 1:1, 4:3, 3:4, 16:9, 9:16, 3:2, 2:3 y otros tamaños de imagen.",
      "featuresDesc": "Nano Banana proporciona capacidades de generación de imágenes de alta calidad con múltiples opciones de tamaño y resolución.",
      "flexiblePricing": "Precios Flexibles",
      "flexiblePricingDesc": "Estándar 5 créditos, Pro 20 créditos, elige según necesites.",
      "commercial": "Licencia Comercial",
      "commercialDesc": "Todas las imágenes generadas pueden usarse para propósitos comerciales.",
      "enterPrompt": "Por favor ingresa un prompt",
      "generateFailed": "Generación fallida",
      "requestFailed": "Solicitud fallida, inténtalo de nuevo",
      "faq": [
        {
          "q": "¿Cuál es la diferencia entre las versiones Estándar y Pro?",
          "a": "La versión Estándar es adecuada para generación rápida de imágenes de calidad estándar, consumiendo 5 créditos. La versión Pro soporta resoluciones más altas (1K/2K/4K) con mejor calidad de imagen, consumiendo 20 créditos."
        },
        {
          "q": "¿Cómo funciona Nano Banana?",
          "a": "Simplemente ingresa una descripción de texto, y el modelo Nano Banana generará imágenes de estilo realista de alta calidad basadas en tu prompt."
        },
        {
          "q": "¿Qué tamaños de imagen son compatibles?",
          "a": "Soporta auto, 1:1 (cuadrado), 4:3, 3:4, 16:9 (horizontal), 9:16 (vertical), 3:2, 2:3 y otros tamaños."
        },
        {
          "q": "¿Pueden usarse las imágenes generadas comercialmente?",
          "a": "Sí, todo el contenido generado usando Nano Banana puede usarse para propósitos comerciales."
        }
      ]
    },
    "nanoBanana2": {
      "genType": "Versión de generación"
    },
    "seedream": {
      "title": "Generador de Imagen IA Seedream 4",
      "desc": "Seedream 4 es un modelo de generación de imagen IA avanzado que se especializa en imágenes artísticas y creativas. Perfecto para ilustraciones, arte conceptual y visuales estilizados.",
      "webSearch": "Búsqueda Web",
      "webSearchDesc": "Habilita búsqueda web para información de referencia más precisa",
      "watermark": "Añadir marca de agua",
      "watermarkDesc": "Añade marca de agua a las imágenes generadas",
      "sizeModeResolution": "Por resolución",
      "sizeModeCustom": "Tamaño personalizado",
      "customWidth": "Ancho",
      "customHeight": "Alto",
      "sizeHint": "Área 1024×1024–4096×4096, relación de aspecto 1/16–16",
      "sizeErrorArea": "El área debe estar entre 1024×1024 y 4096×4096",
      "sizeErrorRatio": "La relación de aspecto debe estar entre 1/16 y 16",
      "demoPromptExample": "La luz lateral de la tarde ilumina la tienda de campaña, con la textura rugosa de la lona claramente visible. Un Pastor Alemán yace dentro; su dueño se agacha para estrecharle la mano.",
      "features": [
        {
          "icon": "🎨",
          "title": "Estilo Artístico",
          "desc": "Genera imágenes artísticas impresionantes con varios estilos de pintura e ilustración."
        },
        {
          "icon": "🖼️",
          "title": "Alta Resolución",
          "desc": "Soporta hasta resolución 4K para arte detallado."
        },
        {
          "icon": "⚡",
          "title": "Generación Rápida",
          "desc": "La mayoría de las imágenes generadas en 15 segundos."
        },
        {
          "icon": "🎭",
          "title": "Transferencia de Estilo",
          "desc": "Aplica varios estilos artísticos a tus creaciones."
        },
        {
          "icon": "📐",
          "title": "Múltiples Tamaños",
          "desc": "Soporta varias relaciones de aspecto para diferentes necesidades."
        },
        {
          "icon": "💼",
          "title": "Licencia Comercial",
          "desc": "Todas las imágenes generadas pueden usarse para propósitos comerciales."
        }
      ],
      "faq": [
        {
          "q": "¿Para qué es mejor Seedream 4?",
          "a": "Seedream 4 sobresale en generar imágenes artísticas y creativas, incluyendo ilustraciones, arte conceptual y visuales estilizados."
        },
        {
          "q": "¿Cuántos créditos cuesta cada generación?",
          "a": "Usar Seedream 4 cuesta 8 créditos por generación. Puedes obtener mejores tasas de crédito a través de planes de suscripción."
        },
        {
          "q": "¿Qué estilos son compatibles?",
          "a": "Seedream 4 soporta varios estilos artísticos incluyendo pintura al óleo, acuarela, arte digital, anime y más."
        },
        {
          "q": "¿Pueden usarse las imágenes generadas comercialmente?",
          "a": "Sí, todo el contenido generado usando Seedream 4 puede usarse para propósitos comerciales."
        }
      ]
    },
    "midjourney": {
      "title": "Generador de Imagen IA Midjourney",
      "desc": "Midjourney es un modelo de generación de imagen IA líder conocido por su excepcional calidad artística y capacidades creativas. Perfecto para arte profesional y proyectos creativos.",
      "referenceBoxTitle": "Añade imágenes de referencia para imagen a imagen",
      "referenceBoxSubtitle": "Soporta PNG, JPEG, WEBP (máx 100KB). Hasta 5 imágenes. Menos imágenes, resultados más precisos.",
      "demoPrompt": "Una isla mística flotante en el cielo, ruinas antiguas cubiertas de cristales brillantes, cascadas fluyendo hacia las nubes abajo, iluminación etérea, estilo de arte de fantasía",
      "referenceImages": "Imágenes de referencia",
      "referenceImagesCount": "Hasta 5",
      "refImageMaxSize": "Cada imagen no debe exceder 100KB",
      "style": "Estilo",
      "styleRealistic": "Realista",
      "styleAnime": "Anime",
      "generationSpeed": "Velocidad de Generación",
      "fastDesc": "Generación de velocidad estándar",
      "turboDesc": "Generación rápida, procesamiento prioritario",
      "creative": "Creativo",
      "highQuality": "Alta Calidad",
      "fastTurbo": "Rápido/Turbo",
      "creativeGeneration": "Generación Creativa",
      "speed": "Velocidad",
      "features": [
        {
          "icon": "🎨",
          "title": "Excelencia Artística",
          "desc": "Calidad artística y salida creativa líderes en la industria."
        },
        {
          "icon": "🖼️",
          "title": "Alta Resolución",
          "desc": "Genera imágenes de alta calidad adecuadas para uso profesional."
        },
        {
          "icon": "🎭",
          "title": "Estilos Únicos",
          "desc": "Estilos artísticos distintivos que diferencian tu trabajo."
        },
        {
          "icon": "⚡",
          "title": "Generación Rápida",
          "desc": "La mayoría de las imágenes generadas en 20 segundos."
        },
        {
          "icon": "📐",
          "title": "Múltiples Tamaños",
          "desc": "Soporta varias relaciones de aspecto y resoluciones."
        },
        {
          "icon": "💼",
          "title": "Licencia Comercial",
          "desc": "Todas las imágenes generadas pueden usarse para propósitos comerciales."
        }
      ],
      "faq": [
        {
          "q": "¿Cuál es la diferencia entre Rápido y Turbo?",
          "a": "El modo Rápido cuesta 10 créditos con velocidad estándar. El modo Turbo cuesta 20 créditos con generación más rápida y procesamiento prioritario."
        },
        {
          "q": "¿Cómo funciona Midjourney?",
          "a": "Simplemente ingresa una descripción de texto, y Midjourney generará imágenes artísticas basadas en tu prompt."
        },
        {
          "q": "¿Qué tamaños de imagen son compatibles?",
          "a": "Soporta 1:1 (cuadrado), 4:3, 3:4, 16:9 (horizontal), 9:16 (vertical), 3:2, 2:3 y otros tamaños."
        },
        {
          "q": "¿Pueden usarse las imágenes generadas comercialmente?",
          "a": "Sí, todo el contenido generado usando Midjourney puede usarse para propósitos comerciales."
        }
      ]
    },
    "gptImage": {
      "title": "Generador de Imagen IA GPT-Image-1",
      "desc": "GPT-Image-1 es el modelo de generación de imagen versátil de OpenAI, capaz de crear una amplia variedad de imágenes a partir de descripciones de texto. Excelente para generación de imágenes de uso general.",
      "demoPromptExample": "Campos toscanos al atardecer, colinas cubiertas de trigo dorado, cipreses y una antigua casa de campo de piedra en la distancia, el atardecer lanzando un brillo rojo cálido a través del cielo, cálido, sanador, fotografía de paisaje, hora dorada.",
      "imageCount": "Conteo de Imágenes",
      "promptEnhance": "Mejora de Prompt",
      "promptEnhanceDesc": "Optimiza automáticamente los prompts para mejores resultados de generación",
      "count": "Conteo",
      "multiPurpose": "Multipropósito",
      "batchGeneration": "Generación por Lotes",
      "size1024Square": "1024×1024 (cuadrado)",
      "size1536Landscape": "1536×1024 (horizontal)",
      "size1024Portrait": "1024×1536 (vertical)",
      "threeSizes": "Tres tamaños fijos",
      "tagQuality": "Alta calidad",
      "tagCommercialShort": "Uso comercial",
      "features": [
        {
          "icon": "🎨",
          "title": "Generación Versátil",
          "desc": "Crea una amplia variedad de imágenes para cualquier propósito."
        },
        {
          "icon": "🖼️",
          "title": "Alta Calidad",
          "desc": "Genera imágenes de alta calidad con detalles precisos."
        },
        {
          "icon": "⚡",
          "title": "Generación Rápida",
          "desc": "La mayoría de las imágenes generadas en 15 segundos."
        },
        {
          "icon": "📝",
          "title": "Comprensión de Texto",
          "desc": "Excelente comprensión de descripciones de texto complejas."
        },
        {
          "icon": "📐",
          "title": "Tres tamaños fijos",
          "desc": "1024×1024 (cuadrado), 1536×1024 (horizontal), 1024×1536 (vertical)."
        },
        {
          "icon": "💼",
          "title": "Licencia Comercial",
          "desc": "Todas las imágenes generadas pueden usarse para propósitos comerciales."
        }
      ],
      "faq": [
        {
          "q": "¿Cómo funciona GPT-Image-1?",
          "a": "Simplemente ingresa una descripción de texto, y GPT-Image-1 generará imágenes de alta calidad basadas en tu prompt."
        },
        {
          "q": "¿Qué tamaños de imagen son compatibles?",
          "a": "Soporta tres tamaños fijos: 1024×1024 (cuadrado), 1536×1024 (horizontal) y 1024×1536 (vertical)."
        },
        {
          "q": "¿Pueden usarse las imágenes generadas comercialmente?",
          "a": "Sí, todo el contenido generado usando GPT-Image-1 puede usarse para propósitos comerciales."
        }
      ]
    },
    "gptImage15": {
      "title": "Generador de Imagen IA GPT-Image-1.5",
      "desc": "GPT-Image-1.5 es el modelo de generación de imagen versátil de OpenAI, capaz de crear una amplia variedad de imágenes a partir de descripciones de texto. Excelente para generación de imágenes de uso general.",
      "demoPromptExample": "Campos toscanos al atardecer, colinas cubiertas de trigo dorado, cipreses y una antigua casa de campo de piedra en la distancia, el atardecer lanzando un brillo rojo cálido a través del cielo, cálido, sanador, fotografía de paisaje, hora dorada.",
      "imageCount": "Conteo de Imágenes",
      "promptEnhance": "Mejora de Prompt",
      "promptEnhanceDesc": "Optimiza automáticamente los prompts para mejores resultados de generación",
      "count": "Conteo",
      "multiPurpose": "Multipropósito",
      "batchGeneration": "Generación por Lotes",
      "size1024Square": "1024×1024 (cuadrado)",
      "size1536Landscape": "1536×1024 (horizontal)",
      "size1024Portrait": "1024×1536 (vertical)",
      "threeSizes": "Tres tamaños fijos",
      "tagQuality": "Alta calidad",
      "tagCommercialShort": "Uso comercial",
      "features": [
        {
          "icon": "🎨",
          "title": "Generación Versátil",
          "desc": "Crea una amplia variedad de imágenes para cualquier propósito."
        },
        {
          "icon": "🖼️",
          "title": "Alta Calidad",
          "desc": "Genera imágenes de alta calidad con detalles precisos."
        },
        {
          "icon": "⚡",
          "title": "Generación Rápida",
          "desc": "La mayoría de las imágenes generadas en 15 segundos."
        },
        {
          "icon": "📝",
          "title": "Comprensión de Texto",
          "desc": "Excelente comprensión de descripciones de texto complejas."
        },
        {
          "icon": "📐",
          "title": "Tres tamaños fijos",
          "desc": "1024×1024 (cuadrado), 1536×1024 (horizontal), 1024×1536 (vertical)."
        },
        {
          "icon": "💼",
          "title": "Licencia Comercial",
          "desc": "Todas las imágenes generadas pueden usarse para propósitos comerciales."
        }
      ],
      "faq": [
        {
          "q": "¿Cómo funciona GPT-Image-1.5?",
          "a": "Simplemente ingresa una descripción de texto, y GPT-Image-1.5 generará imágenes de alta calidad basadas en tu prompt."
        },
        {
          "q": "¿Qué tamaños de imagen son compatibles?",
          "a": "Soporta tres tamaños fijos: 1024×1024 (cuadrado), 1536×1024 (horizontal) y 1024×1536 (vertical)."
        },
        {
          "q": "¿Pueden usarse las imágenes generadas comercialmente?",
          "a": "Sí, todo el contenido generado usando GPT-Image-1.5 puede usarse para propósitos comerciales."
        }
      ]
    },
    "fluxKontext": {
      "title": "Generador de Imagen IA Flux Kontext",
      "desc": "Una joven sentada en un tejado a la hora dorada, llevando una chaqueta de denim oversized, auriculares blancos alrededor del cuello, bebiendo café helado de un vaso de plástico transparente. Su pelo corto y rizado sopla ligeramente con el viento mientras las luces de la ciudad comienzan a brillar a lo lejos.",
      "imageCount": "Conteo de Imágenes",
      "count": "Conteo",
      "demoPrompt1": "Una joven sentada en un tejado a la hora dorada, llevando una chaqueta de denim oversized, auriculares blancos alrededor del cuello, bebiendo café helado de un vaso de plástico transparente. Su pelo corto y rizado sopla ligeramente con el viento mientras las luces de la ciudad comienzan a brillar a lo lejos.",
      "demoPrompt2": "Un hombre en sus veinte años sentado en el suelo sucio de un estudio de arte, rodeado de lienzos sin terminar y tubos de pintura. Lleva un top blanco manchado de color y jeans rotos.",
      "demoPrompt3": "Una joven madre ajustando el gorro de su bebé mientras está sentada en una manta de picnic. Lleva un suéter crema y una falda de pana, descalza en la hierba.",
      "highQuality": "Alta Calidad",
      "fastGen": "Generación Rápida",
      "multiSize": "Múltiples Tamaños",
      "outputStyle": "Estilo de Salida",
      "outputStyleDesc": {
        "auto": "Predeterminado — el modelo determina automáticamente el estilo, sin aspecto forzado",
        "photographic": "Fotográfico — fotos realistas, luz y sombras naturales",
        "digital_art": "Arte Digital — aspecto de ilustración/CG, colores vívidos y ricos",
        "anime": "Anime — estilo de anime/manga japonés, líneas limpias"
      },
      "outputStyleLabel": {
        "auto": "Predeterminado",
        "photographic": "Fotográfico",
        "digital_art": "Arte Digital",
        "anime": "Anime"
      },
      "features": [
        {
          "icon": "✨",
          "title": "Salida de Alta Calidad",
          "desc": "Genera imágenes detalladas de alta fidelidad."
        },
        {
          "icon": "🎨",
          "title": "Texto a Imagen",
          "desc": "Genera con precisión imágenes a partir de descripciones de texto."
        },
        {
          "icon": "⚡",
          "title": "Generación Rápida",
          "desc": "La mayoría de las imágenes completan en unos 15 segundos."
        },
        {
          "icon": "📐",
          "title": "Múltiples Tamaños",
          "desc": "Soporte para relaciones de aspecto 1:1, 3:2, 2:3."
        },
        {
          "icon": "💼",
          "title": "Licencia Comercial",
          "desc": "Las imágenes generadas pueden usarse para propósitos comerciales."
        }
      ],
      "faq": [
        {
          "q": "¿Cómo funciona Flux Kontext?",
          "a": "Ingresa una descripción de texto; Flux Kontext genera imágenes de alta calidad y soporta una o múltiples imágenes por solicitud."
        },
        {
          "q": "¿Qué tamaños de imagen son compatibles?",
          "a": "Soporta 1:1 (cuadrado), 3:2 (horizontal), 2:3 (vertical)."
        },
        {
          "q": "¿Puedo generar múltiples imágenes a la vez?",
          "a": "Sí, puedes generar 1–3 imágenes, cada una facturada por separado."
        },
        {
          "q": "¿Pueden usarse las imágenes generadas comercialmente?",
          "a": "Sí, el contenido generado con Flux Kontext puede usarse para propósitos comerciales."
        }
      ]
    },
    "fluxPro11Ultra": {
      "title": "Generador de Imagen IA Flux Pro 1.1 Ultra",
      "desc": "Flux Pro 1.1 Ultra para texto a imagen de alta calidad con múltiples relaciones de aspecto y generación por lotes.",
      "imageCount": "Conteo de Imágenes",
      "count": "Conteo",
      "demoPrompt1": "Una joven sentada en un tejado a la hora dorada, llevando una chaqueta de denim oversized, auriculares blancos alrededor del cuello, bebiendo café helado de un vaso de plástico transparente. Su pelo corto y rizado sopla ligeramente con el viento mientras las luces de la ciudad comienzan a brillar a lo lejos.",
      "demoPrompt2": "Un hombre en sus veinte años sentado en el suelo sucio de un estudio de arte, rodeado de lienzos sin terminar y tubos de pintura. Lleva un top blanco manchado de color y jeans rotos.",
      "demoPrompt3": "Una joven madre ajustando el gorro de su bebé mientras está sentada en una manta de picnic. Lleva un suéter crema y una falda de pana, descalza en la hierba.",
      "highQuality": "Alta Calidad",
      "fastGen": "Generación Rápida",
      "multiSize": "Múltiples Tamaños",
      "outputStyle": "Estilo de Salida",
      "outputStyleDesc": {
        "auto": "Predeterminado — el modelo determina automáticamente el estilo, sin aspecto forzado",
        "photographic": "Fotográfico — fotos realistas, luz y sombras naturales",
        "digital_art": "Arte Digital — aspecto de ilustración/CG, colores vívidos y ricos",
        "anime": "Anime — estilo de anime/manga japonés, líneas limpias"
      },
      "outputStyleLabel": {
        "auto": "Predeterminado",
        "photographic": "Fotográfico",
        "digital_art": "Arte Digital",
        "anime": "Anime"
      },
      "features": [
        {
          "icon": "✨",
          "title": "Salida de Alta Calidad",
          "desc": "Genera imágenes detalladas de alta fidelidad."
        },
        {
          "icon": "🎨",
          "title": "Texto a Imagen",
          "desc": "Genera con precisión imágenes a partir de descripciones de texto."
        },
        {
          "icon": "⚡",
          "title": "Generación Rápida",
          "desc": "La mayoría de las imágenes completan en unos 15 segundos."
        },
        {
          "icon": "📐",
          "title": "Múltiples Tamaños",
          "desc": "Soporte para 21:9, 16:9, 4:3, 3:2, 1:1, 2:3, 3:4, 9:16, 9:21."
        },
        {
          "icon": "💼",
          "title": "Licencia Comercial",
          "desc": "Las imágenes generadas pueden usarse para propósitos comerciales."
        }
      ],
      "faq": [
        {
          "q": "¿Cómo funciona Flux Pro 1.1 Ultra?",
          "a": "Ingresa una descripción de texto para generar imágenes de alta calidad; soporta 1–4 imágenes por solicitud."
        },
        {
          "q": "¿Qué tamaños de imagen son compatibles?",
          "a": "Soporta 21:9, 16:9, 4:3, 3:2, 1:1, 2:3, 3:4, 9:16, 9:21."
        },
        {
          "q": "¿Puedo generar múltiples imágenes a la vez?",
          "a": "Sí, puedes generar 1–4 imágenes, cada una facturada por separado."
        },
        {
          "q": "¿Pueden usarse las imágenes generadas comercialmente?",
          "a": "Sí, el contenido puede usarse para propósitos comerciales."
        }
      ]
    },
    "fluxSchnell": {
      "title": "Generador de Imagen IA Flux Schnell",
      "desc": "Flux Schnell para texto a imagen rápido con múltiples relaciones de aspecto y generación por lotes.",
      "imageCount": "Conteo de Imágenes",
      "count": "Conteo",
      "demoPrompt1": "Una joven sentada en un tejado a la hora dorada, llevando una chaqueta de denim oversized, auriculares blancos alrededor del cuello, bebiendo café helado de un vaso de plástico transparente. Su pelo corto y rizado sopla ligeramente con el viento mientras las luces de la ciudad comienzan a brillar a lo lejos.",
      "demoPrompt2": "Un hombre en sus veinte años sentado en el suelo sucio de un estudio de arte, rodeado de lienzos sin terminar y tubos de pintura. Lleva un top blanco manchado de color y jeans rotos.",
      "demoPrompt3": "Una joven madre ajustando el gorro de su bebé mientras está sentada en una manta de picnic. Lleva un suéter crema y una falda de pana, descalza en la hierba.",
      "highQuality": "Alta Calidad",
      "fastGen": "Generación Rápida",
      "multiSize": "Múltiples Tamaños",
      "outputStyle": "Estilo de Salida",
      "outputStyleDesc": {
        "auto": "Predeterminado — el modelo determina automáticamente el estilo, sin aspecto forzado",
        "photographic": "Fotográfico — fotos realistas, luz y sombras naturales",
        "digital_art": "Arte Digital — aspecto de ilustración/CG, colores vívidos y ricos",
        "anime": "Anime — estilo de anime/manga japonés, líneas limpias"
      },
      "outputStyleLabel": {
        "auto": "Predeterminado",
        "photographic": "Fotográfico",
        "digital_art": "Arte Digital",
        "anime": "Anime"
      },
      "features": [
        {
          "icon": "✨",
          "title": "Salida de Alta Calidad",
          "desc": "Genera imágenes detalladas de alta fidelidad."
        },
        {
          "icon": "🎨",
          "title": "Texto a Imagen",
          "desc": "Genera con precisión imágenes a partir de descripciones de texto."
        },
        {
          "icon": "⚡",
          "title": "Generación Rápida",
          "desc": "La mayoría de las imágenes completan en unos 15 segundos."
        },
        {
          "icon": "📐",
          "title": "Múltiples Tamaños",
          "desc": "Soporte para 21:9, 16:9, 4:3, 3:2, 1:1, 2:3, 3:4, 9:16, 9:21."
        },
        {
          "icon": "💼",
          "title": "Licencia Comercial",
          "desc": "Las imágenes generadas pueden usarse para propósitos comerciales."
        }
      ],
      "faq": [
        {
          "q": "¿Cómo funciona Flux Schnell?",
          "a": "Ingresa una descripción de texto para generar rápidamente imágenes de alta calidad; soporta 1–4 imágenes por solicitud."
        },
        {
          "q": "¿Qué tamaños de imagen son compatibles?",
          "a": "Soporta 21:9, 16:9, 4:3, 3:2, 1:1, 2:3, 3:4, 9:16, 9:21."
        },
        {
          "q": "¿Puedo generar múltiples imágenes a la vez?",
          "a": "Sí, puedes generar 1–4 imágenes, cada una facturada por separado."
        },
        {
          "q": "¿Pueden usarse las imágenes generadas comercialmente?",
          "a": "Sí, el contenido puede usarse para propósitos comerciales."
        }
      ]
    },
    "flux2": {
      "title": "Generador de imágenes IA FLUX.2",
      "desc": "FLUX.2 ofrece eficiencia empresarial y precisión profesional para generación de texto a imagen con detalles fotorrealistas.",
      "variantLabel": "Variante del modelo",
      "variantDesc": {
        "klein-04": "Tiempo real",
        "klein-09": "Equilibrado",
        "max": "Máxima calidad",
        "pro": "Producción",
        "flex": "Personalizable"
      },
      "promptUpsampling": "Mejora de prompt",
      "promptUpsamplingHint": "Mejora los detalles del prompt para una salida más rica (no disponible para Klein).",
      "steps": "Pasos",
      "stepsHint": "Más pasos = más detalles pero más lento. Solo variante Flex.",
      "guidance": "Guidance",
      "guidanceHint": "Controla la fidelidad al prompt. Solo variante Flex.",
      "tagPhotorealism": "Fotorrealismo",
      "tagMultilingual": "Multilingüe",
      "tagVariants": "5 Variantes",
      "demoPrompt1": "A young woman sitting on a rooftop at golden hour, wearing an oversized denim jacket, white headphones around her neck, sipping iced coffee from a clear plastic cup. Her short curly hair blows slightly in the wind as city lights begin to glow in the distance.",
      "features": [
        { "icon": "✨", "title": "Detalles fotorrealistas", "desc": "Manos, rostros, telas, logos y objetos pequeños precisos hasta 4MP." },
        { "icon": "🎨", "title": "Tipografía y diseño", "desc": "Renderizado de tipografía clara y legible, seguimiento de instrucciones de diseño complejas." },
        { "icon": "🌍", "title": "Multilingüe", "desc": "Soporte nativo de prompts en tu idioma con seguimiento de instrucciones avanzado." },
        { "icon": "🎯", "title": "5 variantes", "desc": "Klein 4B/9B (velocidad), Max (calidad), Pro (producción), Flex (control personalizado)." },
        { "icon": "⚙️", "title": "Control flexible", "desc": "Pasos, guidance, tamaño y tolerancia de seguridad ajustables." }
      ],
      "faq": [
        { "q": "¿Cuáles son las variantes de FLUX.2?", "a": "FLUX.2 ofrece 5 variantes: Klein 4B y 9B (rápido), Max (máxima calidad con búsqueda), Pro (producción), Flex (pasos y guidance ajustables)." },
        { "q": "¿Qué tamaños de imagen soporta?", "a": "FLUX.2 usa dimensiones en píxeles (ancho x alto), múltiplos de 16. Presets: 1:1, 4:3, 3:4, 16:9, 9:16, 21:9, 9:21." },
        { "q": "¿Qué es la mejora de prompt?", "a": "Activa la mejora interna del prompt para más detalles. Disponible para Max, Pro y Flex (no Klein)." },
        { "q": "¿Qué son los pasos y guidance en modo Flex?", "a": "Pasos (1-50): calidad de inferencia, más alto = más detalles. Guidance (1.5-10): fidelidad al prompt, más alto = más cercano a la descripción." },
        { "q": "¿Las imágenes pueden usarse comercialmente?", "a": "Sí, el contenido generado puede usarse con fines comerciales." }
      ]
    },
    "seedance": {
      "title": "Generador de Video IA Seedance",
      "desc": "Seedance es un modelo de video IA de próxima generación que soporta sincronización audiovisual nativa, movimiento cinematográfico y expresión emocional. Cubre modos de texto a video, imagen a video y extensión de video.",
      "textToVideo": "Texto a Video",
      "imageToVideo": "Imagen a Video",
      "videoExtend": "Extensión de Video",
      "uploadImage": "Haz clic para subir imagen de referencia",
      "uploadHint": "PNG, JPG, JPEG (máx 20MB)",
      "endFrame": "Imagen del Fotograma Final",
      "endFrameHint": "(Opcional) Sube fotograma final para controlar el final del video",
      "uploadEndFrame": "Haz clic para subir imagen del fotograma final",
      "uploadVideo": "Haz clic para subir video de referencia",
      "uploadVideoHint": "MP4, MOV, WebM (máx 100MB)",
      "videoPrompt": "Prompt de Video",
      "promptPlaceholder": "Describe el video que deseas generar...",
      "videoPromptPlaceholder": "Describe el video que deseas generar...",
      "negativePrompt": "Prompt Negativo",
      "negativePromptPlaceholder": "Describe lo que no quieres en el video (opcional)",
      "duration": "Duración",
      "videoDuration": "Duración del video",
      "resolution": "Resolución",
      "aspectRatio": "Relación de Aspecto",
      "promptEnhance": "Mejora de prompt",
      "promptEnhanceDesc": "Optimiza automáticamente los prompts para mejores resultados de generación",
      "generateAudio": "Generar Audio",
      "audioOn": "Audio nativo (voz + efectos de sonido)",
      "audioOff": "Solo video, sin audio",
      "seedValue": "Valor de Semilla",
      "seedHint": "El valor de semilla es el identificador único del estilo general. Usar la misma semilla mantiene el estilo consistente, mientras ajustar otros parámetros ayuda a refinar detalles visuales.",
      "seedPlaceholder": "-1 (aleatorio)",
      "characters": "caracteres",
      "creditsRequired": "Créditos Requeridos:",
      "creditsRemaining": "Restantes:",
      "generate": "Generar",
      "generating": "Generando...",
      "demoPrompt": "Prompt de Demostración",
      "demoPromptExample": "Un gatito blanco suave y lindo baila felizmente de puntillas, su cuerpo esponjoso balanceándose suavemente con patitas rosadas diminutas levantadas. Sobre una alfombra suave bajo iluminación cálida amarilla, estilo de dibujo animado sanador, detalles exquisitos, colores suaves y gentiles.",
      "modelLabel": "Modelo:",
      "durationLabel": "Duración:",
      "techSpecsTitle": "Especificaciones Técnicas",
      "techSpecsDesc": "Seedance soporta sincronización audiovisual nativa, movimiento cinematográfico y expresión emocional. Cubre modos de texto a video, imagen a video y extensión de video.",
      "t2vTitle": "Texto a Video (T2V)",
      "t2vDesc": "Transforma prompts en escenas de video cinematográficas",
      "i2vTitle": "Imagen a Video (I2V)",
      "i2vDesc": "Anima una sola imagen usando IA",
      "input": "Entrada:",
      "textPrompt": "Prompt de texto",
      "imagePrompt": "Imagen + prompt",
      "audio": "Audio:",
      "nativeAudio": "Generación de audio nativa",
      "bestFor": "Mejor para:",
      "t2vBestFor": "Perfecto para creación de contenido cinematográfico, publicidad y videos de redes sociales.",
      "i2vBestFor": "Mejor para animación de retratos, exhibiciones de producto y contenido creativo.",
      "featuresDesc": "Ya seas diseñador, marketer, creador de contenido o usuario casual, Seedance te ayuda a crear contenido IA de alta calidad rápidamente.",
      "features": [
        {
          "icon": "🎬",
          "title": "Generación Audiovisual Nativa",
          "desc": "Genera sincrónicamente video y audio de una sola vez, entregando calidad cinematográfica. Sincronización labial natural y doblaje de diálogo."
        },
        {
          "icon": "😊",
          "title": "Expresión Impulsada por Emociones",
          "desc": "Nueva actuación consciente de emociones para expresiones faciales más realistas. Las expresiones sutiles incluyen vacilación, tristeza, tensión o contención emocional."
        },
        {
          "icon": "🎥",
          "title": "Control de Cámara de Nivel de Director",
          "desc": "Soporta movimientos de cámara de empuje, tracción, panorámica, órbita y seguimiento. Guía de primer y último fotograma para transiciones suaves."
        },
        {
          "icon": "📱",
          "title": "Entrada Multimodal",
          "desc": "Soporta texto a video, imagen a video y otros flujos de trabajo creativos flexibles."
        },
        {
          "icon": "⚡",
          "title": "Generación Rápida",
          "desc": "Motor de inferencia optimizado asegura producción rápida, la mayoría de los videos completan en minutos."
        },
        {
          "icon": "💼",
          "title": "Licencia Comercial",
          "desc": "Todos los videos generados pueden usarse para propósitos comerciales, adecuados para publicidad, redes sociales y más."
        }
      ],
      "enterPrompt": "Por favor ingresa un prompt",
      "imageRequired": "El modo imagen a video requiere una imagen de referencia",
      "videoRequired": "El modo de extensión de video requiere un video de referencia",
      "generateFailed": "Generación fallida",
      "requestFailed": "Solicitud fallida, inténtalo de nuevo",
      "faq": [
        {
          "q": "¿Cómo funciona Seedance?",
          "a": "Puedes subir una imagen de referencia o ingresar una descripción de texto directamente, y el modelo Seedance generará contenido de video de alta calidad basado en tus instrucciones, con audio sincronizado. El proceso es simple e intuitivo, no requiere habilidades profesionales."
        },
        {
          "q": "¿Pueden usarse los videos generados comercialmente?",
          "a": "Sí, todo el contenido generado usando Seedance puede usarse para propósitos comerciales, incluyendo materiales de marketing, redes sociales, exhibiciones de producto y más."
        },
        {
          "q": "¿Cuántos créditos cuesta cada generación?",
          "a": "Usar Seedance cuesta 18 créditos por generación. Puedes obtener mejores tasas de crédito a través de planes de suscripción."
        },
        {
          "q": "¿Qué tan rápida es la generación?",
          "a": "La velocidad promedio de generación de Seedance es de aproximadamente 1.5 minutos. Continuamos optimizando nuestra infraestructura para garantizar generación rápida y estable."
        },
        {
          "q": "¿Qué formatos de salida son compatibles?",
          "a": "Los videos se entregan en formato MP4, soportando resoluciones 480p, 720p y 1080p, con duraciones de 5 o 10 segundos y múltiples relaciones de aspecto."
        }
      ]
    },
    "veo": {
      "title": "Generador de Video IA Veo 3.1",
      "desc": "Google Veo 3.1 es un modelo de video IA de última generación que soporta generación de audio nativa, resolución ultra alta y creación de video largo. Perfecto para producción de video profesional.",
      "fastType": "Tipo Rápido",
      "fastTypeBadge": "Velocidad rápida, menor costo",
      "fastTypeDesc": "(Soporta imágenes de referencia 16:9)",
      "qualityType": "Tipo de Calidad",
      "qualityTypeBadge": "Detalles más ricos",
      "qualityTypeDesc": "Movimiento más suave. El fotograma final es opcional para el modo de imagen para controlar el último fotograma.",
      "imageMode": "Modo de Generación",
      "startEndFrames": "Fotogramas Inicio/Final",
      "referenceImage": "Imagen de Referencia",
      "startFrame": "Fotograma Inicial",
      "startFrameHint": "Establece el primer fotograma. El video se anima desde este fotograma.",
      "uploadStartFrame": "Haz clic para subir fotograma inicial",
      "endFrame": "Fotograma Final",
      "endFrameHint": "Establece el último fotograma. El video termina en este fotograma.",
      "uploadEndFrame": "Haz clic para subir fotograma final",
      "negativePrompt": "Prompt Negativo",
      "negativePromptPlaceholder": "Describe lo que no quieres en el video...",
      "features": [
        {
          "icon": "🎬",
          "title": "Generación de Audio Nativa",
          "desc": "Genera sincrónicamente video y audio, incluyendo diálogo y efectos de sonido."
        },
        {
          "icon": "📺",
          "title": "Resolución Ultra HD",
          "desc": "Soporta salida de resolución hasta 4K para producción de video profesional."
        },
        {
          "icon": "⏱️",
          "title": "Soporte de Video Largo",
          "desc": "Genera videos de hasta 2 minutos de duración, adecuados para varias necesidades creativas."
        },
        {
          "icon": "🎥",
          "title": "Movimiento Cinematográfico",
          "desc": "Movimientos de cámara profesionales y transiciones suaves."
        },
        {
          "icon": "⚡",
          "title": "Generación Rápida",
          "desc": "Motor de inferencia optimizado para producción rápida."
        },
        {
          "icon": "💼",
          "title": "Licencia Comercial",
          "desc": "Todos los videos generados pueden usarse para propósitos comerciales."
        }
      ],
      "faq": [
        {
          "q": "¿Cuál es la diferencia entre los tipos Rápido y Calidad?",
          "a": "El tipo Rápido es más rápido y rentable, adecuado para iteración rápida. El tipo Calidad produce detalles más ricos y movimiento más suave, ideal para salida final."
        },
        {
          "q": "¿Cómo funciona Veo 3.1?",
          "a": "Ingresa una descripción de texto o sube una imagen de referencia, y Veo 3.1 generará contenido de video de alta calidad basado en tus instrucciones, opcionalmente con audio sincronizado."
        },
        {
          "q": "¿Cuántos créditos cuesta cada generación?",
          "a": "Usar Veo 3.1 cuesta 30 créditos por generación. Puedes obtener mejores tasas de crédito a través de planes de suscripción."
        },
        {
          "q": "¿Qué resoluciones y duraciones son compatibles?",
          "a": "Soporta resoluciones 720p y 1080p, con duraciones de 5s, 10s y hasta 2 minutos para videos más largos."
        }
      ]
    },
    "veo30": {
      "title": "Generador de Video IA Veo 3.0",
      "desc": "Google Veo 3.0 es un modelo de video IA avanzado que soporta texto a video e imagen a video, con duración 4s/6s/8s y salida 720p/1080p.",
      "fastType": "Tipo Rápido",
      "fastTypeBadge": "Más rápido, menor costo",
      "fastTypeDesc": "(Soporta imagen de referencia 16:9)",
      "qualityType": "Tipo de Calidad",
      "qualityTypeBadge": "Detalles más ricos",
      "qualityTypeDesc": "Movimiento más suave. El fotograma final en modo de imagen es opcional para controlar el último fotograma.",
      "imageMode": "Modo de Imagen",
      "startEndFrames": "Fotograma Inicio/Final",
      "referenceImage": "Imagen de Referencia",
      "referenceImageHint": "Sube una imagen de referencia; el video se generará basado en ella.",
      "uploadReferenceImage": "Haz clic para subir imagen de referencia",
      "startFrame": "Fotograma Inicial",
      "startFrameHint": "Establece el primer fotograma. El video se anima desde este fotograma.",
      "uploadStartFrame": "Haz clic para subir fotograma inicial",
      "endFrame": "Fotograma Final",
      "endFrameHint": "Establece el último fotograma. El video termina en este fotograma.",
      "uploadEndFrame": "Haz clic para subir fotograma final",
      "negativePrompt": "Prompt Negativo",
      "negativePromptPlaceholder": "Describe lo que no quieres en el video...",
      "seedRangeError": "La semilla debe ser un entero entre 0 y 2147483647.",
      "duration": "Duración",
      "resolution": "Resolución",
      "demoPrompt": "Una chica adolescente dibujando en un cuaderno en la ventana de una cafetería, la lluvia golpeando el cristal...",
      "features": [
        {
          "icon": "🎬",
          "title": "Generación de Audio Nativa",
          "desc": "Genera sincrónicamente video y audio, incluyendo diálogo y efectos de sonido."
        },
        {
          "icon": "📺",
          "title": "Resolución HD",
          "desc": "Soporta salida 720p y 1080p para producción de video profesional."
        },
        {
          "icon": "⏱️",
          "title": "Múltiples Duraciones",
          "desc": "Soporta generación de video 4s, 6s y 8s."
        },
        {
          "icon": "🎥",
          "title": "Movimiento Cinematográfico",
          "desc": "Movimientos de cámara profesionales y transiciones suaves."
        },
        {
          "icon": "⚡",
          "title": "Generación Rápida",
          "desc": "Motor de inferencia optimizado para producción rápida."
        },
        {
          "icon": "💼",
          "title": "Licencia Comercial",
          "desc": "Todos los videos generados pueden usarse para propósitos comerciales."
        }
      ],
      "faq": [
        {
          "q": "¿Cuál es la diferencia entre los tipos Rápido y Calidad?",
          "a": "El tipo Rápido es más rápido y rentable, adecuado para iteración rápida. El tipo Calidad produce detalles más ricos y movimiento más suave, ideal para salida final."
        },
        {
          "q": "¿Cómo funciona Veo 3.0?",
          "a": "Ingresa una descripción de texto o sube una imagen de referencia, y Veo 3.0 generará contenido de video de alta calidad basado en tus instrucciones, opcionalmente con audio sincronizado."
        },
        {
          "q": "¿Cuántos créditos cuesta cada generación?",
          "a": "Usar Veo 3.0 cuesta 25 créditos por generación. Puedes obtener mejores tasas de crédito a través de planes de suscripción."
        },
        {
          "q": "¿Qué resoluciones y duraciones son compatibles?",
          "a": "Soporta resoluciones 720p y 1080p, con duraciones de 4s, 6s u 8s."
        }
      ]
    },
    "veo31fast": {
      "title": "Generador de Video IA Veo 3.1 Fast",
      "desc": "Google Veo 3.1 Fast para generación más rápida, soportando texto a video e imagen a video con fotograma final opcional, duración 4s/6s/8s y salida 720p/1080p/4K.",
      "referenceImage": "Imagen de Referencia",
      "referenceImageHint": "Sube una imagen de referencia; el video se generará basado en ella.",
      "uploadReferenceImage": "Haz clic para subir imagen de referencia",
      "endFrame": "Fotograma Final",
      "endFrameHint": "Opcional. Establece la imagen para el último fotograma del video para controlar el final.",
      "uploadEndFrame": "Haz clic para subir fotograma final",
      "duration": "Duración",
      "resolution": "Resolución",
      "seedRangeError": "La semilla debe ser un entero entre 0 y 2147483647.",
      "demoPrompt": "Una chica adolescente dibujando en un cuaderno en la ventana de una cafetería, la lluvia golpeando el cristal...",
      "features": [
        {
          "icon": "⚡",
          "title": "Generación Rápida",
          "desc": "Optimizado para salida más rápida."
        },
        {
          "icon": "📺",
          "title": "Resolución 4K",
          "desc": "Soporta salida 720p, 1080p y 4K."
        },
        {
          "icon": "⏱️",
          "title": "Múltiples Duraciones",
          "desc": "Soporta video 4s, 6s y 8s."
        },
        {
          "icon": "🖼️",
          "title": "Fotograma Final Opcional",
          "desc": "Imagen a video puede subir un fotograma final para controlar el final."
        },
        {
          "icon": "🎥",
          "title": "Movimiento Cinematográfico",
          "desc": "Movimientos de cámara profesionales y transiciones suaves."
        },
        {
          "icon": "💼",
          "title": "Licencia Comercial",
          "desc": "Todos los videos generados pueden usarse para propósitos comerciales."
        }
      ],
      "faq": [
        {
          "q": "¿Cuál es la diferencia entre Veo 3.1 Fast y Veo 3.1?",
          "a": "Veo 3.1 Fast está optimizado para velocidad y menor costo de crédito, con soporte 4K y fotograma final opcional."
        },
        {
          "q": "¿Qué es el fotograma final?",
          "a": "Para imagen a video, puedes subir una imagen de fotograma final para que el video termine en ese fotograma, dándote control sobre el final."
        },
        {
          "q": "¿Cuántos créditos cuesta cada generación?",
          "a": "Usar Veo 3.1 Fast cuesta 20 créditos por generación."
        },
        {
          "q": "¿Qué resoluciones y duraciones son compatibles?",
          "a": "Soporta resoluciones 720p, 1080p y 4K, con duraciones de 4s, 6s u 8s."
        }
      ]
    },
    "kling": {
      "title": "Generador de Video IA Kling 2.6",
      "desc": "Kling 2.6 es un modelo de video IA de alto rendimiento que soporta texto a video e imagen a video, con excelente calidad de movimiento y velocidad de generación rápida.",
      "features": [
        {
          "icon": "🎬",
          "title": "Movimiento de Alta Calidad",
          "desc": "Movimiento suave y natural con salida de calidad profesional."
        },
        {
          "icon": "📱",
          "title": "Múltiples Relaciones de Aspecto",
          "desc": "Soporta 1:1, 16:9, 9:16 y otras relaciones de aspecto."
        },
        {
          "icon": "🔊",
          "title": "Generación de Audio",
          "desc": "Generación de audio nativa opcional para experiencia de video completa."
        },
        {
          "icon": "⚡",
          "title": "Generación Rápida",
          "desc": "La mayoría de los videos generados en 2 minutos."
        },
        {
          "icon": "🖼️",
          "title": "Imagen a Video",
          "desc": "Anima imágenes estáticas con movimiento potenciado por IA."
        },
        {
          "icon": "💼",
          "title": "Licencia Comercial",
          "desc": "Todos los videos generados pueden usarse para propósitos comerciales."
        }
      ],
      "faq": [
        {
          "q": "¿Cómo funciona Kling 2.6?",
          "a": "Ingresa una descripción de texto o sube una imagen de referencia, y Kling 2.6 generará contenido de video de alta calidad basado en tus instrucciones."
        },
        {
          "q": "¿Cuántos créditos cuesta cada generación?",
          "a": "Usar Kling 2.6 cuesta 28 créditos por generación. Puedes obtener mejores tasas de crédito a través de planes de suscripción."
        },
        {
          "q": "¿Qué resoluciones y duraciones son compatibles?",
          "a": "Soporta resoluciones 720p y 1080p, con duraciones de 5s y 10s."
        },
        {
          "q": "¿Puedo usar los videos generados comercialmente?",
          "a": "Sí, todo el contenido generado usando Kling 2.6 puede usarse para propósitos comerciales."
        }
      ]
    },
    "kling3": {
      "title": "Generador de Video IA Kling 3.0",
      "desc": "Kling 3.0 es un modelo de video IA de alto rendimiento que soporta texto a video e imagen a video, con excelente calidad de movimiento y velocidad de generación rápida.",
      "features": [
        {
          "icon": "🎬",
          "title": "Movimiento de Alta Calidad",
          "desc": "Movimiento suave y natural con salida de calidad profesional."
        },
        {
          "icon": "📱",
          "title": "Múltiples Relaciones de Aspecto",
          "desc": "Soporta 1:1, 16:9, 9:16 y otras relaciones de aspecto."
        },
        {
          "icon": "🔊",
          "title": "Generación de Audio",
          "desc": "Generación de audio nativa opcional para experiencia de video completa."
        },
        {
          "icon": "⚡",
          "title": "Generación Rápida",
          "desc": "La mayoría de los videos generados en 2 minutos."
        },
        {
          "icon": "🖼️",
          "title": "Imagen a Video",
          "desc": "Anima imágenes estáticas con movimiento potenciado por IA."
        },
        {
          "icon": "💼",
          "title": "Licencia Comercial",
          "desc": "Todos los videos generados pueden usarse para propósitos comerciales."
        }
      ],
      "faq": [
        {
          "q": "¿Cómo funciona Kling 3.0?",
          "a": "Ingresa una descripción de texto o sube una imagen de referencia, y Kling 3.0 generará contenido de video de alta calidad basado en tus instrucciones."
        },
        {
          "q": "¿Cuántos créditos cuesta cada generación?",
          "a": "Usar Kling 3.0 cuesta 28 créditos por generación. Puedes obtener mejores tasas de crédito a través de planes de suscripción."
        },
        {
          "q": "¿Qué resoluciones y duraciones son compatibles?",
          "a": "Soporta resoluciones 720p y 1080p, con duraciones de 5s y 10s."
        },
        {
          "q": "¿Puedo usar los videos generados comercialmente?",
          "a": "Sí, todo el contenido generado usando Kling 3.0 puede usarse para propósitos comerciales."
        }
      ]
    },
    "sora": {
      "title": "Generador de Video IA Sora 2",
      "desc": "Sora 2 es el modelo de video IA avanzado de OpenAI, capaz de generar videos de alta calidad con movimiento realista y calidad cinematográfica.",
      "demoPromptExample": "@sama El CEO de OpenAI, Sam, está presentando este producto de gabinete, diciendo que es el mismo que el suyo y muy útil.",
      "landscape": "Horizontal",
      "portrait": "Vertical",
      "removeWatermark": "Eliminar Marca de Agua",
      "enabled": "Habilitado",
      "disabled": "Deshabilitado",
      "noWatermark": "Sin Marca de Agua",
      "cinematic": "Calidad Cinematográfica",
      "restrictedAccess": "Acceso Restringido",
      "60secDuration": "Duración de 4 s / 8 s / 12 s",
      "photorealistic": "Fotorrealista",
      "physicsSimulation": "Simulación de Física",
      "features": [
        {
          "icon": "🎬",
          "title": "Calidad Cinematográfica",
          "desc": "Genera videos con apariencia y sensación cinematográfica profesional."
        },
        {
          "icon": "🎥",
          "title": "Movimiento Realista",
          "desc": "Movimiento natural y realista para personajes y escenas."
        },
        {
          "icon": "⏱️",
          "title": "Duración Flexible",
          "desc": "Soporta varias longitudes de video para diferentes necesidades."
        },
        {
          "icon": "⚡",
          "title": "Generación Rápida",
          "desc": "Optimizado para producción rápida de video."
        },
        {
          "icon": "🖼️",
          "title": "Entrada Multimodal",
          "desc": "Soporta modos de texto a video e imagen a video."
        },
        {
          "icon": "💼",
          "title": "Licencia Comercial",
          "desc": "Todos los videos generados pueden usarse para propósitos comerciales."
        }
      ],
      "faq": [
        {
          "q": "¿Cómo funciona Sora 2?",
          "a": "Ingresa una descripción de texto o sube una imagen de referencia, y Sora 2 generará contenido de video de alta calidad basado en tus instrucciones."
        },
        {
          "q": "¿Cuántos créditos cuesta cada generación?",
          "a": "Usar Sora 2 cuesta 15 créditos por generación. Puedes obtener mejores tasas de crédito a través de planes de suscripción."
        },
        {
          "q": "¿Qué hace especial a Sora 2?",
          "a": "Sora 2 sobresale en generar movimiento realista y videos de calidad cinematográfica, haciéndolo ideal para creación de contenido profesional."
        },
        {
          "q": "¿Puedo usar los videos generados comercialmente?",
          "a": "Sí, todo el contenido generado usando Sora 2 puede usarse para propósitos comerciales."
        }
      ]
    },
    "wan": {
      "title": "Generador de Video IA Wan",
      "desc": "Wan es un modelo de video IA versátil que soporta texto a video e imagen a video con excelente calidad y velocidad.",
      "multiFormat": "Múltiples Formatos",
      "smoothMotion": "Movimiento Suave",
      "referenceAudio": "Audio de Referencia",
      "uploadAudio": "Haz clic para subir audio de referencia",
      "uploadAudioHint": "MP3, WAV, M4A (opcional, impulsa la banda sonora del video)",
      "features": [
        {
          "icon": "🎬",
          "title": "Salida de Alta Calidad",
          "desc": "Genera videos de calidad profesional a partir de texto o imágenes."
        },
        {
          "icon": "⚡",
          "title": "Generación Rápida",
          "desc": "Producción rápida de video para flujo de trabajo eficiente."
        },
        {
          "icon": "📱",
          "title": "Múltiples Formatos",
          "desc": "Soporta varias relaciones de aspecto y resoluciones."
        },
        {
          "icon": "🖼️",
          "title": "Animación de Imagen",
          "desc": "Da vida a imágenes estáticas con movimiento IA."
        },
        {
          "icon": "🎥",
          "title": "Movimiento Suave",
          "desc": "Movimiento natural y fluido en videos generados."
        },
        {
          "icon": "💼",
          "title": "Licencia Comercial",
          "desc": "Todos los videos generados pueden usarse para propósitos comerciales."
        }
      ],
      "faq": [
        {
          "q": "¿Cómo funciona Wan?",
          "a": "Ingresa una descripción de texto o sube una imagen de referencia, y Wan generará contenido de video de alta calidad basado en tus instrucciones."
        },
        {
          "q": "¿Qué versión de Wan debo usar?",
          "a": "Wan 2.5 y 2.6 ofrecen las últimas características y mejor calidad. Wan 2.2 es una opción rentable para proyectos más simples."
        },
        {
          "q": "¿Cuántos créditos cuesta cada generación?",
          "a": "Wan 2.6 cuesta 70 créditos, Wan 2.5 cuesta 60 créditos y Wan 2.2 cuesta 10 créditos por generación."
        },
        {
          "q": "¿Puedo usar los videos generados comercialmente?",
          "a": "Sí, todo el contenido generado usando Wan puede usarse para propósitos comerciales."
        }
      ]
    },
    "wan25": {
      "title": "Generador de Video IA Wan 2.5",
      "desc": "Wan 2.5 es un modelo de video IA versátil que soporta texto a video e imagen a video con excelente calidad y velocidad.",
      "features": [
        {
          "icon": "🎬",
          "title": "Salida de Alta Calidad",
          "desc": "Genera videos de calidad profesional a partir de texto o imágenes."
        },
        {
          "icon": "⚡",
          "title": "Generación Rápida",
          "desc": "Producción rápida de video para flujo de trabajo eficiente."
        },
        {
          "icon": "📱",
          "title": "Múltiples Formatos",
          "desc": "Soporta varias relaciones de aspecto y resoluciones."
        },
        {
          "icon": "🖼️",
          "title": "Animación de Imagen",
          "desc": "Da vida a imágenes estáticas con movimiento IA."
        },
        {
          "icon": "🎥",
          "title": "Movimiento Suave",
          "desc": "Movimiento natural y fluido en videos generados."
        },
        {
          "icon": "💼",
          "title": "Licencia Comercial",
          "desc": "Todos los videos generados pueden usarse para propósitos comerciales."
        }
      ],
      "faq": [
        {
          "q": "¿Cómo funciona Wan 2.5?",
          "a": "Ingresa una descripción de texto o sube una imagen de referencia, y Wan 2.5 generará contenido de video de alta calidad basado en tus instrucciones."
        },
        {
          "q": "¿Cuál es la diferencia entre Wan 2.5 y Wan 2.6?",
          "a": "Wan 2.6 ofrece mejoras adicionales en calidad y estabilidad; Wan 2.5 es rentable y adecuado para la mayoría de los casos de uso."
        },
        {
          "q": "¿Cuántos créditos cuesta cada generación?",
          "a": "Wan 2.5 cuesta 60 créditos por generación."
        },
        {
          "q": "¿Puedo usar los videos generados comercialmente?",
          "a": "Sí, todo el contenido generado usando Wan 2.5 puede usarse para propósitos comerciales."
        }
      ]
    },
    "wan26": {
      "title": "Generador de Video IA Wan 2.6",
      "desc": "Wan 2.6 es un modelo de video IA mejorado con calidad y estabilidad mejoradas, soportando texto a video e imagen a video.",
      "features": [
        {
          "icon": "🎬",
          "title": "Salida de Alta Calidad",
          "desc": "Genera videos de calidad profesional a partir de texto o imágenes con calidad mejorada."
        },
        {
          "icon": "⚡",
          "title": "Generación Rápida",
          "desc": "Producción rápida de video para flujo de trabajo eficiente."
        },
        {
          "icon": "📱",
          "title": "Múltiples Formatos",
          "desc": "Soporta varias relaciones de aspecto y resoluciones."
        },
        {
          "icon": "🖼️",
          "title": "Animación de Imagen",
          "desc": "Da vida a imágenes estáticas con movimiento IA."
        },
        {
          "icon": "🎥",
          "title": "Movimiento Suave",
          "desc": "Movimiento natural y fluido en videos generados."
        },
        {
          "icon": "💼",
          "title": "Licencia Comercial",
          "desc": "Todos los videos generados pueden usarse para propósitos comerciales."
        }
      ],
      "faq": [
        {
          "q": "¿Cuál es la diferencia entre Wan 2.6 y Wan 2.5?",
          "a": "Wan 2.6 ofrece mejoras adicionales en calidad y estabilidad para salida de mayor calidad."
        },
        {
          "q": "¿Cómo funciona Wan 2.6?",
          "a": "Ingresa una descripción de texto o sube una imagen de referencia, y Wan 2.6 generará contenido de video de alta calidad basado en tus instrucciones."
        },
        {
          "q": "¿Cuántos créditos cuesta cada generación?",
          "a": "Wan 2.6 cuesta 70 créditos por generación."
        },
        {
          "q": "¿Puedo usar los videos generados comercialmente?",
          "a": "Sí, todo el contenido generado usando Wan 2.6 puede usarse para propósitos comerciales."
        }
      ]
    },
    "wan22": {
      "title": "Generador de Video IA Wan 2.2 Clásico",
      "desc": "Wan 2.2 es un modelo de video IA clásico para texto a video e imagen a video, enfocado en salida estable y fuerte rentabilidad.",
      "demoPromptExample": "Una chica con pecas pequeñas y pelo rojo desordenado sentada en un tejado durante el atardecer, chaqueta de denim ligeramente desgastada, sosteniendo una cámara Polaroid, el horizonte de la ciudad brillando en tonos suaves detrás de ella.",
      "resolutionBadge": "720p",
      "classicVersion": "Versión Clásica",
      "stableReliable": "Estable y Confiable",
      "costEffective": "Rentable",
      "features": [
        {
          "icon": "🎬",
          "title": "Texto/Imagen a Video",
          "desc": "Soporta tanto texto a video como imagen a video para creación diaria y pruebas por lotes."
        },
        {
          "icon": "⚡",
          "title": "Resultados Estables",
          "desc": "Modelo clásico maduro con calidad de salida predecible."
        },
        {
          "icon": "💰",
          "title": "Amigable al Presupuesto",
          "desc": "Menor uso de crédito para flujos de trabajo de alta frecuencia."
        },
        {
          "icon": "📐",
          "title": "Relaciones Comunes",
          "desc": "Soporta relaciones de aspecto comunes como 16:9 y 9:16."
        },
        {
          "icon": "🎥",
          "title": "Salida Limpia",
          "desc": "Entrega calidad de video clara y estable."
        },
        {
          "icon": "💼",
          "title": "Licencia Comercial",
          "desc": "El contenido generado puede usarse comercialmente."
        }
      ],
      "faq": [
        {
          "q": "¿Cuál es la diferencia entre Wan 2.2 y Wan 2.5?",
          "a": "Wan 2.2 es mejor para escenarios sensibles al costo y de alto volumen; Wan 2.5/2.6 proporcionan capacidades y calidad más fuertes."
        },
        {
          "q": "¿Cómo funciona Wan 2.2?",
          "a": "Ingresa un prompt o sube una imagen de referencia, y el modelo genera video basado en tu instrucción."
        },
        {
          "q": "¿Pueden usarse los videos generados comercialmente?",
          "a": "Sí, las salidas de Wan 2.2 pueden usarse para propósitos comerciales."
        }
      ]
    },
    "kling25": {
      "title": "Generador de Video IA Kling 2.5",
      "desc": "Kling 2.5 es un modelo de video IA estándar que soporta texto a video e imagen a video con calidad estable y buen valor.",
      "standard": "Estándar",
      "reliable": "Confiable",
      "costEffective": "Rentable",
      "standardQuality": "Calidad Estándar",
      "textToVideo": "Texto a Video",
      "imageToVideo": "Imagen a Video",
      "referenceImage": "Imagen de Referencia",
      "referenceImageHint": "Haz clic para subir o arrastrar y soltar",
      "referenceImageFormats": "Soporta PNG, JPG, JPEG, WEBP (<=10MB)",
      "endFrame": "Fotograma Final",
      "endFrameOptional": "Opcional",
      "endFrameFormats": "PNG, JPG, JPEG",
      "endFrameHint": "Restringe el fotograma final; mejor cuando coincide con la relación de aspecto de la imagen de referencia",
      "videoPrompt": "Prompt de Video",
      "promptPlaceholder": "Describe el video que deseas generar...",
      "negativePrompt": "Prompt Negativo",
      "negativePromptPlaceholder": "Describe lo que debe excluirse...",
      "duration": "Duración",
      "aspectRatio": "Relación de Aspecto",
      "uploading": "Subiendo...",
      "clickToUploadReference": "Haz clic para subir imagen de referencia",
      "clickToUploadEndFrame": "Haz clic para subir imagen del fotograma final",
      "remove": "Eliminar",
      "creditsRequired": "Créditos Requeridos:",
      "remaining": "Restantes:",
      "generate": "Generar",
      "generating": "Generando...",
      "demoPrompt": "Prompt de Demostración",
      "demoPromptExample": "Usa la imagen del callejón de ciencia ficción subida como primer fotograma. Mantén el mismo callejón, letreros de neón, reflejos y la mujer encapuchada caminando away. Mueve la cámara lentamente hacia adelante por el callejón...",
      "model": "Modelo:",
      "durationLabel": "Duración:",
      "introTitle": "Crea Videos AI de Alta Calidad con Kling 2.5 Estándar",
      "featuresBadge": "Características Principales",
      "featuresTitle": "¿Qué puede hacer {name}?",
      "faqTitle": "Preguntas Frecuentes",
      "errorPromptRequired": "Por favor ingresa un prompt",
      "errorImageRequired": "Se requiere imagen de referencia en modo imagen a video",
      "errorGenerationFailed": "Generación fallida",
      "errorRequestFailed": "Solicitud fallida, inténtalo de nuevo",
      "errorUploadFailed": "Subida fallida, inténtalo de nuevo",
      "features": [
        {
          "icon": "🎬",
          "title": "Texto/Imagen a Video",
          "desc": "Soporta tanto texto a video como imagen a video con opciones de duración 5s/10s."
        },
        {
          "icon": "⚡",
          "title": "Salida Confiable",
          "desc": "Un modelo estándar maduro con rendimiento estable."
        },
        {
          "icon": "💰",
          "title": "Gran Valor",
          "desc": "Menor consumo de crédito que modelos de nivel superior."
        },
        {
          "icon": "📐",
          "title": "Multi Ratio",
          "desc": "Soporta 1:1, 16:9 y 9:16."
        },
        {
          "icon": "💼",
          "title": "Licencia Comercial",
          "desc": "El contenido generado puede usarse comercialmente."
        }
      ],
      "faq": [
        {
          "q": "¿Cuál es la diferencia entre Kling 2.5 y Kling 2.6?",
          "a": "Kling 2.5 está optimizado para costo y rendimiento, mientras Kling 2.6 proporciona capacidades generales más fuertes."
        },
        {
          "q": "¿Cómo funciona Kling 2.5?",
          "a": "Ingresa un prompt o sube una imagen de referencia, y Kling 2.5 genera el video en consecuencia."
        },
        {
          "q": "¿Pueden usarse los videos generados comercialmente?",
          "a": "Sí, las salidas de Kling 2.5 pueden usarse comercialmente."
        }
      ]
    },
    "wanAnimate": {
      "title": "Wan Animate",
      "desc": "Animación de personajes a partir de imagen y vídeo de referencia. Calidad estándar o profesional, marca de agua opcional.",
      "refImageLabel": "Imagen de referencia",
      "refImageHint": "Personaje a animar (JPG/PNG/JPEG/BMP/WEBP, máx. 5 MB, lados 200–4096 px, relación 1:3–3:1).",
      "refVideoLabel": "Vídeo de referencia",
      "refVideoHint": "Referencia de movimiento (MP4/AVI/MOV, 2–30 s, máx. 200 MB, lados 200–2048 px, relación 1:3–3:1).",
      "animateModeLabel": "Modo de animación",
      "modeAnimate": "Imagen a acción",
      "modeReplace": "Cambio de persona en video",
      "referenceVideo": "Vídeo de referencia",
      "btnAnimate": "Animar",
      "animateModeBadgeAnimate": "Movimiento",
      "animateModeBadgeReplace": "Reemplazo",
      "btnAnimateDesc": "Combina el personaje de la imagen con el movimiento del vídeo.",
      "btnReplace": "Reemplazar",
      "btnReplaceDesc": "Sustituye el personaje del vídeo por el de la imagen.",
      "qualityLabel": "Modo de calidad",
      "qualityStd": "Estándar",
      "qualityPro": "Profesional",
      "watermarkLabel": "Marca de agua",
      "uploadVideoRequired": "Sube un vídeo de referencia.",
      "uploadImage": "Subir imagen",
      "uploadVideo": "Subir vídeo",
      "uploading": "Subiendo…",
      "imageUploadHint": "JPG, PNG, JPEG, BMP, WEBP · máx. 5 MB",
      "videoUploadHint": "MP4, AVI, MOV · 2–30 s · máx. 200 MB",
      "uploadImageRequired": "Sube una imagen de referencia.",
      "errImageFileTooLarge": "La imagen supera el límite (máx. 5 MB).",
      "errImageDimensions": "El ancho y alto de la imagen deben estar entre 200 y 4096 px.",
      "errImageAspect": "La relación de aspecto de la imagen debe estar entre 1:3 y 3:1.",
      "errImageInvalid": "Archivo de imagen no válido o ilegible.",
      "errVideoFileTooLarge": "El vídeo supera el límite (máx. 200 MB).",
      "errVideoDuration": "La duración del vídeo debe estar entre 2 y 30 segundos.",
      "errVideoDimensions": "El ancho y alto del vídeo deben estar entre 200 y 2048 px.",
      "errVideoAspect": "La relación de aspecto del vídeo debe estar entre 1:3 y 3:1.",
      "errVideoInvalid": "Archivo de vídeo no válido o ilegible.",
      "defaultModelName": "Wan Animate",
      "demoEmptyHint": "Sube una imagen de personaje y un vídeo de movimiento, y crea animaciones increíbles con Wan Animate.",
      "demoEmptyTitle": "Animación de personajes",
      "demoStepCharacter": "Personaje",
      "demoStepMotion": "Movimiento",
      "demoStepAnimate": "Animación",
      "faqCredits": "El modo profesional consume más créditos que el estándar. Ver la línea superior.",
      "characterAnimation": "Animación de personajes",
      "faceSwap": "Cambio de cara",
      "motionTransfer": "Transferencia de movimiento",
      "identityReplacement": "Sustitución de identidad",
      "motionAccuracy": "Fidelidad del movimiento",
      "features": [
        { "icon": "🎭", "title": "Dos modos", "desc": "Transferencia de movimiento o sustitución completa del personaje." },
        { "icon": "📐", "title": "DashScope oficial", "desc": "Wan 2.2 Animate en Alibaba Cloud." },
        { "icon": "⚡", "title": "Estándar / Pro", "desc": "Elige calidad estándar o profesional por tarea." },
        { "icon": "💧", "title": "Marca de agua opcional", "desc": "Activa o desactiva la marca de agua en la salida." }
      ],
      "faq": [
        { "q": "¿Qué entradas se necesitan?", "a": "Tras la subida, URL HTTPS públicas de imagen y vídeo. Respeta límites de tamaño y relación." },
        { "q": "¿Diferencia entre Animar y Reemplazar?", "a": "Animar aplica el movimiento del vídeo a tu personaje de imagen. Reemplazar cambia el personaje del vídeo por el de la imagen." },
        { "q": "¿Cómo se calculan los créditos?", "a": "El modo profesional cuesta más por generación que el estándar, como se muestra en la página." }
      ]
    },
    "viduq3pro": {
      "title": "Vidu Q3 Pro – Video IA",
      "desc": "Vidu Q3 Pro: texto o imagen, resolución, 1–16 s, relación de aspecto y audio opcional.",
      "imageUrlHint": "Solo URL de imagen HTTPS (la subida devuelve URL pública). La relación de aspecto debe estar entre 1:4 y 4:1.",
      "lengthLabel": "Duración (s)",
      "optional": "Opcional",
      "tagHighQuality": "Alta calidad",
      "tagLength": "1–16 s",
      "tagResolution": "Hasta 2K",
      "demoPromptExample": "Paseo marítimo al amanecer, gente corriendo, gaviotas sobre el agua, un velero a lo lejos.",
      "features": [
        { "icon": "🎬", "title": "Texto e imagen", "desc": "Genera desde un prompt o una imagen de referencia." },
        { "icon": "📐", "title": "Relación de aspecto", "desc": "Modo texto: 16:9, 9:16, 1:1, 4:3, 3:4." },
        { "icon": "⏱️", "title": "Duración", "desc": "De 1 a 16 segundos." },
        { "icon": "🎵", "title": "Audio", "desc": "Audio natural opcional." },
        { "icon": "🎲", "title": "Semilla", "desc": "Semilla opcional para mayor reproducibilidad." }
      ],
      "faq": [
        { "q": "¿Requisitos de imagen a video?", "a": "URL HTTPS pública (JPG/PNG). Relación de aspecto entre 1:4 y 4:1." },
        { "q": "¿Diferencia texto vs imagen?", "a": "El texto usa relación de aspecto; la imagen envía la URL de referencia." },
        { "q": "¿Créditos?", "a": "Según las reglas mostradas: duración, resolución y audio." }
      ]
    },
    "hailuo": {
      "title": "Generador de Video IA Hailuo 2.3",
      "desc": "Hailuo 2.3 es un modelo de video IA de próxima generación diseñado para generación de video creativa y de alta calidad.",
      "demoPromptExample": "Un plano cinematográfico de olas rompiendo en una costa rocosa al atardecer, luz dorada reflejándose en el agua...",
      "highQuality": "Alta Calidad",
      "highQualityOutput": "Salida de Alta Calidad",
      "features": [
        {
          "icon": "🎬",
          "title": "Texto a Video",
          "desc": "Genera videos de alta calidad directamente desde prompts de texto."
        },
        {
          "icon": "✨",
          "title": "Mejora de Prompt",
          "desc": "La mejora de prompt ayuda a aumentar la consistencia y calidad."
        },
        {
          "icon": "🌊",
          "title": "Estilo Creativo",
          "desc": "Genial para contenido de video creativo y artístico."
        },
        {
          "icon": "⚡",
          "title": "Generación Rápida",
          "desc": "Canalización optimizada para entrega más rápida."
        },
        {
          "icon": "🎨",
          "title": "Calidad Visual",
          "desc": "Produce salida visual detallada y estable."
        },
        {
          "icon": "💼",
          "title": "Licencia Comercial",
          "desc": "El contenido generado puede usarse comercialmente."
        }
      ],
      "faq": [
        {
          "q": "¿Cómo funciona Hailuo 2.3?",
          "a": "Ingresa un prompt o sube una imagen de referencia y el modelo genera el video correspondiente."
        },
        {
          "q": "¿Qué es la mejora de prompt?",
          "a": "La mejora de prompt reescribe y enriquece los prompts para mejor calidad de generación."
        },
        {
          "q": "¿Pueden usarse los videos generados comercialmente?",
          "a": "Sí, las salidas de Hailuo 2.3 pueden usarse comercialmente."
        },
        {
          "q": "¿Cuántos créditos cuesta cada generación?",
          "a": "Cada generación se factura según las reglas de crédito del modelo actual."
        }
      ]
    },
    "runway": {
      "title": "Generador de Video IA Runway",
      "desc": "Runway es un modelo de video IA profesional con controles flexibles para relación, duración y semilla.",
      "demoPromptExample": "Al atardecer, las siluetas de grúas en un sitio de construcción en Singapur se destacan contra un brillante atardecer. Varios trabajadores de construcción con cascos están guardando sus herramientas, listos para irse...",
      "professional": "Profesional",
      "multiOption": "Múltiples Opciones",
      "highQuality": "Alta Calidad",
      "multiFormat": "Múltiples Relaciones",
      "reproducibleSeed": "Semilla Reproducible",
      "features": [
        {
          "icon": "🎬",
          "title": "Imagen a Video",
          "desc": "Sube una imagen de referencia y un prompt para generar rápidamente videos de alta calidad."
        },
        {
          "icon": "📐",
          "title": "Múltiples Relaciones",
          "desc": "Soporta 16:9, 9:16, 1:1, 4:3, 3:4 y 21:9."
        },
        {
          "icon": "🎲",
          "title": "Control de Semilla",
          "desc": "Usa semilla para reproducir resultados de generación similares."
        },
        {
          "icon": "⚡",
          "title": "Salida Profesional",
          "desc": "Salida consistente adecuada para flujos de trabajo profesionales y comerciales."
        },
        {
          "icon": "🖼️",
          "title": "Animación de Imagen",
          "desc": "Convierte imágenes estáticas en tomas de video dinámicas."
        },
        {
          "icon": "💼",
          "title": "Licencia Comercial",
          "desc": "El contenido generado puede usarse comercialmente."
        }
      ],
      "faq": [
        {
          "q": "¿Cómo funciona Runway?",
          "a": "Sube una imagen de referencia e ingresa un prompt; el modelo genera el video correspondiente."
        },
        {
          "q": "¿Qué relaciones de aspecto son compatibles?",
          "a": "Se admiten 16:9, 9:16, 1:1, 4:3, 3:4 y 21:9."
        },
        {
          "q": "¿Pueden usarse los videos generados comercialmente?",
          "a": "Sí, las salidas de Runway pueden usarse comercialmente."
        }
      ]
    }
  },
  "privacy": {
    "title": "Política de Privacidad",
    "lastUpdated": "Última actualización: 15 de enero de 2025",
    "navTerms": "Términos de Servicio →",
    "navTrust": "Confianza y Seguridad →",
    "sections": [
      {
        "title": "1. Recopilación de Información",
        "paragraphs": [
          "Recopilamos información que proporcionas al registrarte y usar nuestros servicios, incluyendo dirección de correo electrónico, nombre de usuario e información de pago.",
          "También recopilamos automáticamente datos de uso como dirección IP, tipo de navegador, hora de acceso y características utilizadas."
        ]
      },
      {
        "title": "2. Uso de la Información",
        "paragraphs": [
          "Usamos la información recopilada para proporcionar, mantener y mejorar nuestros servicios, procesar transacciones, enviar notificaciones relacionadas con el servicio y prevenir fraudes y abusos.",
          "No vendemos tu información personal a terceros."
        ]
      },
      {
        "title": "3. Contenido Generado por IA",
        "paragraphs": [
          "Las imágenes que subes y los prompts que ingresas se usan únicamente para generar el contenido que solicitas y no se usan para entrenar modelos de IA.",
          "El contenido generado se almacena temporalmente en nuestros servidores para que lo descargues, luego se elimina según nuestra política de retención de datos."
        ]
      },
      {
        "title": "4. Seguridad de Datos",
        "paragraphs": [
          "Empleamos medidas de seguridad estándar de la industria para proteger tu información personal, incluyendo encriptación SSL, controles de acceso y auditorías de seguridad regulares.",
          "Aunque hacemos todo lo posible para proteger tus datos, ningún método de transmisión por internet es 100% seguro."
        ]
      },
      {
        "title": "5. Uso de Cookies",
        "paragraphs": [
          "Usamos cookies y tecnologías similares para mejorar la experiencia del usuario, analizar el uso y proporcionar contenido personalizado.",
          "Puedes administrar tus preferencias de cookies a través de la configuración de tu navegador. Deshabilitar las cookies puede afectar ciertas características."
        ]
      },
      {
        "title": "6. Servicios de Terceros",
        "paragraphs": [
          "Podemos usar proveedores de servicios de terceros para ayudarnos a proporcionar servicios, como procesamiento de pagos, análisis de datos y soporte al cliente.",
          "Estos proveedores de servicios de terceros solo acceden a tu información personal en la medida necesaria para realizar servicios para nosotros."
        ]
      },
      {
        "title": "7. Tus Derechos",
        "paragraphs": [
          "Tienes derecho a acceder, corregir o eliminar tu información personal. También tienes derecho a solicitar que restrinjamos el procesamiento de tus datos o transfiramos tus datos a otro servicio.",
          "Para ejercer estos derechos, por favor contáctanos en miral_support@miralvis.com. Responderemos a tu solicitud dentro de 30 días."
        ]
      },
      {
        "title": "8. Cumplimiento GDPR",
        "paragraphs": [
          "Para usuarios en el Espacio Económico Europeo, cumplimos con los requisitos del Reglamento General de Protección de Datos (GDPR). Nuestra base legal para procesar tus datos incluye el desempeño del contrato, intereses legítimos y tu consentimiento."
        ]
      },
      {
        "title": "9. Contáctanos",
        "paragraphs": [
          "Si tienes alguna pregunta o inquietud sobre nuestra política de privacidad, por favor contacta a nuestro equipo de protección de datos en miral_support@miralvis.com."
        ]
      }
    ]
  },
  "terms": {
    "title": "Términos de Servicio",
    "lastUpdated": "Última actualización: 15 de enero de 2025",
    "navPrivacy": "Política de Privacidad →",
    "navTrust": "Confianza y Seguridad →",
    "sections": [
      {
        "title": "1. Descripción del Servicio",
        "paragraphs": [
          "Miral (en adelante denominado \"la Plataforma\") es una plataforma de IA que integra creación de imagen, video y música. Estos Términos de Servicio (en adelante denominados \"Términos\") rigen las condiciones y reglas para tu uso de la Plataforma.",
          "Al usar la Plataforma, aceptas estar sujeto a estos Términos. Si no estás de acuerdo con estos Términos, por favor no uses la Plataforma."
        ]
      },
      {
        "title": "2. Registro de Cuenta",
        "paragraphs": [
          "Debes tener al menos 18 años para registrar una cuenta. Necesitas proporcionar información de registro precisa y completa y eres responsable de mantener la seguridad de la cuenta.",
          "Eres responsable de todas las actividades realizadas a través de tu cuenta. Si descubres cualquier uso no autorizado, por favor notifícanos de inmediato."
        ]
      },
      {
        "title": "3. Uso del Servicio",
        "paragraphs": [
          "La Plataforma proporciona servicios de generación de contenido IA basados en créditos. Los créditos pueden obtenerse a través de suscripción o compra única. Diferentes modelos y características de IA consumen diferentes cantidades de créditos.",
          "Aceptas no usar la Plataforma para ningún propósito ilegal, dañino o infractor. Está prohibido generar contenido ilegal, pornográfico, violento o que infrinja derechos."
        ]
      },
      {
        "title": "4. Propiedad Intelectual",
        "paragraphs": [
          "Los derechos de propiedad intelectual del contenido que generas a través de la Plataforma te pertenecen, sujeto a los términos de uso de cada proveedor de modelos de IA.",
          "Las marcas comerciales, logotipos, diseños de interfaz y código de software de la Plataforma están protegidos por las leyes de propiedad intelectual y no pueden usarse sin autorización."
        ]
      },
      {
        "title": "5. Pagos y Reembolsos",
        "paragraphs": [
          "Todos los pagos están en dólares estadounidenses. Las tarifas de suscripción se cobran mensual o anualmente, dependiendo del plan elegido.",
          "Para primeras compras de paquetes únicos o primeras suscripciones, los reembolsos pueden solicitarse dentro de 7 días calendario si el uso de créditos es inferior al 3%."
        ]
      },
      {
        "title": "6. Exención de Responsabilidad",
        "paragraphs": [
          "La Plataforma proporciona servicios \"tal cual\" y no hace garantías expresas o implícitas sobre la disponibilidad, precisión o idoneidad de los servicios.",
          "El contenido generado por IA puede ser inexacto o imperfecto. Los usuarios deben juzgar por sí mismos la aplicabilidad del contenido generado."
        ]
      },
      {
        "title": "7. Limitación de Responsabilidad",
        "paragraphs": [
          "Hasta el máximo permitido por la ley, la Plataforma no es responsable de ningún daño directo, indirecto, incidental o consecuente que resulte del uso o incapacidad de usar los servicios.",
          "La responsabilidad total de la Plataforma no excede el total de las tarifas que pagaste en los últimos 12 meses."
        ]
      },
      {
        "title": "8. Modificación de Términos",
        "paragraphs": [
          "Nos reservamos el derecho de modificar estos Términos en cualquier momento. Los Términos modificados entran en vigor cuando se publican en esta página.",
          "El uso continuado de la Plataforma indica la aceptación de los Términos modificados. Los cambios significativos se notificarán por correo electrónico o notificación de la Plataforma."
        ]
      },
      {
        "title": "9. Contáctanos",
        "paragraphs": [
          "Si tienes alguna pregunta sobre estos Términos, por favor contáctanos en miral_support@miralvis.com."
        ]
      }
    ]
  },
  "trustSafety": {
    "tag": "🛡️ Confianza y Seguridad",
    "title": "La Seguridad de tus Datos es Nuestra Máxima Prioridad",
    "subtitle": "Aprende cómo protegemos tu privacidad y seguridad de datos.",
    "badges": [
      {
        "icon": "🛡️",
        "title": "Sin Entrenamiento IA",
        "desc": "Tu contenido subido y trabajos generados nunca se usan para entrenar ningún modelo de IA."
      },
      {
        "icon": "🔒",
        "title": "Encriptación Extremo a Extremo",
        "desc": "Todas las transferencias de datos usan encriptación TLS 1.3, los datos almacenados usan encriptación AES-256."
      },
      {
        "icon": "✓",
        "title": "Cumple GDPR",
        "desc": "Totalmente conforme con los requisitos del Reglamento General de Protección de Datos de la UE."
      },
      {
        "icon": "🗑️",
        "title": "Control Autónomo de Datos",
        "desc": "Puedes exportar o eliminar todos tus datos en cualquier momento, incluyendo la eliminación de la cuenta."
      }
    ],
    "sections": [
      {
        "title": "Transparencia del Procesamiento de Datos",
        "paragraphs": [
          "Somos completamente transparentes sobre cómo manejamos los datos. Las imágenes y videos que subes se usan solo para generar el contenido que solicitas y se eliminan de los servidores dentro de las 24 horas posteriores al procesamiento.",
          "El contenido generado se almacena en tu cuenta, y puedes descargarlo o eliminarlo en cualquier momento. No compartimos tu contenido sin tu consentimiento."
        ]
      },
      {
        "title": "Infraestructura Segura",
        "paragraphs": [
          "Nuestros servicios están implementados en infraestructura en la nube de clase mundial con protección de seguridad de múltiples capas. Todos los servidores están ubicados en centros de datos certificados por SOC 2 e ISO 27001.",
          "Realizamos auditorías de seguridad regulares y pruebas de penetración para garantizar la seguridad del sistema. Todos los empleados reciben entrenamiento de seguridad estricto."
        ]
      },
      {
        "title": "Seguridad del Contenido",
        "paragraphs": [
          "Desplegamos sistemas de seguridad de contenido avanzados que detectan y bloquean automáticamente la generación de contenido dañino. Esto incluye pero no se limita a contenido violento, pornográfico e infractor.",
          "Si descubres algún contenido que viole las reglas, por favor repórtalo en abuse@miral.org."
        ]
      },
      {
        "title": "Cumplimiento y Certificación",
        "paragraphs": [
          "Cumplimos con las principales regulaciones de protección de datos globales, incluyendo GDPR (UE), CCPA (California) y LGPD (Brasil).",
          "Nuestro procesamiento de pagos cumple con los estándares PCI DSS, garantizando que tu información de pago esté segura."
        ]
      }
    ],
    "ctaTitle": "¿Preocupaciones de Seguridad?",
    "ctaDesc": "Nuestro equipo de seguridad está listo para responder a tus preguntas",
    "ctaButton": "Contactar Equipo de Seguridad",
    "navTerms": "Términos de Servicio →",
    "navPrivacy": "Política de Privacidad →"
  },
  "gallery": {
    "tag": "Historial de Creación",
    "title": "Mis Creaciones",
    "subtitle": "Vista todo tu historial de creación IA.",
    "loginRequired": "Por favor inicia sesión para ver tu historial de creación",
    "empty": "Aún sin creaciones",
    "loadMore": "Cargar Más",
    "filters": {
      "all": "Todas",
      "pending": "Procesando",
      "finish": "Terminado",
      "failed": "Fallido"
    },
    "usePrompt": "Generar con este prompt",
    "download": "Descargar",
    "status": {
      "pending": "Procesando",
      "finish": "Terminado",
      "failed": "Fallido"
    }
  },
  "inspiration": {
    "title": "Inspiración",
    "subtitle": "Mira lo que los creadores están construyendo con Miral — desde imágenes hiperrealistas hasta videos cinematográficos, inspiración a tu alcance.",
    "filters": {
      "all": "Todas",
      "image": "Imagen",
      "video": "Video",
      "portrait": "Retrato",
      "landscape": "Paisaje",
      "fantasy": "Fantasía",
      "anime": "Anime"
    }
  },
  "payment": {
    "success": {
      "title": "Pago Exitoso",
      "message": "¡Gracias por tu compra! Tu pedido ha sido procesado exitosamente y los créditos han sido agregados a tu cuenta.",
      "goHome": "Ir a Inicio",
      "viewProfile": "Ver Perfil"
    },
    "cancel": {
      "title": "Pago Cancelado",
      "message": "Tu pago ha sido cancelado. Si tienes alguna pregunta, no dudes en contactar a nuestro equipo de soporte.",
      "tryAgain": "Intentar de Nuevo",
      "goHome": "Ir a Inicio"
    }
  },
  "plans": {
    "basic": {
      "name": "Basic",
      "features": [
        "All credits delivered at once",
        "Generate up to 2,600 AI images",
        "Generate 520 AI videos",
        "Generate up to 480 AI music tracks",
        "No watermarks",
        "Commercial license"
      ]
    },
    "pro": {
      "name": "Pro",
      "features": [
        "All credits delivered at once",
        "Generate up to 10,600 AI images",
        "Generate up to 2,120 AI videos",
        "Generate up to 1,920 AI music tracks",
        "All premium models",
        "Priority queue",
        "Priority support",
        "Privacy mode & DPA compliance"
      ]
    },
    "ultimate": {
      "name": "Ultimate",
      "features": [
        "All credits delivered at once",
        "Generate up to 36,600 AI images",
        "Generate up to 7,320 AI videos",
        "Generate up to 6,720 AI music tracks",
        "All premium models",
        "Dedicated support",
        "Privacy mode & DPA compliance"
      ]
    }
  },
  "seo": {
    "default": {
      "title": "Miral - Plataforma de creación AI de imágenes, vídeos y música",
      "description": "Miral es una plataforma todo en uno que soporta los mejores modelos IA como Seedream 4, Midjourney, GPT Image, Veo 3 y Sora 2.",
      "keywords": "generador de imágenes IA, generador de vídeos IA, generador de música IA, texto a imagen, Seedream, Midjourney, Veo, Sora, Miral"
    },
    "home": { "title": "Miral: generador de imágenes, vídeos y música con IA", "description": "Crea imágenes, vídeos y música de alta calidad en Miral con modelos líderes como Seedream 5, Midjourney, Veo 3.1, Sora 2 y más, todo desde una sola plataforma." },
    "pricing": { "title": "Precios - Miral", "description": "Miral ofrece precios flexibles. Compra créditos, paga por uso, sin suscripción." },
    "profile": { "title": "Perfil - Miral", "description": "Gestiona tu cuenta Miral, consulta el historial de pedidos." },
    "models": { "title": "Modelos IA - Miral", "description": "Explora los mejores modelos IA en Miral: imagen, vídeo y música." },
    "music": { "title": "Generador de música IA - Miral", "description": "Crea música única a partir de descripciones de texto con la IA de Miral." },
    "tools": { "title": "Herramientas de imagen IA - Miral", "description": "Miral ofrece herramientas de procesamiento de imagen IA: eliminación de marca de agua, fondo, mejora." },
    "inspiration": { "title": "Inspiración - Miral", "description": "Explora las creaciones destacadas de la comunidad Miral." },
    "gallery": { "title": "Mi galería - Miral", "description": "Consulta y gestiona todas tus creaciones en Miral." },
    "faq": { "title": "Preguntas frecuentes - Miral", "description": "Preguntas frecuentes sobre la plataforma Miral." },
    "about": {
      "title": "About Us - Miral",
      "description": "Learn about the Miral AI platform for image, video, and music creation."
    },
    "contact": {
      "title": "Contact Us - Miral",
      "description": "Contact Miral support for help and feedback."
    },
    "terms": { "title": "Términos de servicio - Miral", "description": "Términos de servicio y acuerdo de usuario de Miral." },
    "privacy": { "title": "Política de privacidad - Miral", "description": "Política de privacidad y protección de datos de Miral." },
    "trustSafety": { "title": "Confianza y seguridad - Miral", "description": "Políticas de confianza y seguridad de Miral." },
    "models": {
      "wan25": { "title": "Wan 2.5 - Modelo de vídeo IA potente", "description": "Wan 2.5 ofrece generación de vídeo IA de nueva generación. Crea vídeos realistas y fluidos con movimiento y detalle avanzados, ideal para creadores y empresas." },
      "wan26": { "title": "Wan 2.6 - Generador de vídeo IA mejorado", "description": "Mejora tu creación de vídeo con Wan 2.6. Este modelo IA avanzado genera vídeos ultrarrealistas con movimiento, detalle y velocidad mejorados para contenido profesional." },
      "wan22": { "title": "Wan 2.2 - Generador de vídeo IA rápido", "description": "Wan 2.2 es un modelo de vídeo IA rápido y fiable. Genera vídeos de alta calidad rápidamente, ideal para creadores que necesitan producción profesional eficiente." },
      "wanAnimate": { "title": "Wan Animate - Animación de personajes - Miral", "description": "Anima personajes con imagen y vídeo de referencia mediante Alibaba Wan 2.2 Animate." },
      "veo30": { "title": "Veo 3.0 - Modelo de vídeo IA líder", "description": "Veo 3.0 es un generador de vídeo IA de primer nivel. Crea vídeos realistas y cinematográficos con IA avanzada, perfecto para creación de contenido profesional." },
      "veo31": { "title": "Veo 3.1 - Mejor generación de vídeo IA", "description": "Veo 3.1 es un modelo de vídeo IA líder para vídeos impresionantes y realistas. Crea clips cinematográficos y animaciones con calidad y velocidad inigualables." },
      "kling26": { "title": "Kling 2.6 - Modelo de vídeo IA premium", "description": "Kling 2.6 da vida a la generación de vídeo IA profesional. Genera vídeos de alta calidad y fluidos con IA avanzada para creadores, especialistas en marketing y empresas." },
      "kling25": { "title": "Kling 2.5 - Modelo de vídeo IA fiable", "description": "Kling 2.5 ofrece potente generación de vídeo IA para creadores. Produce vídeos de alta calidad con movimiento fluido y detalle, perfecto para contenido y marketing." },
      "seedance": { "title": "Seedance AI - Generador de vídeo IA avanzado", "description": "Genera vídeos IA de alta calidad con Seedance AI. Crea clips, animaciones y contenido cinematográfico con modelos IA de vanguardia para resultados profesionales rápidos." },
      "sora2": { "title": "Generador de vídeo IA Sora 2 – Texto e imagen a vídeo | Miral", "description": "Crea vídeos Sora 2 desde texto o imágenes en Miral. Pruébalo con créditos gratis y elige 4–12 s, 720p/1080p y formato 16:9/9:16." },
      "hailuo23": { "title": "Hailuo 2.3 - Generador de vídeo IA inteligente", "description": "Hailuo 2.3 ofrece generación de vídeo IA inteligente. Crea vídeos creativos de alta calidad con IA avanzada para creadores de contenido y empresas." },
      "runway": { "title": "Runway - Plataforma de creación de vídeo IA", "description": "Runway es una plataforma de vídeo IA líder para creadores. Edita, genera y mejora vídeos con herramientas IA potentes, perfecta para producción de contenido profesional." },
      "nanobanana": { "title": "Nano Banana - Generador de imagen IA - Miral", "description": "Genera rápidamente imágenes creativas con Nano Banana." },
      "seedream4": { "title": "Seedream 4 - Generador de imágenes IA", "description": "Crea imágenes IA impresionantes en alta resolución con Seedream 4. Genera arte fotorrealista, ilustraciones y diseños con IA avanzada para trabajo creativo profesional." },
      "midjourney": { "title": "Midjourney - Generador de arte IA", "description": "Midjourney es un generador de arte IA líder. Crea imágenes y diseños impresionantes desde texto, perfecto para artistas, diseñadores y creadores de contenido." },
      "gptimage1": { "title": "GPT-Image-1 - Modelo de imágenes IA OpenAI", "description": "GPT-Image-1 de OpenAI genera imágenes IA de alta calidad desde texto. Crea visuales realistas y creativos para diseño, marketing y creación de contenido." },
      "gptimage15": { "title": "GPT Image 1.5 - OpenAI imagen IA - Miral", "description": "Genera imágenes IA con OpenAI GPT Image 1.5." },
     "fluxpro11ultra": { "title": "Flux Pro 1.1 Ultra - Generador de imágenes IA premium", "description": "Flux Pro 1.1 Ultra ofrece generación de imágenes IA ultra alta calidad. Crea imágenes fotorrealistas y detalladas con IA avanzada para diseño profesional." },
      "fluxschnell": { "title": "Flux Schnell - Generador de imágenes IA rápido", "description": "Flux Schnell es un generador de imágenes IA ultrarrápido. Crea imágenes de alta calidad rápidamente, ideal para creadores que necesitan contenido visual profesional rápido." },
      "flux2": {
        "title": "FLUX.2 - Generador de imágenes IA - Miral",
        "description": "Genera imágenes IA profesionales con FLUX.2 — 5 variantes para velocidad, calidad y control."
      },
      "zimageturbo": {
        "title": "Z Image Turbo - Generador de imágenes IA - Miral",
        "description": "Genera imágenes de alta resolución con el modelo Z Image Turbo."
      }
    },
    "tools": {
      "watermarkRemover": { "title": "Eliminador de marcas de agua con IA gratis | Miral", "description": "Elimina online marcas de agua, logotipos, fechas, textos y sellos de fotos con IA. Conserva los detalles y exporta resultados limpios en JPG, PNG o WebP." },
      "backgroundRemover": { "title": "Eliminador de fondos con IA gratis online | Miral", "description": "Elimina gratis fondos de imágenes con IA. Recorta retratos y productos, conserva cabello y bordes finos y crea PNG transparentes desde JPG, PNG o WebP." },
      "imageEraser": { "title": "Borrador de Imágenes IA - Eliminar objetos de fotos", "description": "Borra objetos, personas, marcas de agua y texto no deseados de fotos con IA. Pasa el pincel sobre el área y la IA lo elimina sin costuras rellenando el hueco con contenido natural. Perfecto para limpiar imágenes." },
      "objectRemover": { "title": "Eliminador de Objetos IA - Eliminar objetos de fotos", "description": "Elimina objetos no deseados de fotos con IA. Pasa el pincel sobre el objeto y la IA lo elimina sin costuras rellenando el área con contenido natural. Perfecto para limpiar tus fotos." },
      "aiPersonRemover": { "title": "Eliminador de Personas IA - Eliminar personas de fotos", "description": "Elimina personas de fotos con IA. Pasa el pincel sobre cualquier persona y la IA la elimina sin costuras rellenando el área con contenido natural. Perfecto para eliminar transeúntes y desconocidos de tus fotos." },
      "whiteBackground": { "title": "Fondo Blanco IA - Reemplazar fondo por blanco", "description": "Reemplaza fondos de imágenes por blanco automáticamente con IA. Ideal para fotos de producto e-commerce, fotos de identificación y catálogos." },
      "blueBackground": { "title": "Fondo Azul IA - Reemplazar fondo por azul", "description": "Reemplaza fondos de imágenes por azul automáticamente con IA. Ideal para fotos de pasaporte, fotos de identificación y documentos oficiales." },
      "faceSwap": { "title": "Intercambio de rostros IA - Intercambiar rostros en fotos", "description": "Intercambia rostros en fotos con IA. Sube una foto objetivo y un rostro fuente para fusionar rostros de forma transparente con resultados realistas y naturales." },
      "imageEnhancer": { "title": "Mejorador de imagen IA - Ampliar y mejorar", "description": "Mejora y amplía imágenes con IA. Afina detalles, corrige desenfoque, aumenta resolución y restaura fotos antiguas para resultados profesionales." },
      "docCropEnhance": { "title": "Recorte y corrección de documentos con IA | Miral", "description": "Recorta y corrige documentos, exámenes, tareas y libros online. Repara inclinación, perspectiva, páginas curvas y sombras para obtener escaneos nítidos." },
      "handwrittenErase": { "title": "Borrador IA de escritura para exámenes y tareas | Miral", "description": "Borra respuestas manuscritas de exámenes, tareas y cuadernos con IA sin eliminar el texto impreso. Incluye rotación, recorte y corrección de páginas." }
    },
    imageModels: {
            title: "Modelos de imágenes de IA - Miral",
            description: "Explore los mejores modelos de imágenes de IA en Miral y genere imágenes impresionantes a partir de mensajes de texto.",
            relatedModelsTitle: "Explore más modelos de imágenes de IA",
            demoPrompt: "Mensaje de texto",
            demoOutput: "Imagen generada",
            demoPlaceholder: "Imagen de muestra: próximamente",
            promptLabel: "Crear con",
            usePrompt: "Utilice este mensaje →",
            imagePlaceholder: "Ejemplo de imagen de IA",
            replaceImageHint: "Generado a partir del mensaje que se muestra al lado de esta imagen",
            flux1: {
                title: "Generador de imágenes AI FLUX.1 gratis en línea | miral",
                description: "Cree imágenes de IA de alta calidad en línea con FLUX.1 usando Flux Pro 1.1 Ultra o Flux Schnell. Explora nueve relaciones de aspecto, estilos visuales y créditos gratuitos.",
                heroHeadline: "Generador de imágenes AI FLUX.1",
                heroIntro: "Utilice el generador de imágenes AI FLUX.1 de Black Forest Labs de forma gratuita en Miral AI. Regístrese para recibir créditos gratuitos y elija entre la producción de alta calidad de Flux Pro 1.1 Ultra y la creación rápida y multiestilo de Flux Schnell.",
                eyebrow: "Laboratorios de la Selva Negra · FLUX.1",
                sectionKicker: "FLUJO.1",
                ctaTag: "FLUJO.1 · Miral",
                badges: ["Texto a imagen", "9 relaciones de aspecto", "Pro y Schnell", "Fotografía / Arte digital / Anime"],
                previewLabel: "Flujo Pro 1.1 Ultra",
                previewMeta: ["1:1", "16:9", "9:16", "9 proporciones"],
                previewTitle: "Elija entre calidad refinada y exploración creativa rápida",
                previewDesc: "Utilice Pro 1.1 Ultra para obtener imágenes detalladas o Schnell para explorar rápidamente direcciones fotográficas, de arte digital y de anime.",
                keyFeaturesTitle: "Cree imágenes de alta calidad con el generador de texto a imagen FLUX.1",
                keyFeaturesIntro: "Explore las funciones de Flux Pro 1.1 Ultra y Flux Schnell para una rápida comprensión, velocidad de salida, estilos visuales y relaciones de aspecto flexibles.",
                exploreTitle: "Explore más modelos de imágenes de IA",
                mainFeaturesTitle: "Características clave de FLUX.1",
                generatedImageLabel: "Imagen generada",
                versionLabel: "Versión",
                featureLabel: "Características clave",
                useCaseLabel: "Mejor para",
                controlsTitle: "Elija el modelo, la proporción y el estilo visual adecuados",
                controlsIntro: "Utilice Flux Pro 1.1 Ultra para obtener imágenes finales pulidas o Flux Schnell para una exploración más rápida, luego haga coincidir la relación de aspecto y el estilo con el canal deseado.",
                galleryTitle: "Más ejemplos de imágenes de FLUX.1",
                discussionTitle: "Preguntas comunes sobre la selección de FLUX.1",
                communityTitle: "Formas populares de crear con FLUX.1",
                tutorialPrompt: "Una tranquila librería en un invernadero junto al mar al amanecer, cálidas lámparas de lectura, estanterías de roble pálido, suaves reflejos en el suelo, fotografías de interiores realistas.",
                qualityBenefits: [
                    "Represente materiales, iluminación y profundidad espacial con un acabado más pulido.",
                    "Siga indicaciones detalladas que combinan tema, composición, cámara y estilo.",
                    "Explore instrucciones fotográficas, de arte digital y anime a partir de instrucciones de texto claro."
                ],
                features: [
                    { name: "Texto a imagen FLUX.1 de alta calidad", short: "Convierta las indicaciones escritas en imágenes detalladas y profesionales.", desc: "Flux Pro 1.1 Ultra es adecuado para trabajos donde los detalles de la imagen, los materiales, la iluminación y el acabado general son importantes. Describir claramente el tema, la composición, la cámara y el estilo ayuda a orientar la imagen hacia la dirección de su proyecto.", demo: { type: 'table', rows: [
                        { prompt: "Exterior de un hotel boutique en el desierto a la hora azul, paredes de tierra apisonada, cálido resplandor de ventanas, pastos nativos, largas sombras, fotografía arquitectónica realista.", image: require('@/assets/images/flux1/b9d1e267-bb35-4d5c-a196-fae49460749d.webp') },
                        { prompt: "Fotografía editorial de comida de raviolis hechos a mano en un plato negro mate, aceite de albahaca, servilleta de lino, luz de ventana direccional, poca profundidad de campo.", image: require('@/assets/images/flux1/2ab9dde4-0420-4594-b875-a8465741b767.webp') }
                    ] } },
                    { name: "Generación rápida con Flux Schnell", short: "Cree borradores rápidos, pruebe sugerencias y explore ideas rápidamente.", desc: "Flux Schnell es ideal para flujos de trabajo que necesitan pruebas rápidas de composición, estilo o concepto. Genere un borrador, revise la dirección y luego refine el mensaje para otra iteración.", prompt: "Un concepto de stand de feria modular de cartón para una startup ecológica, pedestales de productos simples, texturas de papel reciclado, iluminación de exposición brillante y diseño limpio.", image: require('@/assets/images/flux1/b8ffe8cb-1d2f-4bfc-897f-1068861614f9.webp') },
                    { name: "Nueve relaciones de aspecto de imagen", short: "Cubre formatos ultraanchos, horizontales, cuadrados, verticales y altos.", desc: "Flux Pro 1.1 Ultra y Flux Schnell admiten 21:9, 16:9, 4:3, 3:2, 1:1, 2:3, 3:4, 9:16 y 9:21 para pancartas, imágenes de productos, contenido social, carteles y elementos visuales móviles.", prompt: "Un observatorio alpino panorámico de 21:9 sobre un mar de nubes, plataforma de observación de cristal, luz de primera hora de la mañana, pequeños excursionistas a escala, pintura mate cinematográfica.", image: require('@/assets/images/flux1/a5efd8d2-571d-406d-9a01-f30581d4ea3b.webp') },
                    { name: "Múltiples estilos visuales en Schnell", short: "Elija Automático, Fotográfico, Arte digital o Anime.", desc: "Flux Schnell ofrece direcciones de estilo Automático, Fotográfico, Arte Digital y Anime, lo que facilita el cambio entre imágenes fotorrealistas, ilustradas y de anime sin cambiar de modelo.", demo: { type: 'table', rows: [
                        { prompt: "Estilo fotográfico: un mecánico de bicicletas ajustando una bicicleta de carreras antigua en un garaje iluminado por el sol, manos manchadas de grasa, reflejos cromados realistas.", image: require('@/assets/images/flux1/2b870b40-a436-42b9-980f-538e303cdfce.webp') },
                        { prompt: "Estilo anime: una acogedora cafetería para gatos dentro de un tren aéreo, nubes en tonos pastel al atardecer fuera de las ventanas, personajes expresivos y arte lineal limpio.", image: require('@/assets/images/flux1/faded76c-4da1-49bb-98dc-10b8276f7da8.webp') }
                    ] } },
                    { name: "Casos de uso creativos flexibles", short: "Cree productos, marketing, retratos, conceptos y elementos visuales sociales.", desc: "La familia FLUX.1 admite imágenes pulidas de productos y marcas, así como conceptos de campaña rápidos, retratos, diseños de entornos y relaciones de aspecto específicas de la plataforma.", prompt: "Imagen de lanzamiento de zapatillas sostenibles con textura de tela reciclada, detalles de encaje flotante, fondo degradado verde musgo y espacio vacío en negrita para el texto de un anuncio social.", image: require('@/assets/images/flux1/0dfa0b4b-7722-40f4-9bc0-7bbf9bb1c000.webp') }
                ],
                showcaseKicker: "Ejemplos rápidos",
                showcaseTitle: "Ejemplos de indicaciones de FLUX.1 para obtener mejores imágenes de IA",
                showcaseIntro: "Utilice estas indicaciones de FLUX.1 como punto de partida. Describe claramente el tema, la composición, la iluminación, la cámara, los materiales, la paleta de colores y el estilo visual.",
                variantsKicker: "guía de modelos",
                variantsTitle: "¿Por qué es Flux Pro 1.1 Ultra mejor que Flux Schnell?",
                variantsIntro: "Elija un modelo FLUX.1 según la calidad, velocidad y control de estilo que su proyecto necesita.",
                variants: [
                    { name: "Flujo Pro 1.1 Ultra", tag: "Alta calidad", desc: "Diseñado para un trabajo de texto a imagen detallado, realista y pulido con nueve relaciones de aspecto compatibles.", bestFor: "Lo mejor para fotografía de productos, imágenes destacadas de campañas y efectos visuales finales pulidos." },
                    { name: "Flujo Schnell", tag: "Rápido", desc: "Diseñado para una iteración rápida con nueve relaciones de aspecto y estilos Automático, Fotográfico, Arte digital y Anime.", bestFor: "Lo mejor para borradores, pruebas rápidas, contenido social y exploración rápida" }
                ],
                useCasesKicker: "Hecho para el trabajo real",
                useCasesTitle: "Casos de uso populares de FLUX.1",
                useCases: [
                    { name: "FLUX.1 para fotografía de productos", desc: "Cree imágenes destacadas de productos, escenas de estilos de vida y conceptos visuales de comercio electrónico." },
                    { name: "FLUX.1 para marketing y publicidad", desc: "Genere anuncios sociales, pancartas de campaña y elementos visuales de marketing de marca." },
                    { name: "FLUX.1 para retratos fotorrealistas", desc: "Cree retratos similares a fotografías con iluminación, fondos y composición controlados." },
                    { name: "FLUX.1 para arte digital", desc: "Utilice Schnell para explorar rápidamente direcciones de ilustración, fantasía y arte digital." },
                    { name: "FLUX.1 para imágenes de anime", desc: "Utilice el estilo Schnell Anime para personajes y escenas de anime." },
                    { name: "FLUX.1 para arte conceptual", desc: "Explora entornos cinematográficos, escenas de juegos, personajes y mundos visuales." },
                    { name: "FLUX.1 para imágenes de redes sociales", desc: "Utilice nueve relaciones de aspecto para contenido de plataforma horizontal, cuadrado y vertical." },
                    { name: "FLUX.1 para carteles y pancartas", desc: "Elija una proporción adecuada para eventos, promociones y conceptos de diseño de páginas móviles." }
                ],
                howToKicker: "Tres sencillos pasos",
                howToTitle: "Cómo utilizar el generador de imágenes AI FLUX.1 en línea de forma gratuita",
                howToIntro: "Regístrese para recibir créditos gratis y use Flux Pro 1.1 Ultra o Flux Schnell en línea en Miral.",
                howToSteps: [
                    { title: "Ingrese un mensaje detallado", desc: "Describe el tema, el escenario, la composición, la iluminación, la cámara, los materiales, los colores y el estilo del objetivo." },
                    { title: "Elija modelo y relación", desc: "Elija Pro 1.1 Ultra para una calidad pulida o Schnell para una exploración rápida, luego establezca una relación de aspecto y un estilo Schnell." },
                    { title: "Generar y refinar", desc: "Genere la imagen, revísela y descárguela, o ajuste el mensaje, la proporción o el estilo para otra versión." }
                ],
                howToCta: "Utilice el generador de imágenes AI FLUX.1 gratis",
                faqTitle: "Preguntas frecuentes sobre FLUX.1",
                faqs: [
                    { q: "¿Qué es el generador de imágenes AI FLUX.1?", a: "FLUX.1 es una familia de modelos de generación de imágenes de Black Forest Labs. En Miral, utilice Flux Pro 1.1 Ultra y Flux Schnell para convertir mensajes de texto en imágenes de productos, marketing, retratos, anime y arte conceptual." },
                    { q: "¿Puedo utilizar el generador de imágenes AI FLUX.1 de forma gratuita?", a: "Sí. Regístrese para recibir créditos gratuitos y comience a crear imágenes de alta calidad con el generador de imágenes AI FLUX.1 de inmediato. La generación de imágenes utiliza los créditos correspondientes." },
                    { q: "¿Cuál es la diferencia entre Flux Pro 1.1 Ultra y Flux Schnell?", a: "Flux Pro 1.1 Ultra es adecuado para imágenes finales pulidas donde el detalle y el acabado importan. Flux Schnell es adecuado para borradores rápidos, pruebas rápidas y exploración de múltiples estilos, con estilos Automático, Fotográfico, Arte Digital y Anime." },
                    { q: "¿Qué relaciones de aspecto de imagen admite FLUX.1?", a: "Flux Pro 1.1 Ultra y Flux Schnell en Miral admiten 21:9, 16:9, 4:3, 3:2, 1:1, 2:3, 3:4, 9:16 y 9:21, para un total de nueve relaciones de aspecto." },
                    { q: "¿Qué estilos admite Flux Schnell?", a: "Flux Schnell admite imágenes automáticas, fotográficas, de arte digital y de anime para coincidencias automáticas, imágenes fotorrealistas, ilustraciones digitales y efectos visuales de anime." },
                    { q: "¿Cómo uso el generador de imágenes AI FLUX.1 en línea?", a: "Ingrese un mensaje de texto, elija Flux Pro 1.1 Ultra o Flux Schnell y establezca una relación de aspecto. Con Schnell, también puede seleccionar un estilo visual antes de hacer clic en Generar." },
                    { q: "¿Cuáles son los mejores ejemplos de indicaciones de FLUX.1?", a: "Las indicaciones efectivas de FLUX.1 describen claramente el tema, el entorno, la composición, la iluminación, la cámara, los materiales, la paleta de colores y el estilo del objetivo. Utilice los ejemplos de esta página como punto de partida y adáptelos a su proyecto." },
                    { q: "FLUX.1 vs FLUX.2: ¿cuál debo usar?", a: "Elija FLUX.1 para obtener resultados pulidos con Flux Pro 1.1 Ultra o una creación rápida de múltiples estilos con Flux Schnell. Elija la página FLUX.2 en Miral cuando necesite sus variantes Klein, Max, Pro y Flex." },
                    { q: "FLUX.1 vs Midjourney: ¿cuál debo usar?", a: "FLUX.1 es ideal para relaciones de aspecto explícitas, el rápido flujo de trabajo Schnell o la salida pulida Pro 1.1 Ultra. Midjourney puede ser adecuado para usuarios que prefieren sus estilos artísticos, flujo de trabajo de imágenes de referencia y proceso creativo." }
                ],
                ctaTitle: "¡Usa FLUX.1 gratis en Miral!",
                ctaDesc: "Regístrate para recibir créditos gratis. Elija Flux Pro 1.1 Ultra o Flux Schnell y cree imágenes con la proporción y el estilo que su proyecto necesita."
            },
            flux2: {
                title: "Generador de imágenes AI FLUX.2 gratis en línea | miral",
                description: "Cree imágenes de IA fotorrealistas en línea con FLUX.2. Elija cinco variantes de modelo para fotografías de productos, carteles, obras de arte y elementos visuales de marketing refinados.",
                heroHeadline: "Generador de imágenes AI FLUX.2",
                heroIntro: "Utilice el generador de imágenes AI FLUX.2 de Black Forest Labs de forma gratuita en Miral AI. Regístrese para recibir créditos gratuitos y crear instantáneamente imágenes fotorrealistas, fotografías de productos, carteles y elementos visuales de marketing de alta calidad.",
                eyebrow: "Laboratorios de la Selva Negra · FLUX.2",
                sectionKicker: "FLUJO.2",
                ctaTag: "FLUJO.2 · Miral",
                badges: ["Texto a imagen", "Fotorrealista", "Tipografía precisa", "Múltiples relaciones de aspecto"],
                previewLabel: "FLUJO.2",
                previewMeta: ["1:1", "1024 × 1024", "PNG"],
                previewTitle: "Desde un aviso preciso hasta una imagen lista para producción",
                previewDesc: "Cree fotografías detalladas de productos, conceptos de campañas, retratos y diseños ricos en texto en un flujo de trabajo optimizado.",
                keyFeaturesTitle: "Cree imágenes profesionales con el generador de texto a imagen FLUX.2",
                keyFeaturesIntro: "Explore las funciones clave del generador de imágenes con IA FLUX.2 para obtener indicaciones precisas, detalles pulidos, resultados realistas y control visual confiable.",
                exploreTitle: "Explore más modelos de imágenes de IA",
                mainFeaturesTitle: "Características clave de FLUX.2",
                generatedImageLabel: "Imagen generada",
                versionLabel: "Versión",
                featureLabel: "Características clave",
                useCaseLabel: "Mejor para",
                controlsTitle: "Elija la versión y configuración de salida correctas de FLUX.2",
                controlsIntro: "Utilice Klein para iteraciones rápidas, Max para obtener la mejor calidad final, Pro para flujos de trabajo de producción o Flex para tipografía y control de detalles finos.",
                galleryTitle: "Más ejemplos de imágenes de FLUX.2",
                discussionTitle: "Preguntas comunes sobre el modelo FLUX.2",
                communityTitle: "Formas populares de crear con FLUX.2",
                tutorialPrompt: "Fotografía de campaña premium de un frasco de perfume esmeralda translúcido sobre piedra caliza pálida, luz suave de la mañana, refracción de vidrio realista, tipografía refinada y generoso espacio negativo.",
                qualityBenefits: [
                    "Siga indicaciones detalladas con un mayor control sobre el tema, la composición, la iluminación y el estilo.",
                    "Cree texturas realistas, profundidad y detalles pulidos para un trabajo visual profesional.",
                    "Maneje carteles ricos en texto, etiquetas de productos y gráficos de campaña con una tipografía más clara."
                ],
                features: [
                    { name: "Síntesis de imágenes de alta gama", short: "Ofrece adherencia rápida mejorada y calidad de imagen sin latencia adicional.", desc: "FLUX.2 mejora enormemente la alineación rápida e incluso admite entradas de formato largo, como guiones detallados y descripciones de escenas. Garantiza que las imágenes generadas ofrezcan mayor fidelidad sin comprometer la velocidad, lo que reduce la necesidad de ajustes iterativos y permite a los creadores alcanzar un resultado final más rápido.", demo: { type: 'table', rows: [
                        { prompt: "Un paisaje impresionante con colores vibrantes y detalles intrincados, que muestra una puesta de sol sobre una cadena montañosa.",image: require('@/assets/images/flux2/1a2627bd-61e0-406a-9308-19f2883d004e.webp') },
                        { prompt: "Arte abstracto para traducir entre lenguajes funcionales y lenguajes de bajo nivel." ,image: require('@/assets/images/flux2/sample.webp')},
                        { prompt: "Una foto de un personaje de anime/caricatura, detallada y bien hecha, pero que parece hecha por humanos." ,image: require('@/assets/images/flux2/57047990-2e26-4b44-bacf-f10bca5ee70d.webp')}
                    ] } },
                    { name: "Detalle y realismo superiores", short: "Produce texturas, iluminación y profundidad realistas para imágenes de estudio.", desc: "FLUX.2 captura texturas finas, iluminación realista y profundidad natural que hacen que las imágenes generadas parezcan genuinamente fotográficas. Esto lo convierte en una opción ideal para fotografías de productos, retratos y efectos visuales cinematográficos donde la credibilidad es lo más importante.", prompt: "Fotografía de producto de estudio de un reloj mecánico plateado sobre pizarra oscura, iluminación lateral suave, textura realista de metal cepillado, poca profundidad de campo, reflejos sutiles, composición editorial premium." ,image: require('@/assets/images/flux2/b1d818f0-ff1f-4612-b586-62f75e14466c.webp') },
                    { name: "Fuerte adherencia inmediata", short: "Sigue atentamente indicaciones complejas, incluidos temas, estilos y composiciones específicos.", desc: "FLUX.2 interpreta indicaciones en capas y de varias partes con una precisión impresionante: maneja temas, estilos artísticos, paletas de colores e instrucciones de composición específicos en una sola generación. Esto les da a los creadores más control y menos repeticiones al describir exactamente lo que quieren.", prompt: "Un tranvía rojo cruzando una lluviosa plaza europea al anochecer, tres ciclistas en primer plano, cálidas ventanas de café a la izquierda, cielo azul a la hora, composición simétrica, fotografía cinematográfica.",image: require('@/assets/images/flux2/2026b767-edcb-4441-b70e-a6d94ae6ebb9.webp') },
                    { name: "Manejo avanzado de tipografía", short: "Representa texto dentro de imágenes con una ortografía más limpia y coherencia de estilo.", desc: "FLUX.2 ofrece generación de texto mejorada y control en las imágenes, con una coherencia de estilo de fuente más precisa. Esto hace posible producir materiales basados ​​en texto y señalización para carteles, anuncios, cómics y gráficos de marca con muchos menos artefactos.", demo: { type: 'table', rows: [
                        { prompt: "Una hermosa foto de paisaje místico con el texto \"FLUX 2\", belleza sutil, incorpora arándanos." ,image: require('@/assets/images/flux2/c2f47f20-00b4-4cec-b972-e7a69d40be56.webp') },
                        { prompt: "Un pastel de la selva negra que deletrea las palabras \"FLUX 2 Pro\", fotografía de comida sabrosa." ,image: require('@/assets/images/flux2/2258b023-29ba-433f-b909-88f542adc3b9.webp') }
                    ] } },
                    { name: "Generación rápida y escalable", short: "Elija desde iteraciones de menos de un segundo hasta resultados de máxima calidad.", desc: "FLUX.2 abarca modelos rápidos de Klein y variantes Pro, Max y Flex centradas en la producción. Esta gama lo hace práctico para borradores rápidos, producción de contenido por lotes y activos creativos o de marketing de calidad final.", prompt: "Una foto limpia de un producto editorial de un frasco de perfume verde translúcido sobre piedra caliza, una suave luz matutina, sombras sutiles y una estética de campaña premium." ,image: require('@/assets/images/flux2/2a4b147b-31c2-4ded-a626-d7e209fb751b.webp')}
                ],
                showcaseKicker: "Ejemplos rápidos",
                showcaseTitle: "Ejemplos de indicaciones de FLUX.2 para obtener mejores imágenes de IA",
                showcaseIntro: "Utilice estos ejemplos de mensajes de FLUX.2 como punto de partida, personalice el tema, la composición, la iluminación y el estilo, luego envíe su mensaje directamente al generador.",
                variantsKicker: "guía de modelos",
                variantsTitle: "Comparación de modelos FLUX.2: Klein vs Max vs Pro vs Flex",
                variantsIntro: "Compare FLUX.2 Klein, Max, Pro y Flex para elegir el modelo de imagen de IA adecuado para una iteración rápida, activos de calidad final, escala de producción o control de tipografía fina.",
                variants: [
                    { name: "FLUX.2 Pequeño 4B / 9B", tag: "Más rápido", desc: "Elija FLUX.2 Klein para generación rápida de imágenes, borradores y creación rápida de prototipos en gran volumen.", bestFor: "Lo mejor para borradores, lotes e iteraciones rápidas" },
                    { name: "FLUJO.2 Máx.", tag: "La más alta calidad", desc: "Elija FLUX.2 Max para activos finales, el seguimiento más rápido y una generación basada en tierra.", bestFor: "Lo mejor para campañas premium e imágenes destacadas" },
                    { name: "FLUJO.2 Pro", tag: "Producción", desc: "Elija FLUX.2 Pro para obtener un equilibrio de calidad de imagen, tiempo de respuesta y salida escalable a nivel de producción.", bestFor: "Lo mejor para marketing y producción de contenidos." },
                    { name: "FLUJO.2 Flex", tag: "controlar", desc: "Elija FLUX.2 Flex para orientación ajustable, tipografía, representación de texto y preservación de pequeños detalles.", bestFor: "Lo mejor para carteles, etiquetas y recursos de diseño." }
                ],
                useCasesKicker: "Hecho para el trabajo real",
                useCasesTitle: "Casos de uso populares de FLUX.2",
                useCases: [
                    { name: "FLUX.2 para fotografía de productos", desc: "Cree fotografías de productos refinadas, escenas de estilos de vida y variaciones de imágenes de comercio electrónico." },
                    { name: "FLUX.2 para marketing y publicidad", desc: "Convierta los conceptos de campaña en anuncios sociales, pancartas y elementos visuales de marca consistentes." },
                    { name: "FLUX.2 para carteles y tipografía", desc: "Utilice la representación de texto FLUX.2 para producir titulares, etiquetas, carteles y gráficos basados en texto más claros." },
                    { name: "FLUX.2 para retratos fotorrealistas", desc: "Genere retratos detallados con IA con iluminación, estilo y composición controlados." },
                    { name: "FLUX.2 para arte conceptual", desc: "Explora entornos cinematográficos, personajes e indicaciones visuales rápidamente." },
                    { name: "FLUX.2 para diseño editorial", desc: "Cree ilustraciones y portadas distintivas para artículos y presentaciones." }
                ],
                howToKicker: "Tres sencillos pasos",
                howToTitle: "Cómo utilizar el generador de imágenes AI FLUX.2 en línea",
                howToIntro: "Utilice el generador de imágenes AI FLUX.2 en línea en Miral para pasar de un mensaje de texto detallado a una imagen generada.",
                howToSteps: [
                    { title: "Ingrese su mensaje", desc: "Describe el tema, la composición, la iluminación, los colores, el estilo y cualquier texto que quieras que aparezca en la imagen." },
                    { title: "Elija la configuración de FLUX.2", desc: "Abra el generador, seleccione Klein, Max, Pro o Flex, luego elija el tamaño de salida que se ajuste a su proyecto." },
                    { title: "Genera tu imagen", desc: "Inicie la generación, revise el resultado y descargue la imagen o refine su mensaje para otra versión." }
                ],
                howToCta: "Pruebe el generador de imágenes AI FLUX.2",
                faqTitle: "Preguntas frecuentes sobre FLUX.2",
                faqs: [
                    { q: "¿Qué es FLUX.2?", a: "FLUX.2 es el modelo de IA de conversión de texto a imagen de próxima generación de Black Forest Labs. Convierte indicaciones escritas en imágenes detalladas de alta calidad y está disponible en Miral para arte, diseño, marketing y creación visual de productos directamente en su navegador." },
                    { q: "¿Qué herramienta puedo utilizar para crear fotografías de productos y elementos visuales de marketing ricos en texto?", a: "FLUX.2 combina coherencia rápida, detalle, fotorrealismo y manejo de tipografía para fotografía de productos profesionales e imágenes de marketing ricas en texto que exigen fidelidad y precisión." },
                    { q: "¿Puedo utilizar el generador de imágenes AI FLUX.2 de forma gratuita?", a: "Sí. Regístrese para recibir créditos gratuitos y comience a crear imágenes de alta calidad con el generador de imágenes AI FLUX.2 de inmediato. La generación de imágenes utiliza los créditos correspondientes." },
                    { q: "¿Cómo uso el generador de imágenes AI FLUX.2 en línea?", a: "Ingrese un mensaje de texto detallado, elija FLUX.2 Klein, Max, Pro o Flex, seleccione un tamaño de imagen y haga clic en Generar. FLUX.2 funciona bien para materiales de marketing, fotografía de productos, conceptos cinematográficos, creatividades sociales y diseños de carteles." },
                    { q: "¿Cuánto tiempo tarda FLUX.2 en generarse?", a: "El tiempo de generación depende de la variante FLUX.2 seleccionada, el tamaño de la imagen y la carga de servicio actual. Klein está diseñado para una iteración muy rápida, mientras que Max, Pro y Flex priorizan diferentes equilibrios de calidad y control." },
                    { q: "¿Cómo arreglar una imagen FLUX.2 que no sigue mis indicaciones?", a: "Describe el tema, el escenario, la composición, la iluminación, la cámara o el estilo artístico, los colores y cualquier texto requerido de manera más explícita. Utilice los ejemplos de indicaciones de FLUX.2 en esta página como punto de partida y personalícelos para su proyecto." },
                    { q: "¿Qué modelo de FLUX.2 debo elegir?", a: "Elija FLUX.2 Klein para borradores y lotes rápidos, Max para recursos finales de la más alta calidad, Pro para generación de imágenes a escala de producción o Flex cuando la tipografía y el control fino son más importantes." },
                    { q: "FLUX.2 Max vs Pro: ¿cuál es la diferencia?", a: "FLUX.2 Max prioriza la máxima calidad, un seguimiento rápido y sólido y una generación basada en la tierra. FLUX.2 Pro equilibra la calidad de producción, la entrega más rápida y la producción escalable para los flujos de trabajo creativos cotidianos." },
                    { q: "FLUX.2 vs Midjourney: ¿cuál debo usar?", a: "Elija según el flujo de trabajo en lugar de un ganador universal. FLUX.2 es ideal para seguimiento preciso de indicaciones, tipografía, imágenes de productos y producción basada en API. Midjourney puede ser adecuado para creadores que prefieran su flujo de trabajo artístico distintivo y sus herramientas comunitarias." }
                ],
                ctaTitle: "¡Prueba FLUX.2 gratis en Miral!",
                ctaDesc: "Ingrese su idea arriba y use el generador de imágenes AI FLUX.2 para crear imágenes detalladas con la variante de modelo que se adapta a su flujo de trabajo."
            },
            seedream: {
                title: "Generador de imágenes AI Seedream gratuito en línea | miral",
                description: "Genere imágenes de IA de alta calidad en línea con Seedream. Obtenga una comprensión rápida y precisa, una representación de texto clara y una salida detallada de 2K a 4K para proyectos creativos.",
                heroHeadline: "Generador de imágenes AI de Seedream",
                heroIntro: "Utilice el generador de imágenes Seedream AI de forma gratuita. Regístrese para recibir créditos gratuitos y crear instantáneamente imágenes de productos, carteles, retratos e imágenes de marketing de alta calidad.",
                eyebrow: "Semilla ByteDance · Seedream AI",
                sectionKicker: "IA de sueño de semillas",
                ctaTag: "Semilla · Miral",
                badges: ["Texto a imagen", "Comprensión de la intención", "Salida 2K/3K/4K", "Representación de texto claro"],
                previewLabel: "IA de sueño de semillas",
                previewMeta: ["1:1", "2K/3K/4K", "Tamaño personalizado"],
                previewTitle: "De la intención creativa a una imagen precisa y de alta resolución",
                previewDesc: "Cree composiciones complejas, fotografías de productos, retratos y diseños ricos en texto con detalles refinados y un control rápido confiable.",
                keyFeaturesTitle: "Cree imágenes precisas con el generador de texto a imagen AI de Seedream",
                keyFeaturesIntro: "Explore las funciones de Seedream AI para una comprensión más profunda de la intención, composición compleja, resultados de alta resolución, detalles realistas y representación de texto precisa a través de la generación de texto a imagen.",
                exploreTitle: "Explora los modelos de IA de Seedream",
                mainFeaturesTitle: "Funciones clave de conversión de texto a imagen de Seedream AI",
                seedream5Desc: "Utilice el último modelo de Seedream para obtener indicaciones precisas, realismo refinado, representación de texto y resultados de alta resolución.",
                seedream4Desc: "Abra el flujo de trabajo establecido de Seedream 4 para una creación confiable de texto a imagen y configuraciones de salida flexibles.",
                features: [
                    { name: "Comprensión rápida más profunda", short: "Interpreta la intención creativa, las relaciones espaciales y las instrucciones detalladas.", desc: "Seedream AI va más allá de hacer coincidir términos puntuales aislados. Razona sobre las relaciones entre temas, diseño, atributos y contexto visual para producir resultados más coherentes a partir de instrucciones de texto complejas.", demo: { type: 'table', rows: [
                        { prompt: "Un estante de exhibición de 3x3, vista frontal, con nueve objetos diferentes organizados por material y color, iluminación de estudio consistente y alineación espacial precisa.", image: require('@/assets/images/seedream/0217834949526105a9f949eb72c2227dac5c405ca3d9cd6c996b9_0.webp') },
                        { prompt: "Foto editorial de un reloj junto a lino doblado y una taza de cerámica, composición triangular equilibrada, suave luz de la mañana.", image: require('@/assets/images/seedream/021783495149924e4fd4c285bd49f804239cddc30345c48dc6024_0.webp') },
                        { prompt: "Una escena cinematográfica de mercado con compradores en primer plano, un sujeto central claro, profundidad en capas y una luz cálida reflejada en el pavimento mojado.", image: require('@/assets/images/seedream/994ae318-58d7-4ffa-98e1-ea97553ff0c0.webp') }
                    ] } },
                    { name: "Control de composición compleja", short: "Maneja múltiples temas, atributos y diseños estructurados con mayor coherencia.", desc: "El generador de imágenes de IA de Seedream sigue instrucciones de varias partes en escenas complejas, lo que ayuda a preservar los atributos, posiciones, colores y relaciones de los objetos solicitados en una sola composición.", prompt: "Una escena editorial frontal con tres jarrones de cerámica de diferentes formas sobre plataformas de piedra escalonadas, una esfera roja detrás del jarrón más alto, iluminación lateral suave, espacio equilibrado y fondo de estudio neutro.", image: require('@/assets/images/seedream/021783495389730ffa263910bfaab0198f27d0234753c494fd2fa_0.webp') },
                    { name: "Salida 2K, 3K y 4K", short: "Seleccione una resolución de salida según los detalles y las dimensiones que necesita su proyecto.", desc: "Seedream AI admite salidas seleccionables de 2K, 3K y 4K en Miral, además de tamaños de imagen personalizados. Elija en función de las dimensiones y el nivel de detalle requerido para su uso final.", prompt: "Un amplio paisaje cinematográfico de una ciudad costera futurista al amanecer, arquitectura en capas, agua reflectante, profundidad atmosférica, detalles intrincados de edificios, composición panorámica.", image: require('@/assets/images/seedream/0217834956211361c17ef9c173e8babb4a0658490f0169e937059_0.webp') },
                    { name: "Representación de texto mejorada", short: "Crea texto más claro para carteles, diseños, etiquetas y gráficos de presentación.", desc: "Seedream AI combina el razonamiento visual con la creación de texto mejorada, lo que la hace útil para carteles, gráficos de presentación, anuncios, conceptos de empaque y otros diseños donde el texto legible es parte de la imagen.", demo: { type: 'table', rows: [
                        { prompt: "Afiche de evento minimalista con el título \"DISEÑO PARA EL MAÑANA\", tipografía geométrica en negrita, fondo blanco, cuadrícula decorativa en verde.", image: require('@/assets/images/seedream/0217834957232579f663fff68d336b1dca042ed755c42d2babd5a_0.webp') },
                        { prompt: "Paquete de café premium con la etiqueta \"MIRAL ROAST\", notas de cata concisas, textura de papel cálida, fotografía de producto en estudio.", image: require('@/assets/images/seedream/021783495813482572fdc12977fa128088f145c73a50ff1524591_0.webp') }
                    ] } },
                    { name: "Detalle refinado y realismo", short: "Produce iluminación, materiales, profundidad y presentación del producto convincentes.", desc: "Seedream AI genera texturas refinadas e iluminación coherente para fotografía de productos, retratos, imágenes editoriales y conceptos cinematográficos donde la claridad y la estructura creíble son importantes.", prompt: "Una foto limpia de un producto editorial de un frasco de perfume verde translúcido sobre piedra caliza, una suave luz matutina, sombras sutiles y una estética de campaña premium.", image: require('@/assets/images/seedream/021783495894855ad8f78454eef31552c89ebf2f2559e7d2d47a0_0.webp') }
                ],
                showcaseKicker: "Ejemplos rápidos",
                showcaseTitle: "Ejemplos de indicaciones de IA de Seedream para obtener mejores imágenes de IA",
                showcaseIntro: "Utilice estos ejemplos de indicaciones de Seedream AI como punto de partida. Describe claramente los temas, las relaciones espaciales, el texto, la iluminación y el diseño, luego envía el mensaje directamente al generador.",
                variantsKicker: "guía de resolución",
                variantsTitle: "Guía de resolución de IA de Seedream: 2K vs 3K vs 4K",
                variantsIntro: "Elija una resolución de salida de Seedream AI en función de la rapidez con la que desee iterar y de la cantidad de detalles que requiera el activo final.",
                variants: [
                    { name: "2K", tag: "Salida estándar", desc: "Una resolución práctica para contenido social, trabajo creativo cotidiano y diseños digitales estándar.", bestFor: "Lo mejor para contenido digital normal" },
                    { name: "3K", tag: "Más detalle", desc: "Agrega más detalles de imagen y admite diseños más grandes para trabajos de marketing y presentaciones.", bestFor: "Lo mejor para activos de marketing y presentación." },
                    { name: "4K", tag: "Detalle máximo", desc: "Utilice el ajuste preestablecido más alto cuando sean importantes las texturas finas, los diseños con mucho texto o la calidad de entrega superior.", bestFor: "Lo mejor para campañas finales y resultados de alta resolución" }
                ],
                useCasesKicker: "Hecho para el trabajo real",
                useCasesTitle: "Casos de uso populares de IA de Seedream",
                useCases: [
                    { name: "AI de Seedream para fotografía de productos", desc: "Cree fotografías de productos refinadas, escenas de estilos de vida y conceptos de imágenes de comercio electrónico." },
                    { name: "IA de Seedream para marketing", desc: "Convierta ideas de campañas estructuradas en anuncios sociales, pancartas y elementos visuales de marca." },
                    { name: "AI de Seedream para carteles y textos", desc: "Produzca conceptos de carteles, gráficos de presentación, etiquetas y diseños basados en texto." },
                    { name: "AI de Seedream para composiciones complejas", desc: "Organice múltiples temas y atributos solicitados en una estructura visual coherente." },
                    { name: "IA Seedream para arte conceptual", desc: "Explora entornos cinematográficos, personajes e instrucciones visuales detalladas." },
                    { name: "AI de Seedream para imágenes editoriales", desc: "Cree portadas, ilustraciones, infografías e imágenes listas para presentaciones." }
                ],
                howToKicker: "Tres sencillos pasos",
                howToTitle: "Cómo utilizar el generador de imágenes AI de Seedream en línea de forma gratuita",
                howToIntro: "Regístrese para recibir créditos gratuitos y utilice el generador de imágenes AI de Seedream en línea con un mensaje claro y la resolución requerida por su proyecto.",
                howToSteps: [
                    { title: "Ingrese su intención creativa", desc: "Describe los temas, las relaciones espaciales, la composición, la iluminación, el estilo y el texto requerido lo más claramente posible." },
                    { title: "Elija resolución y tamaño", desc: "Abra el generador y seleccione 2K, 3K, 4K o un tamaño personalizado compatible según su uso final." },
                    { title: "Generar y revisar", desc: "Inicie la generación, revise la composición y los detalles, luego descargue el resultado o ajuste su mensaje." }
                ],
                howToCta: "Utilice el generador de imágenes AI de Seedream gratis",
                faqTitle: "Preguntas frecuentes sobre la IA de Seedream",
                faqs: [
                    { q: "¿Qué es el generador de imágenes AI de Seedream?", a: "Seedream AI es un modelo inteligente de creación de imágenes del equipo Seed de ByteDance. En Miral, convierte indicaciones de texto detalladas en imágenes de alta resolución para diseño, marketing, conceptos de productos, carteles y elementos visuales editoriales." },
                    { q: "¿Qué herramienta puedo utilizar para crear carteles de alta resolución con texto claro?", a: "Seedream AI combina una comprensión más profunda de la intención, una composición precisa, una creación de texto mejorada y una salida de alta resolución seleccionable para carteles y otros diseños ricos en texto." },
                    { q: "¿Puedo utilizar el generador de imágenes AI de Seedream de forma gratuita?", a: "Sí. Regístrese para recibir créditos gratuitos y comience a crear imágenes de alta calidad con el generador de imágenes Seedream AI de inmediato. La generación de imágenes utiliza los créditos correspondientes." },
                    { q: "¿Cómo uso el generador de imágenes Seedream AI en línea?", a: "Ingrese un mensaje de texto detallado, elija salida 2K, 3K o 4K, opcionalmente seleccione un tamaño personalizado y haga clic en Generar. Para obtener mejores resultados, describa claramente los temas, las relaciones espaciales, los atributos, la iluminación, el texto y el diseño." },
                    { q: "¿Seedream AI admite imágenes 2K, 3K y 4K?", a: "Sí. Miral expone ajustes preestablecidos de resolución 2K, 3K y 4K para Seedream AI, junto con dimensiones personalizadas compatibles para diferentes relaciones de aspecto y necesidades de entrega." },
                    { q: "¿Cómo arreglar imágenes de Seedream con texto o composición incorrecta?", a: "Describe el tema, las relaciones entre los objetos, la composición, la iluminación, los colores, el estilo y el texto requerido de manera más explícita. Utilice los ejemplos de Seedream en esta página como punto de partida y establezca claramente cada requisito visual." },
                    { q: "¿Qué resolución de Seedream AI debo elegir?", a: "Elija 2K para contenido digital estándar, 3K cuando los diseños de presentación o marketing necesiten más detalles y 4K cuando el máximo detalle sea importante para grandes campañas finales, carteles o recursos de diseño premium." },
                    { q: "Seedream AI vs Midjourney: ¿cuál debo usar?", a: "Seedream AI es ideal para indicaciones estructuradas, composiciones complejas, diseños ricos en texto y resultados de alta resolución seleccionables en Miral. Midjourney puede ser adecuado para creadores que prefieran su flujo de trabajo artístico distintivo y sus herramientas comunitarias." }
                ],
                ctaTitle: "¡Usa Seedream AI gratis en Miral!",
                ctaDesc: "Regístrate para recibir créditos gratis. Describe tu idea, elige la resolución adecuada y utiliza el generador de imágenes AI de Seedream para crear imágenes precisas y de alta resolución."
            },
            gptImage: {
                title: "Generador de imágenes AI de imágenes GPT gratis en línea | miral",
                description: "Genere imágenes de IA de alta calidad en línea con GPT Image y GPT-Image-1.5 en Miral AI. Elija tamaños prácticos y niveles de calidad para carteles, productos y retratos.",
                heroHeadline: "Generador de imágenes AI de imágenes GPT",
                heroIntro: "Utilice el generador de imágenes GPT Image AI de forma gratuita en Miral AI. Regístrese para recibir créditos gratuitos y crear instantáneamente imágenes de productos, carteles, retratos y elementos visuales de marketing de alta calidad con GPT-Image-1.5.",
                eyebrow: "OpenAI · GPT-Imagen-1.5",
                sectionKicker: "Imagen GPT",
                ctaTag: "Imagen GPT · Miral",
                badges: ["Texto a imagen", "Calidad seleccionable", "Paisaje / Retrato / Cuadrado", "Comprensión rápida y precisa"],
                previewLabel: "GPT-Imagen-1.5",
                previewMeta: ["1024 × 1024", "1536 × 1024", "1024 × 1536"],
                previewTitle: "De una idea escrita a una imagen de IA práctica y pulida",
                previewDesc: "Utilice indicaciones claras y calidad seleccionable para crear imágenes de productos, carteles, retratos y contenido de marca.",
                keyFeaturesTitle: "Cree imágenes de alta calidad con el generador de imágenes GPT Image AI",
                keyFeaturesIntro: "Explore las funciones de GPT-Image-1.5 para una rápida comprensión, control de calidad, tamaños de imagen prácticos y creación visual profesional.",
                features: [
                    { name: "Mensajes en lenguaje natural y de múltiples temas", short: "Describe temas, composición, iluminación, estilo y relaciones visuales en lenguaje natural.", desc: "El generador de imágenes GPT Image AI admite indicaciones en lenguaje natural con múltiples temas, atributos y requisitos de composición. Comience con un mensaje simple o especifique la posición, el color y la relación de cada sujeto para crear imágenes de múltiples sujetos más coherentes.", demo: { type: 'table', rows: [
                        { prompt: "Fotografía editorial de producto de un frasco de perfume transparente sobre un pedestal de piedra pálida, suave luz de la mañana desde la izquierda, fondo limpio, poca profundidad de campo, estética de marca premium.", image: require('@/assets/images/gptImage/perfume-editorial.webp') },
                        { prompt: "Una calle lluviosa de la ciudad por la noche, tres peatones en primer plano sosteniendo paraguas de diferentes colores, un tranvía pasando a lo lejos, neón reflejado en el pavimento mojado, composición cinematográfica amplia.", image: require('@/assets/images/gptImage/rainy-city-tram.webp') }
                    ] } },
                    { name: "Control de calidad GPT-Imagen-1.5", short: "Elija Automático, Bajo, Medio o Alto según las necesidades de velocidad y detalle.", desc: "GPT-Image-1.5 ofrece configuraciones de calidad automática, baja, media y alta. Utilice una calidad más baja para una exploración rápida y una calidad más alta para las imágenes, carteles o recursos de marketing del producto final.", prompt: "Anuncio de comida de alta calidad de un pastel de fresas sobre un fondo negro, textura de crema crujiente, luz de borde suave, fotografía de comida detallada, composición comercial.", image: require('@/assets/images/gptImage/strawberry-cake.webp') },
                    { name: "Tres tamaños de imagen prácticos", short: "Cree resultados cuadrados, horizontales y verticales.", desc: "Elija 1024×1024, 1536×1024 o 1024×1536 para publicaciones en redes sociales, pancartas y elementos visuales de presentación, o carteles verticales y contenido móvil.", prompt: "Un póster de viaje con retrato de 1024×1536 con un acantilado junto al mar y un faro en la niebla de la mañana, espacio para un titular en la parte superior y diseño editorial moderno.", image: require('@/assets/images/gptImage/lighthouse-travel-poster.webp') },
                    { name: "Creación de texto claro y diseño", short: "Cree conceptos de carteles, etiquetas y marcas que incluyan texto.", desc: "Al indicar claramente el texto requerido, la ubicación, el estilo tipográfico y las relaciones de diseño, GPT Image puede ayudar a explorar carteles, empaques, gráficos de eventos e imágenes de marketing con titulares.", demo: { type: 'table', rows: [
                        { prompt: "Afiche de evento tecnológico minimalista con el título \"CREAR EL FUTURO\", tipo sans-serif en negrita, fondo azul profundo, cuadrícula geométrica verde, título claro centrado.", image: require('@/assets/images/gptImage/create-the-future.webp') },
                        { prompt: "Concepto de paquete de café premium con el texto \"MIRAL ROAST\" en el frente, textura de papel marrón cálido, etiqueta limpia, fotografía de producto de estudio.", image: require('@/assets/images/gptImage/miral-roast-package.webp') }
                    ] } },
                    { name: "Detalle y realismo", short: "Represente materiales, iluminación, personas y detalles del producto creíbles.", desc: "GPT Image funciona bien para fotografía de productos, retratos, interiores y elementos visuales editoriales cuando el mensaje describe claramente los materiales, las opciones de cámara, la iluminación y la profundidad de campo.", prompt: "Retrato editorial cercano de un artista cerámico con luz natural de ventana, textura de piel realista, polvo de arcilla en sus manos, fondo de taller, poca profundidad de campo, cálida fotografía editorial.", image: require('@/assets/images/gptImage/ceramic-artist.webp') }
                ],
                showcaseKicker: "Ejemplos rápidos",
                showcaseTitle: "Ejemplos de indicaciones de imágenes GPT para obtener mejores imágenes de IA",
                showcaseIntro: "Utilice estas indicaciones de imagen GPT como punto de partida. Describe claramente el tema, la composición, la iluminación, el estilo, los materiales y cualquier texto requerido.",
                variantsKicker: "Guía de versiones",
                variantsTitle: "GPT-Imagen-1.5 frente a GPT-Imagen-1",
                variantsIntro: "Elija una versión de imagen GPT en función de si necesita control de calidad. Ambos admiten prácticos tamaños cuadrados, horizontales y verticales.",
                variants: [
                    { name: "GPT-Imagen-1.5", tag: "Recomendado", desc: "Admite 1024×1024, 1536×1024 y 1024×1536 con opciones de calidad automática, baja, media y alta.", bestFor: "Lo mejor para el trabajo diario y profesional que necesita control de calidad." },
                    { name: "GPT-Imagen-1", tag: "Clásico", desc: "Admite los mismos tres prácticos tamaños de imagen con un conjunto de controles más simple.", bestFor: "Lo mejor para la creación sencilla y de uso general de texto a imagen" }
                ],
                useCasesKicker: "Hecho para el trabajo real",
                useCasesTitle: "Casos de uso de imágenes GPT populares",
                useCases: [
                    { name: "Imagen GPT para fotografía de productos y maquetas", desc: "Cree imágenes destacadas de productos, escenas de estilos de vida, maquetas de productos y conceptos visuales de comercio electrónico." },
                    { name: "Imagen GPT para imágenes de listado de comercio electrónico", desc: "Explore imágenes de listados de productos, gráficos destacados, exhibidores de empaques y conceptos publicitarios." },
                    { name: "Imagen GPT para anuncios de marketing y redes sociales", desc: "Cree anuncios en redes sociales, pancartas de campaña, pancartas de correo electrónico y elementos visuales de marketing de marca." },
                    { name: "Imagen GPT para UI/UX y diseños de sitios web", desc: "Genere conceptos visuales para interfaces de aplicaciones, diseños de sitios web, páginas de destino y páginas de presentación de productos." },
                    { name: "Imagen GPT para infografías e informes visuales", desc: "Explore conceptos de diseño para infografías, informes visuales y gráficos de presentación; Verifique todo el texto y los datos antes del uso final." },
                    { name: "Imagen GPT para carteles y embalajes de productos", desc: "Explore carteles, etiquetas de productos y diseños de empaques con requisitos de encabezado y diseño." },
                    { name: "Imagen GPT para portadas de libros e imágenes de blogs", desc: "Cree portadas de libros, ilustraciones editoriales, encabezados de blogs y conceptos visuales de publicación." },
                    { name: "Imagen GPT para retratos", desc: "Cree retratos editoriales con iluminación, fondos y estilo controlados." },
                    { name: "Imagen GPT para conceptos de personajes de juegos", desc: "Explora rápidamente los personajes del juego, el vestuario, los accesorios y diferentes direcciones artísticas." },
                    { name: "Imagen GPT para entornos de juego", desc: "Genere entornos de juego, escenas cinematográficas y conceptos de construcción de mundos para una exploración creativa temprana." },
                    { name: "Imagen GPT para contenido social", desc: "Genere imágenes cuadradas, horizontales y verticales para diferentes plataformas." }
                ],
                howToKicker: "Tres sencillos pasos",
                howToTitle: "Cómo utilizar el generador de imágenes GPT Image AI en línea de forma gratuita",
                howToIntro: "Regístrese para recibir créditos gratuitos y utilice el generador de imágenes GPT Image AI en línea en Miral.",
                howToSteps: [
                    { title: "Ingrese un mensaje detallado", desc: "Describe el tema, el escenario, la composición, la iluminación, el estilo, los materiales y cualquier texto requerido." },
                    { title: "Elija tamaño y calidad", desc: "Elija un tamaño cuadrado, horizontal o vertical y configure la calidad GPT-Image-1.5 según sus necesidades." },
                    { title: "Generar y revisar", desc: "Inicie la generación, revise y descargue la imagen, o ajuste el mensaje y cree otra versión." }
                ],
                howToCta: "Utilice el generador de imágenes AI de imágenes GPT gratis",
                faqTitle: "Preguntas frecuentes sobre la imagen GPT",
                faqs: [
                    { q: "¿Qué es el generador de imágenes GPT Image AI?", a: "GPT Image es la familia de modelos de conversión de texto a imagen de uso general de OpenAI. En Miral, el generador de imágenes GPT Image AI convierte indicaciones escritas en imágenes de alta calidad para diseño, marketing, conceptos de productos, carteles y contenido social." },
                    { q: "¿Puedo utilizar el generador de imágenes GPT Image AI de forma gratuita?", a: "Sí. Regístrese para recibir créditos gratuitos y comience a crear imágenes de alta calidad con el generador de imágenes GPT Image AI de inmediato. La generación de imágenes utiliza los créditos correspondientes." },
                    { q: "¿Cómo uso el generador de imágenes GPT Image AI en línea?", a: "Ingrese un mensaje detallado y elija 1024×1024, 1536×1024 o 1024×1536. Con GPT-Image-1.5, también puede seleccionar calidad automática, baja, media o alta antes de hacer clic en Generar." },
                    { q: "¿Cuál es la diferencia entre GPT-Image-1.5 y GPT-Image-1?", a: "Ambas versiones admiten los mismos tres prácticos tamaños de imagen. GPT-Image-1.5 en Miral también proporciona control de calidad automático, bajo, medio y alto, mientras que GPT-Image-1 tiene un conjunto de parámetros más simple." },
                    { q: "¿Qué tamaños de imagen admite GPT Image?", a: "En Miral, GPT-Image-1 y GPT-Image-1.5 admiten imágenes cuadradas de 1024 × 1024, paisajes de 1536 × 1024 y retratos de 1024 × 1536." },
                    { q: "¿Qué calidad de imagen GPT debo elegir?", a: "Elija bajo o medio cuando pruebe las indicaciones rápidamente, alto para imágenes, carteles o recursos de marketing del producto final y automático cuando no esté seguro. Las opciones de calidad se aplican a GPT-Image-1.5." },
                    { q: "¿Cómo solucionar los resultados de la imagen GPT que no coinciden con mi mensaje?", a: "Describe el tema, el escenario, la composición, la iluminación, la cámara, los materiales, el estilo y cualquier texto requerido de manera más explícita. Utilice los ejemplos de imágenes GPT de esta página como punto de partida y adáptelos a su proyecto." },
                    { q: "¿Necesito experiencia en ingeniería rápida para utilizar GPT Image?", a: "No. Comience con un mensaje simple en lenguaje natural, luego agregue posiciones de los temas, composición, iluminación, colores, materiales y requisitos de texto según sea necesario. Las descripciones más claras generalmente ayudan a que el resultado se ajuste más a su intención creativa." },
                    { q: "¿Qué herramienta puedo utilizar para crear imágenes de productos de comercio electrónico, carteles y conceptos de interfaz de usuario?", a: "GPT Image puede crear imágenes de listados de comercio electrónico, maquetas de productos, carteles, conceptos UI/UX, diseños de sitios web, diseños infográficos, portadas de libros, imágenes de blogs, banners de correo electrónico y conceptos de juegos. Verifique el texto, los datos, los elementos de la marca y los detalles estructurales antes del uso final." },
                    { q: "Imagen GPT vs Midjourney: ¿cuál debo usar?", a: "GPT Image es ideal para un control rápido claro, tamaños de imagen prácticos y generación directa del navegador. Midjourney puede ser adecuado para usuarios que prefieren sus estilos artísticos, flujo de trabajo de imágenes de referencia y proceso creativo." }
                ],
                ctaTitle: "¡Utilice la imagen GPT gratis en Miral!",
                ctaDesc: "Regístrate para recibir créditos gratis. Describe tu idea, elige un tamaño y una calidad, y utiliza el generador de imágenes GPT Image AI para crear imágenes de alta calidad."
            },
            qwenImage2Pro: {
                title: "Generador de imágenes Qwen Image 2.0 Pro AI gratis en línea | miral",
                description: "Cree imágenes de IA en línea con Qwen Image 2.0 Pro. Utilice mensajes negativos, mejoras de mensajes, relaciones de aspecto flexibles y genere hasta cuatro imágenes por ejecución.",
                heroHeadline: "Generador de imágenes Qwen Image 2.0 Pro AI",
                heroIntro: "Utilice el generador de imágenes Qwen Image 2.0 Pro AI de forma gratuita en Miral AI. Regístrese para recibir créditos gratuitos y crear rápidamente imágenes de alta calidad con mensajes negativos, mejoras rápidas y relaciones de aspecto flexibles.",
                eyebrow: "Alibaba Tongyi Qwen · Qwen-Image-2.0-Pro",
                sectionKicker: "Imagen Qwen 2.0 Pro",
                ctaTag: "Imagen Qwen 2.0 Pro · Miral",
                badges: ["Texto a imagen", "Aviso negativo", "Mejora inmediata", "1-4 imágenes/ejecutar", "Relaciones de aspecto flexibles"],
                previewLabel: "Imagen Qwen 2.0 Pro",
                previewMeta: ["1:1", "2048 × 2048", "Hasta 1-4 imágenes"],
                previewTitle: "Desde un mensaje preciso con exclusiones hasta imágenes pulidas",
                previewDesc: "Combine mensajes positivos con mensajes negativos y mejoras de mensajes para generar múltiples imágenes en el objetivo en una sola ejecución.",
                keyFeaturesTitle: "Cree imágenes precisas con el generador de texto a imagen Qwen Image 2.0 Pro",
                keyFeaturesIntro: "Explore las funciones clave del generador de imágenes Qwen Image 2.0 Pro AI para obtener control preciso, indicaciones negativas, mejora de indicaciones, salida por lotes y relaciones de aspecto flexibles.",
                mainFeaturesTitle: "Capacidades clave de Qwen Image 2.0 Pro",
                promptLabel: "Aviso positivo",
                negativePromptLabel: "Aviso negativo",
                shortPromptLabel: "Mensaje corto",
                negativePromptFallback: "poca claridad, detalles distorsionados, composición desordenada",
                features: [
                    { name: "Control rápido negativo", short: "Describa qué excluir para obtener resultados más limpios y acertados.", desc: "El generador de imágenes Qwen Image 2.0 Pro AI admite un mensaje negativo dedicado, para que pueda indicarle al modelo qué debe evitar, como poca claridad, manos deformadas o composición desordenada. Esto le brinda un control más preciso sobre la imagen final y reduce la necesidad de volver a rodar repetidamente.", demo: { type: 'table', rows: [
                        { prompt: "Una foto de producto premium de una botella de vidrio para el cuidado de la piel sobre piedra húmeda, luz suave de la mañana y fondo limpio. (Negativo: fondo desordenado, baja resolución, reflejos deformados).", image: require('@/assets/images/qwenImage2Pro/32ccbe94-155c-4873-9e85-602969ecb6e4.webp') },
                        { prompt: "Un retrato de una mujer joven con luz otoñal, textura natural de la piel, poca profundidad de campo. (Negativo: piel demasiado alisada, aspecto ceroso, colores sobresaturados).", image: require('@/assets/images/qwenImage2Pro/b4c88e78-6c88-4db5-9ea2-a6041609a380.webp') }
                    ] } },
                    { name: "Mejora inmediata", short: "Opcionalmente, amplíe un breve mensaje con más detalles.", desc: "Active la mejora de mensajes y Qwen Image 2.0 Pro enriquecerá automáticamente un mensaje breve con detalles adicionales antes de su generación. Esto ayuda a los no expertos a producir imágenes más completas y vívidas sin necesidad de reescritura manual.", demo: { type: 'table', rows: [
                        { prompt: "Un acogedor rincón de lectura junto a una ventana lluviosa.", image: require('@/assets/images/qwenImage2Pro/f9f87426-60d9-4f97-a372-7cb55b5bf7de.webp') },
                        { prompt: "Un escritorio de lectura de madera junto a una ventana cubierta por la lluvia por la noche, una cálida lámpara de trabajo que ilumina un libro abierto y un té humeante, un interior tranquilo y acogedor.", image: require('@/assets/images/qwenImage2Pro/qwen-enhance-rainy-desk.webp') }
                    ] } },
                    { name: "Genere de 1 a 4 imágenes a la vez", short: "Produzca múltiples variaciones en una sola ejecución.", desc: "Qwen Image 2.0 Pro puede generar hasta cuatro imágenes por solicitud, por lo que puede comparar variaciones de un concepto, ángulo o estilo una al lado de la otra y elegir la mejor. Esto acelera la exploración creativa para el marketing y las imágenes de productos.", prompt: "Una lámpara de mesa de cerámica minimalista sobre una mesa auxiliar de nogal, un interior cálido por la noche, una pared color crema, sombras suaves, fotografías de productos escandinavos.", image: require('@/assets/images/qwenImage2Pro/c4581d5b-f28a-4ae5-8bb2-b110c30d954c.webp') },
                    { name: "Relaciones de aspecto flexibles", short: "Elija tamaños horizontales, verticales, cuadrados o personalizados.", desc: "Elija entre relaciones de aspecto ya preparadas, como 2688×1536 horizontal, 1536×2688 vertical, 2048×2048 cuadrado y 2368×1728/1728×2368, o ingrese un tamaño personalizado de 512×512 a 2048×2048. Esto hace que el generador de texto a imagen Qwen Image 2.0 Pro sea adecuado tanto para pancartas, carteles, publicaciones en redes sociales como para miniaturas cuadradas.", prompt: "Una toma cinematográfica de un paisaje amplio de un acantilado costero en la hora dorada, nubes espectaculares y detalles de rocas finas, 2688×1536.", image: require('@/assets/images/qwenImage2Pro/e2bd1179-48db-4ce6-a713-2a0a62dd5dd5.webp') },
                    { name: "Detalle refinado y realismo", short: "Renderiza texturas, iluminación y profundidad realistas.", desc: "Qwen Image 2.0 Pro produce texturas finas, iluminación realista y profundidad natural, lo que lo convierte en una opción sólida para fotografía de productos, retratos y visuales editoriales donde la credibilidad importa.", prompt: "Retrato editorial de primer plano de un ceramista anciano en un taller iluminado por el sol, textura natural de la piel, polvo de arcilla en las manos, luz cálida de la ventana, poca profundidad de campo.", image: require('@/assets/images/qwenImage2Pro/3204b3e8-c5ca-40b4-afa9-a65f6dd806e2.webp') }
                ],
                showcaseKicker: "Ejemplos rápidos",
                showcaseTitle: "Ejemplos de indicaciones de Qwen Image 2.0 Pro para obtener mejores imágenes de IA",
                showcaseIntro: "Utilice estos ejemplos de indicaciones de Qwen Image 2.0 Pro como punto de partida. Empareje cada mensaje positivo con un mensaje negativo para eliminar elementos no deseados y luego envíelo directamente al generador.",
                useCasesKicker: "Hecho para el trabajo real",
                useCasesTitle: "Casos de uso populares de Qwen Image 2.0 Pro",
                useCases: [
                    { name: "Qwen Image 2.0 Pro para fotografía de productos", desc: "Cree fotografías limpias de productos con fondos controlados utilizando indicaciones negativas para eliminar el desorden." },
                    { name: "Qwen Image 2.0 Pro para marketing", desc: "Genere conceptos de campaña, anuncios sociales y pancartas en múltiples proporciones." },
                    { name: "Qwen Image 2.0 Pro para carteles y tipografía", desc: "Produzca diseños de carteles y diseños ricos en texto con títulos y etiquetas claros." },
                    { name: "Qwen Image 2.0 Pro para retratos", desc: "Genere retratos detallados con textura de piel natural utilizando indicaciones negativas para evitar artefactos." },
                    { name: "Qwen Image 2.0 Pro para arte conceptual", desc: "Explora personajes, entornos e instrucciones visuales con 1 a 4 variaciones por carrera." },
                    { name: "Qwen Image 2.0 Pro para comercio electrónico", desc: "Produzca múltiples variaciones de imágenes para listados y anuncios en una sola generación." }
                ],
                howToKicker: "Tres sencillos pasos",
                howToTitle: "Cómo utilizar el generador de imágenes AI Qwen Image 2.0 Pro en línea",
                howToIntro: "Utilice el generador de imágenes Qwen Image 2.0 Pro AI en línea en Miral con indicaciones positivas, indicaciones negativas y controles de salida flexibles.",
                howToSteps: [
                    { title: "Ingrese su mensaje principal", desc: "Describe el tema, la escena, la composición, la iluminación, el estilo y los detalles visuales deseados." },
                    { title: "Configurar controles de generación", desc: "Agregue un mensaje negativo si es necesario, habilite la mejora del mensaje, elija el tamaño y seleccione de una a cuatro imágenes." },
                    { title: "Generar y comparar", desc: "Inicie la generación, compare las variaciones devueltas y descargue la imagen que mejor se adapte a su intención." }
                ],
                howToCta: "Pruebe el generador de imágenes Qwen Image 2.0 Pro AI",
                faqTitle: "Preguntas frecuentes sobre Qwen Image 2.0 Pro",
                faqs: [
                    { q: "¿Qué es el generador de imágenes Qwen Image 2.0 Pro AI?", a: "Qwen Image 2.0 Pro es el modelo de conversión de texto a imagen Tongyi Qwen de Alibaba. El generador de imágenes Qwen Image 2.0 Pro AI convierte indicaciones escritas en imágenes detalladas de alta calidad y está disponible en Miral para arte, diseño, marketing y creación visual de productos directamente en su navegador." },
                    { q: "¿Qué herramienta puedo utilizar para crear múltiples variaciones de imágenes de productos con mensajes negativos?", a: "Qwen Image 2.0 Pro proporciona un mensaje negativo dedicado, mejora de mensajes opcional, de 1 a 4 imágenes por ejecución y relaciones de aspecto flexibles para fotografía de productos, marketing y variaciones visuales de comercio electrónico." },
                    { q: "¿Puedo utilizar el generador de imágenes Qwen Image 2.0 Pro AI de forma gratuita?", a: "Sí. Regístrese para recibir créditos gratuitos y comience a crear imágenes de alta calidad con el generador de imágenes Qwen Image 2.0 Pro AI de inmediato. La generación de imágenes utiliza los créditos correspondientes." },
                    { q: "¿Cómo uso el generador de imágenes Qwen Image 2.0 Pro AI en línea?", a: "Ingrese un mensaje de texto detallado, opcionalmente agregue un mensaje negativo que describa qué evitar, active la mejora del mensaje si es necesario, elija una relación de aspecto o un tamaño personalizado, establezca cuántas imágenes generar (1-4) y haga clic en Generar. Qwen Image 2.0 Pro funciona bien para materiales de marketing, fotografías de productos, retratos y diseños de carteles." },
                    { q: "¿Cómo corregir elementos no deseados en los resultados de Qwen Image 2.0 Pro?", a: "Agregue un mensaje negativo que describa los elementos que no desea, como poca claridad, manos deformes o un fondo desordenado. Qwen Image 2.0 Pro lo utiliza para desviar la generación de esos resultados." },
                    { q: "¿Cuántas imágenes puede generar Qwen Image 2.0 Pro a la vez?", a: "Qwen Image 2.0 Pro puede generar hasta 4 imágenes en una sola solicitud (n = 1 a 4), para que puedas comparar variaciones de un concepto, ángulo o estilo y elegir la mejor." },
                    { q: "¿Qué tamaños y relaciones de aspecto admite Qwen Image 2.0 Pro?", a: "En Miral, Qwen Image 2.0 Pro ofrece proporciones listas para usar, como 2688×1536, 1536×2688, 2048×2048, 2368×1728 y 1728×2368, además de un tamaño personalizado desde 512×512 hasta 2048×2048. Esto cubre resultados horizontales, verticales y cuadrados para pancartas, carteles, publicaciones en redes sociales y miniaturas." },
                    { q: "¿Cuáles son los mejores ejemplos de indicaciones de Qwen Image 2.0 Pro?", a: "Las indicaciones efectivas de Qwen Image 2.0 Pro describen claramente el tema, la configuración, la composición, la iluminación y el estilo, luego combina una indicación positiva con una negativa para eliminar detalles no deseados. Utilice los ejemplos de indicaciones de Qwen Image 2.0 Pro en esta página como punto de partida y personalícelos para su proyecto." },
                    { q: "Qwen Image 2.0 Pro vs Midjourney: ¿cuál debo usar?", a: "Elija según el flujo de trabajo en lugar de un ganador universal. Qwen Image 2.0 Pro es ideal cuando necesita mensajes negativos explícitos, mejora de mensajes, de 1 a 4 imágenes por ejecución y relaciones de aspecto flexibles en un generador basado en navegador en Miral. Midjourney puede ser adecuado para creadores que prefieran su flujo de trabajo artístico distintivo y sus herramientas comunitarias." }
                ],
                ctaTitle: "¡Pruebe Qwen Image 2.0 Pro gratis en Miral!",
                ctaDesc: "Ingrese su idea arriba y use el generador de imágenes Qwen Image 2.0 Pro AI con controles opcionales para crear variaciones de imágenes precisas."
            },
            stableDiffusion: {
                title: "Generador de imágenes AI Stable Diffusion 3.5 gratis en línea | miral",
                description: "Genere imágenes de IA en línea con Stable Diffusion 3.5. Utilice indicaciones negativas, relaciones de aspecto preestablecidas y tamaños personalizados de 512 a 2048 píxeles en Miral.",
                heroHeadline: "Generador de imágenes AI de difusión estable 3.5",
                heroIntro: "Utilice el generador de imágenes AI Stable Diffusion 3.5 de forma gratuita en Miral AI. Regístrese para recibir créditos gratuitos y crear rápidamente imágenes de alta calidad con indicaciones detalladas, indicaciones negativas y tamaños flexibles.",
                eyebrow: "Estabilidad AI · Difusión estable 3.5",
                sectionKicker: "Difusión estable 3.5",
                ctaTag: "Difusión Estable 3.5 · Miral",
                badges: ["Texto a imagen", "Aviso negativo", "Relaciones de aspecto flexibles", "Tamaño personalizado"],
                previewLabel: "Difusión estable 3.5",
                previewMeta: ["1:1", "512 – 2048", "Múltiplos de 64"],
                previewTitle: "Desde un mensaje detallado hasta una imagen pulida y controlada",
                previewDesc: "Combine indicaciones positivas con indicaciones negativas y elija la relación de aspecto correcta para dirigir Stable Diffusion 3.5 hacia imágenes limpias y precisas.",
                keyFeaturesTitle: "Cree imágenes controladas con el generador de texto a imagen de Stable Diffusion 3.5",
                keyFeaturesIntro: "Explore las funciones clave del generador de imágenes de IA de Stable Diffusion 3.5 para obtener indicaciones negativas, relaciones de aspecto flexibles, tamaños personalizados y comprensión detallada de las indicaciones.",
                exploreTitle: "Explore más modelos de imágenes de IA",
                mainFeaturesTitle: "Características clave de Difusión estable 3.5",
                generatedImageLabel: "Imagen generada",
                versionLabel: "controlar",
                featureLabel: "Lo que cambia",
                useCaseLabel: "Mejor para",
                variantsTitle: "Controles de salida de difusión estable 3.5",
                variantsIntro: "Combine el modelo Stable Diffusion 3.5 con relaciones de aspecto preestablecidas o dimensiones personalizadas exactas según el diseño final que necesita.",
                variants: [
                    { name: "Difusión estable 3.5", desc: "Generación detallada de texto a imagen con control de avisos positivos y negativos.", bestFor: "Imágenes de productos, retratos, arte conceptual e imágenes de marketing." },
                    { name: "Relaciones de aspecto preestablecidas", desc: "Dimensiones de salida horizontal, vertical y cuadrada ya preparadas.", bestFor: "Publicaciones sociales, pancartas, carteles y miniaturas." },
                    { name: "Tamaño de imagen personalizado", desc: "Ancho y alto exactos de 512 a 2048 en múltiplos de 64.", bestFor: "Diseñe espacios y proyectos que requieran dimensiones de píxeles precisas." }
                ],
                controlsTitle: "Elija los controles rápidos y el tamaño de imagen adecuados",
                controlsIntro: "Utilice un mensaje negativo para reducir los detalles no deseados, luego seleccione una proporción preestablecida o ingrese dimensiones personalizadas para el canal deseado.",
                galleryTitle: "Ejemplos de imágenes de difusión más estable 3.5",
                discussionTitle: "Preguntas comunes sobre difusión estable 3.5",
                communityTitle: "Formas populares de crear con Stable Diffusion 3.5",
                tutorialPrompt: "Fotografía editorial de un producto de un altavoz escultural de cerámica sobre piedra pálida, suave luz de la ventana de la mañana, textura realista, composición equilibrada, sombras sutiles, fondo limpio.",
                qualityBenefits: [
                    "Utilice indicaciones negativas para reducir el desorden, los detalles mal formados y los estilos visuales no deseados.",
                    "Siga descripciones en capas del tema, la composición, la iluminación, los materiales y el estado de ánimo.",
                    "Cree imágenes horizontales, verticales y cuadradas con ajustes preestablecidos o dimensiones personalizadas precisas."
                ],
                features: [
                    { name: "Control rápido negativo", short: "Describa qué excluir para obtener resultados más limpios y acertados.", desc: "El generador de imágenes de IA de Stable Diffusion 3.5 admite un mensaje negativo dedicado, para que pueda indicarle al modelo qué debe evitar, como poca claridad, manos deformadas o un fondo desordenado. Esto le brinda un control más preciso sobre la imagen final y reduce la necesidad de volver a rodar repetidamente.", demo: { type: 'table', rows: [
                        { prompt: "Una fotografía de producto premium de un jarrón de cerámica negro mate sobre un pedestal de mármol, una luz de estudio suave y un fondo limpio. (Negativo: fondo desordenado, baja resolución, reflejos deformados).", image: require('@/assets/images/stableDiffusion/1783501013638.webp') },
                        { prompt: "Un retrato de un joven con una suave luz de ventana, textura natural de la piel y poca profundidad de campo. (Negativo: piel demasiado alisada, aspecto ceroso, colores sobresaturados).", image: require('@/assets/images/stableDiffusion/1783501332038.webp') }
                    ] } },
                    { name: "Relaciones de aspecto flexibles", short: "Elija paisaje, retrato, cuadrado o un tamaño personalizado.", desc: "Elija entre relaciones de aspecto ya preparadas, como 1024 × 1024, 1280 × 1280, 896 × 1536, 1536 × 896, 768 × 1344, 1344 × 768, 1024 × 1536 y 1536 × 1536, o ingrese un tamaño personalizado de 512 × 512 a 2048×2048. Esto hace que el generador de texto a imagen de Stable Diffusion 3.5 sea adecuado tanto para pancartas, carteles, publicaciones en redes sociales como para miniaturas cuadradas.", prompt: "Una toma cinematográfica de un paisaje amplio de un acantilado costero en la hora dorada, nubes dramáticas, finos detalles de rocas, 1536×896.", image: require('@/assets/images/stableDiffusion/1783501396803.webp') },
                    { name: "Tamaños de imagen personalizados", short: "Establezca dimensiones exactas en píxeles para obtener resultados precisos.", desc: "Cuando un ajuste preestablecido no se ajuste, cambie a un tamaño personalizado e ingrese cualquier ancho y alto desde 512 hasta 2048 en múltiplos de 64. Esto le permite hacer coincidir un diseño, una ranura para pancarta o un aspecto de impresión específicos sin recortar manualmente.", prompt: "Un fondo de póster minimalista con una composición geométrica centrada, degradado azul profundo, vetas sutiles, 1280×1280.", image: require('@/assets/images/stableDiffusion/0217835023294345bd2f0b9e6315ce45b86fb4e22ec7496156d5f_0.webp') },
                    { name: "Comprensión rápida detallada", short: "Sigue descripciones en capas de tema, luz y estilo.", desc: "Stable Diffusion 3.5 lee instrucciones de texto en capas y representa el tema, el entorno, la iluminación y el estado de ánimo que usted describe. Combine un mensaje positivo claro con un mensaje negativo para acercar el resultado a su intención en menos intentos.", demo: { type: 'table', rows: [
                        { prompt: "Foto editorial de un reloj de pulsera junto a lino doblado y una taza de cerámica, composición triangular equilibrada, suave luz de la mañana.", image: require('@/assets/images/stableDiffusion/1783501741652.webp') },
                        { prompt: "Un acogedor rincón de lectura junto a una ventana lluviosa, una cálida luz de lámpara, libros apilados, una manta texturizada y un ambiente cinematográfico.", image: require('@/assets/images/stableDiffusion/1783501817217.webp') }
                    ] } },
                    { name: "Detalle refinado y realismo", short: "Proporcione iluminación, materiales y profundidad creíbles.", desc: "Stable Diffusion 3.5 produce texturas finas, iluminación realista y profundidad natural, lo que hace que el generador de imágenes de IA Stable Diffusion 3.5 sea una opción sólida para fotografía de productos, retratos, arte conceptual y visuales editoriales donde la credibilidad importa.", prompt: "Retrato editorial de primer plano de un ceramista anciano en un taller iluminado por el sol, textura natural de la piel, polvo de arcilla en las manos, luz cálida de la ventana, poca profundidad de campo.", image: require('@/assets/images/stableDiffusion/021783502374347ebd7c24e3cae4a4b683f52566c3e30e2cb26b5_0.webp') }
                ],
                showcaseKicker: "Ejemplos rápidos",
                showcaseTitle: "Ejemplos de mensajes de Stable Diffusion 3.5 para obtener mejores imágenes de IA",
                showcaseIntro: "Utilice estos ejemplos de indicaciones de Stable Diffusion 3.5 como punto de partida. Describe claramente el tema, la composición, la iluminación y el estilo, combina cada mensaje con un mensaje negativo y luego envíalo directamente al generador.",
                useCasesKicker: "Hecho para el trabajo real",
                useCasesTitle: "Casos de uso populares de difusión estable 3.5",
                useCases: [
                    { name: "Difusión estable 3.5 para fotografía de productos", desc: "Cree fotografías limpias de productos con fondos controlados utilizando indicaciones negativas para eliminar el desorden." },
                    { name: "Difusión estable 3.5 para marketing", desc: "Genere conceptos de campaña, anuncios sociales y pancartas en múltiples proporciones." },
                    { name: "Difusión estable 3.5 para carteles y diseños", desc: "Produzca fondos de carteles y elementos visuales listos para diseñar en dimensiones de píxeles personalizadas." },
                    { name: "Difusión estable 3.5 para retratos", desc: "Genere retratos detallados con textura de piel natural, utilizando indicaciones negativas para evitar artefactos." },
                    { name: "Difusión estable 3.5 para arte conceptual", desc: "Explora personajes, entornos e instrucciones visuales con indicaciones en capas." },
                    { name: "Difusión estable 3.5 para contenido social", desc: "Cree imágenes cuadradas, verticales y horizontales con tamaños para diferentes plataformas sociales." }
                ],
                howToKicker: "Tres sencillos pasos",
                howToTitle: "Cómo utilizar el generador de imágenes AI Stable Diffusion 3.5 en línea",
                howToIntro: "Utilice el generador de imágenes de IA Stable Diffusion 3.5 en línea en Miral con un mensaje claro, un mensaje negativo y la relación de aspecto que su proyecto necesita.",
                howToSteps: [
                    { title: "Ingrese su mensaje principal", desc: "Describe el tema, la escena, la composición, la iluminación, el estilo y los detalles visuales deseados." },
                    { title: "Configurar controles de generación", desc: "Agregue un mensaje negativo si es necesario, luego elija una relación de aspecto ya preparada o ingrese un tamaño personalizado." },
                    { title: "Generar y revisar", desc: "Inicie la generación, revise el resultado y descargue la imagen o ajuste su mensaje para otra pasada." }
                ],
                howToCta: "Pruebe el generador de imágenes AI Stable Diffusion 3.5",
                faqTitle: "Preguntas frecuentes sobre la difusión estable 3.5",
                faqs: [
                    { q: "¿Qué es el generador de imágenes AI Stable Diffusion 3.5?", a: "Stable Diffusion 3.5 es un modelo de conversión de texto a imagen de Stability AI. El generador de imágenes de IA de Stable Diffusion 3.5 convierte las indicaciones escritas en imágenes detalladas y está disponible en Miral para arte, diseño, marketing y creación visual de productos directamente en su navegador." },
                    { q: "¿Qué herramienta puedo utilizar para crear imágenes de tamaño personalizado con mensajes negativos?", a: "Stable Diffusion 3.5 ofrece un mensaje negativo dedicado, relaciones de aspecto listas para usar y tamaños personalizados de 512 a 2048 para fotografía de productos, imágenes de marketing, retratos y arte conceptual." },
                    { q: "¿Puedo utilizar el generador de imágenes AI Stable Diffusion 3.5 de forma gratuita?", a: "Sí. Regístrese para recibir créditos gratuitos y comience a crear imágenes de alta calidad con el generador de imágenes AI Stable Diffusion 3.5 de inmediato. La generación de imágenes utiliza los créditos correspondientes." },
                    { q: "¿Cómo uso el generador de imágenes AI Stable Diffusion 3.5 en línea?", a: "Ingrese un mensaje de texto detallado, opcionalmente agregue un mensaje negativo que describa qué evitar, elija una relación de aspecto ya preparada o ingrese un tamaño personalizado y haga clic en Generar. Stable Diffusion 3.5 funciona bien para materiales de marketing, fotografías de productos, retratos y diseños de carteles." },
                    { q: "¿Cómo corregir detalles no deseados o deformados en imágenes de Stable Diffusion 3.5?", a: "Agregue un mensaje negativo que describa los elementos que no desea, como poca claridad, manos deformes o un fondo desordenado. Stable Diffusion 3.5 lo utiliza para desviar la generación de esos resultados." },
                    { q: "¿Qué tamaños y relaciones de aspecto admite Stable Diffusion 3.5?", a: "En Miral, Stable Diffusion 3.5 ofrece proporciones listas para usar, como 1024 × 1024, 1280 × 1280, 896 × 1536, 1536 × 896, 768 × 1344, 1344 × 768, 1024 × 1536 y 1536 × 1536, además de un tamaño personalizado de 512×512 hasta 2048×2048 en múltiplos de 64. Esto cubre salidas horizontales, verticales y cuadradas para pancartas, carteles, publicaciones en redes sociales y miniaturas." },
                    { q: "¿Cuáles son los mejores ejemplos de indicaciones de Stable Diffusion 3.5?", a: "Las indicaciones efectivas de Difusión Estable 3.5 describen claramente el tema, el entorno, la composición, la iluminación y el estilo, luego combina una indicación positiva con una indicación negativa para eliminar detalles no deseados. Utilice los ejemplos de indicaciones de Stable Diffusion 3.5 en esta página como punto de partida y personalícelos para su proyecto." },
                    { q: "Stable Diffusion 3.5 vs Midjourney: ¿cuál debo usar?", a: "Elija según el flujo de trabajo en lugar de un ganador universal. Stable Diffusion 3.5 es una excelente opción cuando necesita mensajes negativos explícitos, relaciones de aspecto listas para usar y tamaños de píxeles personalizados en un generador basado en navegador en Miral. Midjourney puede ser adecuado para creadores que prefieran su flujo de trabajo artístico distintivo y sus herramientas comunitarias." }
                ],
                ctaTitle: "¡Pruebe Stable Diffusion 3.5 gratis en Miral!",
                ctaDesc: "Ingrese su idea arriba y use el generador de imágenes AI Stable Diffusion 3.5 con indicaciones negativas y tamaños flexibles para crear imágenes controladas."
            },
            zImageTurbo: {
                title: "Generador de imágenes Z Image Turbo AI gratis en línea | miral",
                description: "Cree imágenes de IA de alta calidad en línea con Z Image Turbo. Amplíe las indicaciones, elija relaciones de aspecto flexibles, establezca dimensiones personalizadas y controle las semillas en Miral.",
                heroHeadline: "Generador de imágenes Z Image Turbo AI",
                heroIntro: "Utilice el generador de imágenes Z Image Turbo AI de forma gratuita en Miral AI. Regístrese para recibir créditos gratuitos y crear rápidamente imágenes de alta calidad con extensión rápida, relaciones de aspecto flexibles y control de semillas.",
                eyebrow: "Imagen Z Turbo",
                sectionKicker: "Imagen Z Turbo",
                ctaTag: "Imagen Z Turbo · Miral",
                badges: ["Texto a imagen", "Extensión inmediata", "Relaciones de aspecto flexibles", "Tamaño personalizado", "Control de semillas"],
                previewLabel: "Imagen Z Turbo",
                previewMeta: ["1:1", "512 – 2048", "Control de semillas"],
                previewTitle: "Desde un mensaje breve hasta una imagen pulida y de alta resolución",
                previewDesc: "Deje que la extensión rápida enriquezca una idea breve, elija la relación de aspecto correcta y reutilice una semilla para mantener un estilo consistente en todas las imágenes.",
                keyFeaturesTitle: "Cree imágenes pulidas con el generador de texto a imagen Z Image Turbo",
                keyFeaturesIntro: "Explore las funciones clave del generador de imágenes Z Image Turbo AI para obtener una extensión rápida, relaciones de aspecto flexibles, tamaños personalizados y consistencia basada en semillas.",
                exploreTitle: "Explore más modelos de imágenes de IA",
                mainFeaturesTitle: "Funciones clave de Z Image Turbo",
                generatedImageLabel: "Imagen generada",
                versionLabel: "controlar",
                featureLabel: "Lo que cambia",
                useCaseLabel: "Mejor para",
                variantsTitle: "Controles de creación de imágenes Z Turbo",
                variantsIntro: "Combine extensión rápida, dimensiones flexibles y control de semillas según el nivel de detalle y coherencia visual que necesite su proyecto.",
                variants: [
                    { name: "Imagen Z Turbo", desc: "Generación rápida de texto a imagen con salida detallada de alta resolución.", bestFor: "Imágenes de productos, retratos, arte conceptual e imágenes de marketing." },
                    { name: "Extensión inmediata", desc: "Enriquece automáticamente las indicaciones breves con detalles visuales adicionales.", bestFor: "Convertir ideas rápidas en instrucciones de generación más completas." },
                    { name: "Control de semillas", desc: "Reutiliza la misma semilla inicial mientras perfecciona otras configuraciones.", bestFor: "Mantener un estilo coordinado en todas las variaciones de imágenes o campañas." }
                ],
                controlsTitle: "Elija la configuración de indicación, tamaño y semilla adecuadas",
                controlsIntro: "Habilite la extensión rápida cuando una idea necesite más detalles, elija las dimensiones de salida deseadas y reutilice una semilla cuando la coherencia visual sea importante.",
                galleryTitle: "Más ejemplos de imágenes turbo de imagen Z",
                discussionTitle: "Preguntas comunes sobre Z Image Turbo",
                communityTitle: "Formas populares de crear con Z Image Turbo",
                tutorialPrompt: "Un scooter eléctrico compacto expuesto en un luminoso estudio de arquitectura, suelo de hormigón pálido, claraboya suave, fotografía de producto refinada, composición equilibrada y materiales realistas.",
                qualityBenefits: [
                    "Amplíe las ideas breves en sugerencias más ricas sin tener que reescribir manualmente cada detalle visual.",
                    "Elija dimensiones horizontales, verticales, cuadradas o personalizadas precisas para el canal final.",
                    "Reutilice una semilla para mantener la iluminación, la paleta y la composición más consistentes en todas las iteraciones."
                ],
                features: [
                    { name: "Extensión inmediata", short: "Opcionalmente, amplíe un breve mensaje con más detalles.", desc: "Active la extensión de aviso y Z Image Turbo enriquecerá automáticamente un aviso breve con detalles adicionales antes de su generación. Esto ayuda a que las indicaciones breves o simples produzcan imágenes más completas y vívidas sin necesidad de reescritura manual.", demo: { type: 'table', rows: [
                        { prompt: "Un invernadero de cristal lleno de plantas tropicales en la superficie de Marte.", image: require('@/assets/images/zImageTurbo/b1057f7b-3e0e-9687-aa55-56cfed42147a0.webp') },
                        { prompt: "Una pequeña panadería artesanal construida dentro de un vagón de tren antiguo.", image: require('@/assets/images/zImageTurbo/a8dbab92-cfb4-928b-bd20-4f01835aa0ac0.webp') }
                    ] } },
                    { name: "Relaciones de aspecto flexibles", short: "Elija paisaje, retrato, cuadrado o un tamaño personalizado.", desc: "Elija entre relaciones de aspecto ya preparadas, como 1024 × 1024, 1280 × 1280, 864 × 1536, 1536 × 864, 720 × 1280, 1280 × 720, 1024 × 1536 y 1536 × 1536, o ingrese un tamaño personalizado de 512 × 512 a 2048×2048. Esto hace que el generador de texto a imagen Z Image Turbo sea adecuado tanto para pancartas, carteles, publicaciones en redes sociales como para miniaturas cuadradas.", prompt: "Una vista aérea ultra amplia de un mercado nocturno de Tokio bajo la lluvia, linternas de papel brillantes, puestos de comida abarrotados, calles reflectantes, atmósfera cinematográfica, 1536×864.", image: require('@/assets/images/zImageTurbo/b2964bd5-066f-90b6-8c86-91dad79e44120.webp') },
                    { name: "Tamaños de imagen personalizados", short: "Establezca dimensiones exactas en píxeles para obtener resultados precisos.", desc: "Cuando un ajuste preestablecido no se ajuste, cambie a un tamaño personalizado e ingrese cualquier ancho y alto desde 512 hasta 2048. Esto le permite hacer coincidir un diseño, una ranura para pancarta o un aspecto de impresión específicos sin recortar manualmente.", prompt: "Un póster vertical de exposición botánica, tipografía naranja de gran tamaño, raras hojas tropicales, textura cálida de papel blanquecino, cuadrícula editorial precisa, 1152×1728.", image: require('@/assets/images/zImageTurbo/2d5a0c7e-3ef6-9433-be0d-606be80f99e80.webp') },
                    { name: "Control de semillas para lograr consistencia", short: "Reutilice una semilla para mantener un estilo estable en todas las imágenes.", desc: "Establezca una semilla fija (0 a 2147483647) y el generador de imágenes Z Image Turbo AI se apoyará en el mismo punto de partida en todas las ejecuciones, lo que facilitará mantener una apariencia consistente mientras refina el mensaje. Deje la semilla en 0 para obtener un resultado nuevo y aleatorio cada vez.", prompt: "Una campaña coordinada para el cuidado de la piel que presenta tres botellas de vidrio esmerilado sobre piedra verde pálida, luz suave y difusa y detalles en eucalipto: reutilice la misma semilla para preservar la iluminación, la paleta y la composición en toda la serie de productos.", image: require('@/assets/images/zImageTurbo/f688ab6d-a723-969d-8df1-fbac721e66350.webp') },
                    { name: "Detalle refinado y realismo", short: "Proporcione iluminación, materiales y profundidad creíbles.", desc: "Z Image Turbo produce texturas finas, iluminación realista y profundidad natural, lo que lo convierte en una opción sólida para fotografía de productos, retratos, arte conceptual y visuales editoriales donde la credibilidad importa.", prompt: "Primer plano documental de un fabricante de violines tallando un puente de arce en un taller tranquilo, finas virutas de madera, herramientas manuales desgastadas, textura natural de la piel, luz suave de la ventana norte, poca profundidad de campo.", image: require('@/assets/images/zImageTurbo/715e19f5-fea4-9361-a1e3-0f04d595db660.webp') }
                ],
                showcaseKicker: "Ejemplos rápidos",
                showcaseTitle: "Ejemplos de indicaciones de Z Image Turbo para obtener mejores imágenes de IA",
                showcaseIntro: "Utilice estos ejemplos de indicaciones de Z Image Turbo como punto de partida. Describe claramente el tema, la composición, la iluminación y el estilo, habilita opcionalmente la extensión de aviso y luego envíalo directamente al generador.",
                useCasesKicker: "Hecho para el trabajo real",
                useCasesTitle: "Casos de uso populares de Z Image Turbo",
                useCases: [
                    { name: "Z Image Turbo para fotografía de productos", desc: "Cree tomas limpias de productos con fondos controlados y una semilla fija para una apariencia consistente." },
                    { name: "Imagen Z Turbo para marketing", desc: "Genere conceptos de campaña, anuncios sociales y pancartas en múltiples proporciones." },
                    { name: "Z Image Turbo para carteles y diseños", desc: "Produzca fondos de carteles y elementos visuales listos para diseñar en dimensiones de píxeles personalizadas." },
                    { name: "Z Image Turbo para retratos", desc: "Genere retratos detallados con textura de piel natural e iluminación creíble." },
                    { name: "Z Image Turbo para arte conceptual", desc: "Explora personajes, entornos e instrucciones visuales con indicaciones en capas." },
                    { name: "Z Image Turbo para contenido social", desc: "Cree imágenes cuadradas, verticales y horizontales con tamaños para diferentes plataformas sociales." }
                ],
                howToKicker: "Tres sencillos pasos",
                howToTitle: "Cómo utilizar el generador de imágenes Z Image Turbo AI en línea",
                howToIntro: "Utilice el generador de imágenes Z Image Turbo AI en línea en Miral con un mensaje claro, una extensión de mensaje opcional y la relación de aspecto que su proyecto necesita.",
                howToSteps: [
                    { title: "Ingrese su mensaje principal", desc: "Describe el tema, la escena, la composición, la iluminación, el estilo y los detalles visuales deseados." },
                    { title: "Configurar controles de generación", desc: "Opcionalmente, habilite la extensión de solicitud, elija una relación de aspecto ya preparada o ingrese un tamaño personalizado y establezca una semilla si desea coherencia." },
                    { title: "Generar y revisar", desc: "Inicie la generación, revise el resultado y descargue la imagen o ajuste su mensaje para otra pasada." }
                ],
                howToCta: "Pruebe el generador de imágenes Z Image Turbo AI",
                faqTitle: "Preguntas frecuentes sobre Z Image Turbo",
                faqs: [
                    { q: "¿Qué es el generador de imágenes Z Image Turbo AI?", a: "Z Image Turbo es un modelo de texto a imagen para la generación de imágenes de alta resolución. El generador de imágenes Z Image Turbo AI convierte las indicaciones escritas en imágenes detalladas y está disponible en Miral para arte, diseño, marketing y creación visual de productos directamente en su navegador." },
                    { q: "¿Qué herramienta puedo utilizar para crear una serie coherente de imágenes de productos?", a: "Z Image Turbo combina extensión rápida, tamaños de imagen flexibles y control de semillas para ayudar a crear una serie consistente de fotografías de productos o imágenes de marketing." },
                    { q: "¿Puedo utilizar el generador de imágenes Z Image Turbo AI de forma gratuita?", a: "Sí. Regístrese para recibir créditos gratuitos y comience a crear imágenes de alta calidad con el generador de imágenes Z Image Turbo AI de inmediato. La generación de imágenes utiliza los créditos correspondientes." },
                    { q: "¿Cómo uso el generador de imágenes Z Image Turbo AI en línea?", a: "Ingrese un mensaje de texto detallado, opcionalmente active la extensión del mensaje, elija una relación de aspecto ya preparada o ingrese un tamaño personalizado, establezca una semilla si desea una apariencia consistente y haga clic en Generar. Z Image Turbo funciona bien para materiales de marketing, fotografías de productos, retratos y diseños de carteles." },
                    { q: "¿Qué es la extensión rápida en Z Image Turbo?", a: "La extensión de aviso es un interruptor opcional que permite a Z Image Turbo enriquecer automáticamente un aviso breve o simple con detalles adicionales antes de su generación. Esto ayuda a los no expertos a producir imágenes más completas y vívidas sin necesidad de reescritura manual." },
                    { q: "¿Cómo corregir resultados inconsistentes en Z Image Turbo?", a: "Reutilice la misma semilla mientras perfecciona otros parámetros para ayudar a mantener un estilo consistente en todas las imágenes. Deje la semilla en 0 solo cuando desee un resultado nuevo y aleatorio cada vez." },
                    { q: "¿Qué tamaños y relaciones de aspecto admite Z Image Turbo?", a: "En Miral, Z Image Turbo ofrece proporciones listas para usar, como 1024×1024, 1280×1280, 864×1536, 1536×864, 720×1280, 1280×720, 1024×1536 y 1536×1536, además de un tamaño personalizado desde 512×512 hasta 2048×2048. Esto cubre resultados horizontales, verticales y cuadrados para pancartas, carteles, publicaciones en redes sociales y miniaturas." },
                    { q: "¿Cuáles son los mejores ejemplos de indicaciones de Z Image Turbo?", a: "Las indicaciones efectivas de Z Image Turbo describen claramente el tema, el entorno, la composición, la iluminación y el estilo. Para ideas breves, habilite la extensión de solicitud para que el modelo pueda enriquecer la solicitud automáticamente. Utilice los ejemplos de indicaciones de Z Image Turbo en esta página como punto de partida y personalícelos para su proyecto." }
                ],
                ctaTitle: "¡Pruebe Z Image Turbo gratis en Miral!",
                ctaDesc: "Ingrese su idea arriba y use el generador de imágenes Z Image Turbo AI con extensión rápida, tamaños flexibles y control de semillas para crear imágenes pulidas."
            },
            midjourney: {
                title: "Generador de imágenes AI Midjourney gratis en línea | miral",
                description: "Crea arte con IA en línea con Midjourney en Miral AI. Elija estilos realistas o anime, guíe los resultados con imágenes de referencia y convierta las indicaciones de texto en imágenes vívidas.",
                heroHeadline: "Generador de imágenes de IA a mitad del viaje",
                heroIntro: "Utilice el generador de imágenes Midjourney AI de forma gratuita en Miral AI. Regístrese para recibir créditos gratuitos y crear instantáneamente imágenes de alta calidad con estilos realistas o anime y guía de imágenes de referencia opcional.",
                eyebrow: "A mitad del viaje",
                sectionKicker: "A mitad del viaje",
                ctaTag: "Mitad del viaje · Miral",
                badges: ["Texto a imagen", "Estilos realistas y anime", "Guía de imagen de referencia", "Dirección Artística"],
                previewLabel: "A mitad del viaje",
                previewMeta: ["Realista", "animado", "Hasta 5 Referencias"],
                previewTitle: "De un mensaje vívido a una imagen cinematográfica dirigida por el arte",
                previewDesc: "Elige un estilo, describe el ambiente y la iluminación y deja que Midjourney dé forma al aspecto artístico de tu concepto, póster o personaje.",
                keyFeaturesTitle: "Cree imágenes dirigidas por el arte con el generador de texto a imagen de Midjourney",
                keyFeaturesIntro: "Explore las funciones clave del generador de imágenes AI de Midjourney para cambiar de estilo, guiar imágenes de referencia y una rica dirección artística.",
                features: [
                    { name: "Estilos realistas y anime.", short: "Cambia el estilo visual con un toque.", desc: "El generador de imágenes Midjourney AI de Miral expone dos estilos ya preparados: Realista y Anime. Elija Realista para detalles fotográficos, luz natural y texturas realistas, o Anime para líneas estilizadas, colores llamativos y una sensación de dibujado a mano. El estilo se elige en el panel, por lo que su mensaje puede centrarse en la escena misma.", demo: { type: 'table', rows: [
                        { prompt: "Un viajero solitario parado en el borde de una montaña brumosa al amanecer, luz volumétrica, toma panorámica cinematográfica, tela fina y detalles de rocas.", image: require('@/assets/images/midjourney/1783505533006329.webp') },
                        { prompt: "Una joven espadachina decidida en una azotea al anochecer, cabello suelto, linternas brillantes, líneas de anime expresivas y sombreado de celdas vibrante.", image: require('@/assets/images/midjourney/45f1eae9-39b9-4cc9-8a4e-e597aa4d344b.webp') }
                    ] } },
                    { name: "Guía de imagen de referencia", short: "Sube hasta cinco imágenes para dirigir la apariencia.", desc: "Guíe el generador de imágenes AI de Midjourney con hasta cinco imágenes de referencia (PNG, JPG, JPEG o WebP). Úselos para trasladar una paleta de colores, apariencia de personaje, forma de producto o estética general para que el resultado se acerque más a una dirección de referencia que al texto solo.", prompt: "Una fotografía de producto premium de un jarrón de cerámica negro mate sobre un pedestal de mármol, una luz de estudio suave y un fondo limpio que combina con el ambiente y la paleta de las referencias cargadas.", image: require('@/assets/images/midjourney/1783506116812275.webp') },
                    { name: "Iluminación cinematográfica y ambiente", short: "Proporcione luz, atmósfera y profundidad espectaculares.", desc: "Midjourney es conocido por su iluminación y atmósfera artísticas. Describa la hora dorada, el brillo de neón, la niebla, la luz del borde o la luz de las velas, y el modelo se inclina hacia una apariencia cinematográfica que se adapta a carteles, arte clave y conceptos visuales.", demo: { type: 'table', rows: [
                        { prompt: "Un callejón de neón empapado de lluvia por la noche, charcos reflectantes, un suave bokeh de señales distantes, una atmósfera cinematográfica de mal humor, una sola figura con un paraguas.", image: require('@/assets/images/midjourney/1783506281563151.webp') },
                        { prompt: "Un retrato en hora dorada de un músico en una azotea, cálida luz de fondo, destellos en la lente, poca profundidad de campo, grano de película.", image: require('@/assets/images/midjourney/1783506420066100.webp') }
                    ] } },
                    { name: "Arte de personajes y concepto", short: "Construye personajes y mundos expresivos.", desc: "El generador de texto a imagen de Midjourney es ideal para el diseño de personajes, escenas de fantasía y arte conceptual. Describe la pose, el atuendo, la expresión y el entorno de un personaje, elige un estilo y repite hasta que aterrice el aspecto.", prompt: "Un alquimista errante con una capa de viaje en capas, que lleva una linterna de latón y viales brillantes, un antiguo sendero en el bosque, luz moteada y detalles intrincados de vestuario.", image: require('@/assets/images/midjourney/1783506547640511.webp') },
                    { name: "Carteles y arte editorial", short: "Produzca diseños llamativos y elementos visuales clave.", desc: "Desde arte clave de campaña hasta ilustraciones editoriales, Midjourney da forma a composiciones audaces y una estética refinada. Combine un tema focal claro con un estado de ánimo descrito y deje que el modelo proporcione imágenes artísticas para uso editorial y de marketing.", prompt: "Una imagen clave de campaña audaz de un colibrí flotando sobre una flor tropical brillante, tonos joya saturados, espacio negativo limpio e iluminación de estudio de alto contraste.", image: require('@/assets/images/midjourney/55889f96-30d2-4032-9340-2d27090394e6.webp') }
                ],
                showcaseKicker: "Ejemplos rápidos",
                showcaseTitle: "Ejemplos de indicaciones a mitad de camino para obtener mejores imágenes de IA",
                showcaseIntro: "Utilice estos ejemplos de indicaciones de Midjourney como punto de partida. Describe el tema, el estado de ánimo, la iluminación y el estilo de la escena, luego elige Realista o Anime en el panel y envíalo al generador.",
                useCasesKicker: "Hecho para el trabajo real",
                useCasesTitle: "Casos de uso populares a mitad de viaje",
                useCases: [
                    { name: "Mitad del viaje hacia el arte conceptual", desc: "Construye personajes, mundos de fantasía y direcciones visuales con iluminación y ambiente artísticos." },
                    { name: "Mitad del viaje para obras de arte y carteles clave", desc: "Cree audaces imágenes clave de campaña, carteles e ilustraciones editoriales con una apariencia elegante." },
                    { name: "Mitad del viaje para imágenes de productos y marcas", desc: "Dé forma a conceptos de productos premium e imágenes de marca, guiados por imágenes de referencia para lograr coherencia." },
                    { name: "Mitad del viaje para retratos", desc: "Genere retratos cinematográficos con luz natural, grano de película o sombreado anime estilizado." },
                    { name: "Mitad del viaje por el anime y la ilustración", desc: "Cambie al estilo Anime para obtener líneas expresivas, colores llamativos y personajes dibujados a mano." },
                    { name: "Mitad del camino hacia el contenido social", desc: "Produzca imágenes llamativas y compartibles para feeds, miniaturas y publicaciones sociales creativas." }
                ],
                howToKicker: "Tres sencillos pasos",
                howToTitle: "Cómo utilizar el generador de imágenes AI Midjourney en línea",
                howToIntro: "Utilice el generador de imágenes de IA Midjourney en línea en Miral con un mensaje vívido, un estilo elegido e imágenes de referencia opcionales.",
                howToSteps: [
                    { title: "Describe tu escena", desc: "Escriba un mensaje vívido que cubra el tema, el entorno, el estado de ánimo, la iluminación y el aspecto artístico que desea." },
                    { title: "Elija estilo y referencias", desc: "Elija Realista o Anime en el panel y, opcionalmente, cargue hasta cinco imágenes de referencia para guiar la apariencia." },
                    { title: "Generar y refinar", desc: "Inicie la generación, revise el resultado y descargue la imagen o ajuste su mensaje y referencias para otra pasada." }
                ],
                howToCta: "Pruebe el generador de imágenes AI Midjourney",
                faqTitle: "Preguntas frecuentes sobre la mitad del viaje",
                faqs: [
                    { q: "¿Qué es el generador de imágenes AI de Midjourney?", a: "Midjourney es un modelo de conversión de texto a imagen ampliamente utilizado conocido por sus imágenes cinematográficas dirigidas artísticamente. En Miral, el generador de imágenes con IA de Midjourney convierte indicaciones escritas en imágenes sorprendentes para arte conceptual, elementos visuales clave, carteles y trabajos editoriales directamente en su navegador." },
                    { q: "¿Qué herramienta puedo utilizar para crear arte conceptual cinematográfico con imágenes de referencia?", a: "Midjourney combina una rica dirección artística, iluminación espectacular, estilos realista y anime, y guía de imágenes de referencia para arte conceptual cinematográfico, elementos visuales clave e imágenes de marca." },
                    { q: "¿Puedo utilizar el generador de imágenes AI de Midjourney de forma gratuita?", a: "Sí. Regístrese para recibir créditos gratuitos y comience a crear imágenes de alta calidad con el generador de imágenes Midjourney AI de inmediato. La generación de imágenes utiliza los créditos correspondientes." },
                    { q: "¿Cómo uso el generador de imágenes AI de Midjourney en línea?", a: "Ingrese un mensaje de texto vívido que describa el tema, el estado de ánimo, la iluminación y el estilo, elija Realista o Anime en el panel, opcionalmente cargue hasta cinco imágenes de referencia y haga clic en Generar. Midjourney funciona bien para arte conceptual, imágenes clave, carteles, retratos e ilustraciones editoriales." },
                    { q: "¿Cuál es la diferencia entre los estilos Realista y Anime?", a: "Realista se inclina hacia los detalles fotográficos, la luz natural y las texturas realistas, mientras que el anime prefiere líneas estilizadas, colores llamativos y una apariencia dibujada a mano. Usted elige el estilo en el panel, para que su mensaje pueda centrarse en la escena misma." },
                    { q: "¿Cómo arreglar las imágenes de Midjourney que no coinciden con mi referencia?", a: "Cargue hasta cinco imágenes de referencia claras (PNG, JPG, JPEG o WebP) y describa qué paleta de colores, apariencia de personaje, forma del producto o estética general debe seguir el resultado." },
                    { q: "¿Cuáles son los mejores ejemplos de indicaciones de Midjourney?", a: "Las indicaciones efectivas de Midjourney describen en detalle el tema, el entorno, el estado de ánimo, la iluminación y el aspecto artístico, y luego combinan esas indicaciones con el estilo correcto en el panel. Utilice los ejemplos de indicaciones de Midjourney en esta página como punto de partida y ajústelos para su proyecto." },
                    { q: "Midjourney vs Stable Diffusion 3.5: ¿cuál debo usar?", a: "Elija según el flujo de trabajo en lugar de un ganador universal. Midjourney encaja perfectamente con conceptos dirigidos por el arte, iluminación cinematográfica y elementos visuales guiados por referencias con estilos realistas y anime ya preparados en Miral. Stable Diffusion 3.5 puede ser adecuado para creadores que necesitan mensajes negativos explícitos y relaciones de aspecto flexibles con tamaños personalizados." }
                ],
                ctaTitle: "¡Prueba Midjourney gratis en Miral!",
                ctaDesc: "Ingrese su idea arriba y use el generador de imágenes AI de Midjourney con estilos realistas o anime y guía de imágenes de referencia para crear imágenes artísticas."
            }
        }
  }
}
